import * as U from "react";
import j, { useState as M, useEffect as ne, useCallback as V, memo as Ie, useMemo as F, useContext as bt, useRef as ae, createContext as Li } from "react";
import "regenerator-runtime";
import { HttpClient as Di } from "@reolink/web.fe.http-client";
import { getGlobal as ge, loadScript as Mi, lazyload as Fi } from "@reolink/web.fe.utils";
import * as ft from "@reolink-web/utils";
import { ReoBalloon as Lt, EPlacement as Dt, ReoIcon as st, ReoSelect as hn, ReoCounter as ii, ReoInput as Bi, ReoCheckbox as ri, ReoButton as xn } from "@reolink/web.basic-component";
import { ReoLink as gn, ReoIcon as ot, ReoBalloon as ln, EPlacement as un, ReoPopup as Nt, ReoButton as qt, ReoCounter as Vi, ReoSpin as $i, ReoInput as pt } from "@reolink-web/ui";
import { ReoTabs as Ki, ReoButton as Qe, ReoIcon as yn, ReoPopup as Rn, ReoCheckbox as Ui } from "@reolink-web/components.basic";
import zi from "react-dom/client";
import ji from "youtube-player";
var oi = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Wi(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Mt = {}, Hi = {
  get exports() {
    return Mt;
  },
  set exports(e) {
    Mt = e;
  }
}, Kt = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
(function() {
  var e = j, t = Symbol.for("react.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), c = Symbol.for("react.context"), u = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), v = Symbol.for("react.suspense_list"), y = Symbol.for("react.memo"), T = Symbol.for("react.lazy"), f = Symbol.for("react.offscreen"), w = Symbol.iterator, P = "@@iterator";
  function p(g) {
    if (g === null || typeof g != "object")
      return null;
    var D = w && g[w] || g[P];
    return typeof D == "function" ? D : null;
  }
  var h = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
  function b(g) {
    {
      for (var D = arguments.length, H = new Array(D > 1 ? D - 1 : 0), le = 1; le < D; le++)
        H[le - 1] = arguments[le];
      k("error", g, H);
    }
  }
  function k(g, D, H) {
    {
      var le = h.ReactDebugCurrentFrame, Se = le.getStackAddendum();
      Se !== "" && (D += "%s", H = H.concat([Se]));
      var Ae = H.map(function(Pe) {
        return String(Pe);
      });
      Ae.unshift("Warning: " + D), Function.prototype.apply.call(console[g], console, Ae);
    }
  }
  var C = !1, l = !1, _ = !1, d = !1, x = !1, N;
  N = Symbol.for("react.module.reference");
  function I(g) {
    return !!(typeof g == "string" || typeof g == "function" || g === r || g === a || x || g === i || g === m || g === v || d || g === f || C || l || _ || typeof g == "object" && g !== null && (g.$$typeof === T || g.$$typeof === y || g.$$typeof === s || g.$$typeof === c || g.$$typeof === u || // This needs to include all possible module reference object
    // types supported by any Flight configuration anywhere since
    // we don't know which Flight build this will end up being used
    // with.
    g.$$typeof === N || g.getModuleId !== void 0));
  }
  function B(g, D, H) {
    var le = g.displayName;
    if (le)
      return le;
    var Se = D.displayName || D.name || "";
    return Se !== "" ? H + "(" + Se + ")" : H;
  }
  function ie(g) {
    return g.displayName || "Context";
  }
  function X(g) {
    if (g == null)
      return null;
    if (typeof g.tag == "number" && b("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof g == "function")
      return g.displayName || g.name || null;
    if (typeof g == "string")
      return g;
    switch (g) {
      case r:
        return "Fragment";
      case n:
        return "Portal";
      case a:
        return "Profiler";
      case i:
        return "StrictMode";
      case m:
        return "Suspense";
      case v:
        return "SuspenseList";
    }
    if (typeof g == "object")
      switch (g.$$typeof) {
        case c:
          var D = g;
          return ie(D) + ".Consumer";
        case s:
          var H = g;
          return ie(H._context) + ".Provider";
        case u:
          return B(g, g.render, "ForwardRef");
        case y:
          var le = g.displayName || null;
          return le !== null ? le : X(g.type) || "Memo";
        case T: {
          var Se = g, Ae = Se._payload, Pe = Se._init;
          try {
            return X(Pe(Ae));
          } catch {
            return null;
          }
        }
      }
    return null;
  }
  var se = Object.assign, Q = 0, ve, ye, ue, _e, E, $, ce;
  function Z() {
  }
  Z.__reactDisabledLog = !0;
  function R() {
    {
      if (Q === 0) {
        ve = console.log, ye = console.info, ue = console.warn, _e = console.error, E = console.group, $ = console.groupCollapsed, ce = console.groupEnd;
        var g = {
          configurable: !0,
          enumerable: !0,
          value: Z,
          writable: !0
        };
        Object.defineProperties(console, {
          info: g,
          log: g,
          warn: g,
          error: g,
          group: g,
          groupCollapsed: g,
          groupEnd: g
        });
      }
      Q++;
    }
  }
  function O() {
    {
      if (Q--, Q === 0) {
        var g = {
          configurable: !0,
          enumerable: !0,
          writable: !0
        };
        Object.defineProperties(console, {
          log: se({}, g, {
            value: ve
          }),
          info: se({}, g, {
            value: ye
          }),
          warn: se({}, g, {
            value: ue
          }),
          error: se({}, g, {
            value: _e
          }),
          group: se({}, g, {
            value: E
          }),
          groupCollapsed: se({}, g, {
            value: $
          }),
          groupEnd: se({}, g, {
            value: ce
          })
        });
      }
      Q < 0 && b("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
    }
  }
  var L = h.ReactCurrentDispatcher, z;
  function W(g, D, H) {
    {
      if (z === void 0)
        try {
          throw Error();
        } catch (Se) {
          var le = Se.stack.trim().match(/\n( *(at )?)/);
          z = le && le[1] || "";
        }
      return `
` + z + g;
    }
  }
  var q = !1, Y;
  {
    var re = typeof WeakMap == "function" ? WeakMap : Map;
    Y = new re();
  }
  function K(g, D) {
    if (!g || q)
      return "";
    {
      var H = Y.get(g);
      if (H !== void 0)
        return H;
    }
    var le;
    q = !0;
    var Se = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    var Ae;
    Ae = L.current, L.current = null, R();
    try {
      if (D) {
        var Pe = function() {
          throw Error();
        };
        if (Object.defineProperty(Pe.prototype, "props", {
          set: function() {
            throw Error();
          }
        }), typeof Reflect == "object" && Reflect.construct) {
          try {
            Reflect.construct(Pe, []);
          } catch (lt) {
            le = lt;
          }
          Reflect.construct(g, [], Pe);
        } else {
          try {
            Pe.call();
          } catch (lt) {
            le = lt;
          }
          g.call(Pe.prototype);
        }
      } else {
        try {
          throw Error();
        } catch (lt) {
          le = lt;
        }
        g();
      }
    } catch (lt) {
      if (lt && le && typeof lt.stack == "string") {
        for (var Ce = lt.stack.split(`
`), Xe = le.stack.split(`
`), Ke = Ce.length - 1, ze = Xe.length - 1; Ke >= 1 && ze >= 0 && Ce[Ke] !== Xe[ze]; )
          ze--;
        for (; Ke >= 1 && ze >= 0; Ke--, ze--)
          if (Ce[Ke] !== Xe[ze]) {
            if (Ke !== 1 || ze !== 1)
              do
                if (Ke--, ze--, ze < 0 || Ce[Ke] !== Xe[ze]) {
                  var nt = `
` + Ce[Ke].replace(" at new ", " at ");
                  return g.displayName && nt.includes("<anonymous>") && (nt = nt.replace("<anonymous>", g.displayName)), typeof g == "function" && Y.set(g, nt), nt;
                }
              while (Ke >= 1 && ze >= 0);
            break;
          }
      }
    } finally {
      q = !1, L.current = Ae, O(), Error.prepareStackTrace = Se;
    }
    var kt = g ? g.displayName || g.name : "", pn = kt ? W(kt) : "";
    return typeof g == "function" && Y.set(g, pn), pn;
  }
  function pe(g, D, H) {
    return K(g, !1);
  }
  function oe(g) {
    var D = g.prototype;
    return !!(D && D.isReactComponent);
  }
  function Ue(g, D, H) {
    if (g == null)
      return "";
    if (typeof g == "function")
      return K(g, oe(g));
    if (typeof g == "string")
      return W(g);
    switch (g) {
      case m:
        return W("Suspense");
      case v:
        return W("SuspenseList");
    }
    if (typeof g == "object")
      switch (g.$$typeof) {
        case u:
          return pe(g.render);
        case y:
          return Ue(g.type, D, H);
        case T: {
          var le = g, Se = le._payload, Ae = le._init;
          try {
            return Ue(Ae(Se), D, H);
          } catch {
          }
        }
      }
    return "";
  }
  var Be = Object.prototype.hasOwnProperty, G = {}, de = h.ReactDebugCurrentFrame;
  function fe(g) {
    if (g) {
      var D = g._owner, H = Ue(g.type, g._source, D ? D.type : null);
      de.setExtraStackFrame(H);
    } else
      de.setExtraStackFrame(null);
  }
  function xe(g, D, H, le, Se) {
    {
      var Ae = Function.call.bind(Be);
      for (var Pe in g)
        if (Ae(g, Pe)) {
          var Ce = void 0;
          try {
            if (typeof g[Pe] != "function") {
              var Xe = Error((le || "React class") + ": " + H + " type `" + Pe + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof g[Pe] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
              throw Xe.name = "Invariant Violation", Xe;
            }
            Ce = g[Pe](D, Pe, le, H, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
          } catch (Ke) {
            Ce = Ke;
          }
          Ce && !(Ce instanceof Error) && (fe(Se), b("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", le || "React class", H, Pe, typeof Ce), fe(null)), Ce instanceof Error && !(Ce.message in G) && (G[Ce.message] = !0, fe(Se), b("Failed %s type: %s", H, Ce.message), fe(null));
        }
    }
  }
  var ee = Array.isArray;
  function Te(g) {
    return ee(g);
  }
  function be(g) {
    {
      var D = typeof Symbol == "function" && Symbol.toStringTag, H = D && g[Symbol.toStringTag] || g.constructor.name || "Object";
      return H;
    }
  }
  function De(g) {
    try {
      return Ee(g), !1;
    } catch {
      return !0;
    }
  }
  function Ee(g) {
    return "" + g;
  }
  function Oe(g) {
    if (De(g))
      return b("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", be(g)), Ee(g);
  }
  var Le = h.ReactCurrentOwner, We = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
  }, je, Ve, tt;
  tt = {};
  function Ye(g) {
    if (Be.call(g, "ref")) {
      var D = Object.getOwnPropertyDescriptor(g, "ref").get;
      if (D && D.isReactWarning)
        return !1;
    }
    return g.ref !== void 0;
  }
  function A(g) {
    if (Be.call(g, "key")) {
      var D = Object.getOwnPropertyDescriptor(g, "key").get;
      if (D && D.isReactWarning)
        return !1;
    }
    return g.key !== void 0;
  }
  function J(g, D) {
    if (typeof g.ref == "string" && Le.current && D && Le.current.stateNode !== D) {
      var H = X(Le.current.type);
      tt[H] || (b('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', X(Le.current.type), g.ref), tt[H] = !0);
    }
  }
  function te(g, D) {
    {
      var H = function() {
        je || (je = !0, b("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", D));
      };
      H.isReactWarning = !0, Object.defineProperty(g, "key", {
        get: H,
        configurable: !0
      });
    }
  }
  function we(g, D) {
    {
      var H = function() {
        Ve || (Ve = !0, b("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", D));
      };
      H.isReactWarning = !0, Object.defineProperty(g, "ref", {
        get: H,
        configurable: !0
      });
    }
  }
  var Me = function(g, D, H, le, Se, Ae, Pe) {
    var Ce = {
      // This tag allows us to uniquely identify this as a React Element
      $$typeof: t,
      // Built-in properties that belong on the element
      type: g,
      key: D,
      ref: H,
      props: Pe,
      // Record the component responsible for creating this element.
      _owner: Ae
    };
    return Ce._store = {}, Object.defineProperty(Ce._store, "validated", {
      configurable: !1,
      enumerable: !1,
      writable: !0,
      value: !1
    }), Object.defineProperty(Ce, "_self", {
      configurable: !1,
      enumerable: !1,
      writable: !1,
      value: le
    }), Object.defineProperty(Ce, "_source", {
      configurable: !1,
      enumerable: !1,
      writable: !1,
      value: Se
    }), Object.freeze && (Object.freeze(Ce.props), Object.freeze(Ce)), Ce;
  };
  function Fe(g, D, H, le, Se) {
    {
      var Ae, Pe = {}, Ce = null, Xe = null;
      H !== void 0 && (Oe(H), Ce = "" + H), A(D) && (Oe(D.key), Ce = "" + D.key), Ye(D) && (Xe = D.ref, J(D, Se));
      for (Ae in D)
        Be.call(D, Ae) && !We.hasOwnProperty(Ae) && (Pe[Ae] = D[Ae]);
      if (g && g.defaultProps) {
        var Ke = g.defaultProps;
        for (Ae in Ke)
          Pe[Ae] === void 0 && (Pe[Ae] = Ke[Ae]);
      }
      if (Ce || Xe) {
        var ze = typeof g == "function" ? g.displayName || g.name || "Unknown" : g;
        Ce && te(Pe, ze), Xe && we(Pe, ze);
      }
      return Me(g, Ce, Xe, Se, le, Le.current, Pe);
    }
  }
  var $e = h.ReactCurrentOwner, _t = h.ReactDebugCurrentFrame;
  function Pt(g) {
    if (g) {
      var D = g._owner, H = Ue(g.type, g._source, D ? D.type : null);
      _t.setExtraStackFrame(H);
    } else
      _t.setExtraStackFrame(null);
  }
  var Zt;
  Zt = !1;
  function en(g) {
    return typeof g == "object" && g !== null && g.$$typeof === t;
  }
  function kn() {
    {
      if ($e.current) {
        var g = X($e.current.type);
        if (g)
          return `

Check the render method of \`` + g + "`.";
      }
      return "";
    }
  }
  function Ni(g) {
    {
      if (g !== void 0) {
        var D = g.fileName.replace(/^.*[\\\/]/, ""), H = g.lineNumber;
        return `

Check your code at ` + D + ":" + H + ".";
      }
      return "";
    }
  }
  var Tn = {};
  function Ii(g) {
    {
      var D = kn();
      if (!D) {
        var H = typeof g == "string" ? g : g.displayName || g.name;
        H && (D = `

Check the top-level render call using <` + H + ">.");
      }
      return D;
    }
  }
  function Sn(g, D) {
    {
      if (!g._store || g._store.validated || g.key != null)
        return;
      g._store.validated = !0;
      var H = Ii(D);
      if (Tn[H])
        return;
      Tn[H] = !0;
      var le = "";
      g && g._owner && g._owner !== $e.current && (le = " It was passed a child from " + X(g._owner.type) + "."), Pt(g), b('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', H, le), Pt(null);
    }
  }
  function Nn(g, D) {
    {
      if (typeof g != "object")
        return;
      if (Te(g))
        for (var H = 0; H < g.length; H++) {
          var le = g[H];
          en(le) && Sn(le, D);
        }
      else if (en(g))
        g._store && (g._store.validated = !0);
      else if (g) {
        var Se = p(g);
        if (typeof Se == "function" && Se !== g.entries)
          for (var Ae = Se.call(g), Pe; !(Pe = Ae.next()).done; )
            en(Pe.value) && Sn(Pe.value, D);
      }
    }
  }
  function pi(g) {
    {
      var D = g.type;
      if (D == null || typeof D == "string")
        return;
      var H;
      if (typeof D == "function")
        H = D.propTypes;
      else if (typeof D == "object" && (D.$$typeof === u || // Note: Memo only checks outer props here.
      // Inner props are checked in the reconciler.
      D.$$typeof === y))
        H = D.propTypes;
      else
        return;
      if (H) {
        var le = X(D);
        xe(H, g.props, "prop", le, g);
      } else if (D.PropTypes !== void 0 && !Zt) {
        Zt = !0;
        var Se = X(D);
        b("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", Se || "Unknown");
      }
      typeof D.getDefaultProps == "function" && !D.getDefaultProps.isReactClassApproved && b("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
    }
  }
  function xi(g) {
    {
      for (var D = Object.keys(g.props), H = 0; H < D.length; H++) {
        var le = D[H];
        if (le !== "children" && le !== "key") {
          Pt(g), b("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", le), Pt(null);
          break;
        }
      }
      g.ref !== null && (Pt(g), b("Invalid attribute `ref` supplied to `React.Fragment`."), Pt(null));
    }
  }
  function In(g, D, H, le, Se, Ae) {
    {
      var Pe = I(g);
      if (!Pe) {
        var Ce = "";
        (g === void 0 || typeof g == "object" && g !== null && Object.keys(g).length === 0) && (Ce += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
        var Xe = Ni(Se);
        Xe ? Ce += Xe : Ce += kn();
        var Ke;
        g === null ? Ke = "null" : Te(g) ? Ke = "array" : g !== void 0 && g.$$typeof === t ? (Ke = "<" + (X(g.type) || "Unknown") + " />", Ce = " Did you accidentally export a JSX literal instead of a component?") : Ke = typeof g, b("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Ke, Ce);
      }
      var ze = Fe(g, D, H, Se, Ae);
      if (ze == null)
        return ze;
      if (Pe) {
        var nt = D.children;
        if (nt !== void 0)
          if (le)
            if (Te(nt)) {
              for (var kt = 0; kt < nt.length; kt++)
                Nn(nt[kt], g);
              Object.freeze && Object.freeze(nt);
            } else
              b("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
          else
            Nn(nt, g);
      }
      return g === r ? xi(ze) : pi(ze), ze;
    }
  }
  function Ri(g, D, H) {
    return In(g, D, H, !0);
  }
  function Ei(g, D, H) {
    return In(g, D, H, !1);
  }
  var Ai = Ei, Oi = Ri;
  Kt.Fragment = r, Kt.jsx = Ai, Kt.jsxs = Oi;
})();
(function(e) {
  e.exports = Kt;
})(Hi);
const ke = Mt.Fragment, o = Mt.jsx, S = Mt.jsxs;
class qi {
  constructor(t) {
    this._taskQueue = [], this._taskCountPerTime = 10, this._taskInterval = 1e4, this._scheduleTimer = 0, this._executor = t.executor, this._taskCountPerTime = t.taskCountPerTime ?? this._taskCountPerTime, this._taskInterval = t.taskInterval ?? this._taskInterval, "document" in globalThis && document.addEventListener("visibilitychange", () => {
      document.visibilityState === "hidden" && this._taskQueue.length > 0 && this._executor(this._taskQueue.splice(0)).catch(() => {
        throw new Error("AsyncScheduler: execute task failed.");
      });
    });
  }
  addTask(t) {
    this._taskQueue.push(t), this._tryScheduleIfNecessary();
  }
  _tryScheduleIfNecessary() {
    !this._scheduleTimer && this._taskQueue.length > 0 && (this._scheduleTimer = window.setTimeout(() => {
      this._run(), this._clearScheduleTimer();
    }, this._taskInterval));
  }
  _clearScheduleTimer() {
    this._scheduleTimer && (clearTimeout(this._scheduleTimer), this._scheduleTimer = 0);
  }
  _run() {
    const t = this._taskQueue.splice(0, Math.min(this._taskCountPerTime, this._taskQueue.length));
    Promise.resolve().then(() => t.length > 0 ? this._executor(t) : Promise.resolve()).catch(() => {
      this._taskQueue.push(...t);
    }).finally(() => {
      this._tryScheduleIfNecessary();
    });
  }
}
class Yi {
  constructor(t) {
    Error.stackTraceLimit = 100, this._reporterFunc = t.reporterFunc, this._asyncScheduler = new qi({
      executor: async (n) => {
        await this._reporterFunc(n);
      }
    });
  }
  _makeError(t) {
    const n = new Date(), r = t.message ?? t.error.message ?? "Unknown", i = t.error instanceof Error ? t.error : new Error(r);
    return {
      level: t.level ?? "low",
      err: {
        name: i.name ?? "Unknown",
        code: t.code ?? -1,
        msg: r,
        stack: i.stack ?? "Unknown"
      },
      time: {
        utc: n.getTime(),
        lo: n.toLocaleDateString(),
        tz: n.getTimezoneOffset()
      },
      ref: document.referrer,
      ctx: t.ctx ?? {}
    };
  }
  // private _watchUnhandledPromiseRejection(): void {
  //     if ('addEventListener' in globalThis) {
  //         globalThis.addEventListener('unhandledrejection', (event: PromiseRejectionEvent) => {
  //             let error: Error;
  //             if (event.reason instanceof Error) {
  //                 error = event.reason;
  //             }
  //             else if (typeof event.reason === 'string') {
  //                 error = new Error(event.reason);
  //             }
  //             else {
  //                 error = new Error('Unknown');
  //                 error.message = JSON.stringify(event.reason);
  //             }
  //             this._asyncScheduler.addTask(this._makeError({
  //                 level: 'low',
  //                 error,
  //                 ctx: {
  //                     type: 'unhandledrejection'
  //                 }
  //             }));
  //         });
  //     }
  // }
  sendError(t) {
    this._asyncScheduler.addTask(this._makeError(t));
  }
}
class Gi {
  constructor() {
    this.officialDomain = "https://reolink.dev", this.storeDomain = "https://store.reolink.dev", this.accountDomain = "https://my.reolink.dev", this.apiDomain = "https://apis.reolink.dev", this.cdnDomain = "https://cdn.reolink.dev", this.baseUrl = this.officialDomain + "/wp-json/reo-v2/", this.baseUrlV3 = this.officialDomain + "/reo-v3/", this.baseUrlApiV2 = this.apiDomain + "/v2/", this.screen = "pc", typeof navigator < "u" && navigator.userAgent.toLowerCase().includes("mobile") && (this.screen = "mobile");
  }
}
const Je = new Gi();
class vn {
  constructor(t, n) {
    this._httpInstance = {}, this._isInit = !1, this._isInit || (this._httpInstance = new Di({
      baseUrl: t,
      receivingResponse: {
        onFulfilled(r) {
          var i;
          if (!n && ((i = r == null ? void 0 : r.result) == null ? void 0 : i.code) !== 0)
            throw r;
        },
        onRejected(r) {
          console.error(r);
        }
      }
    }), this._isInit = !0);
  }
  get httpInstance() {
    return this._httpInstance;
  }
  async get(t, n, r) {
    return await this._httpInstance.get(t, n, r);
  }
  async post(t, n, r) {
    return await this._httpInstance.post(t, n, r);
  }
  async patch(t, n, r) {
    return await this._httpInstance.patch(t, n, r);
  }
  async put(t, n, r) {
    return await this._httpInstance.put(t, n, r);
  }
  async delete(t, n, r) {
    return await this._httpInstance.delete(t, n, r);
  }
}
const ct = new vn(Je.baseUrl), Qi = new vn(Je.baseUrlV3), Xi = new vn(Je.baseUrlApiV2, !0), En = async (e, t) => {
  let n = `/gifts/batch/?no-mobile-redirection=1&id=${e}`;
  return t && (n += "&area=flashsale"), (await ct.get(n)).data;
}, Ji = async (e) => {
  let t = "/gifts/batch/?no-mobile-redirection=1";
  return e && (t += "&area=flashsale"), (await ct.get(t)).data;
}, Zi = async (e) => (await ct.get(`/products/${e}/recommendations?processed_data=1&no-mobile-redirection=1`)).data, er = async () => (await ct.get("/aliexpress/activities?no-mobile-redirection=1")).data, tr = async (e) => {
  const t = e.country;
  await Xi.post(
    "/emails/subscriptions/?no-mobile-redirection=1",
    {
      email: e.email,
      topicKey: e.subject.toLowerCase(),
      country: t && t !== "__" ? t : void 0
    }
  );
};
function nr(e) {
  const t = {
    "&#197;": "Å",
    "&ccedil;": "Ç",
    "&Eacute;": "É",
    "&atilde;": "Ã",
    "&eacute;": "é",
    "&iacute;": "í",
    "&oacute;": "ó",
    "&ouml;": "ö",
    "&Iacute;": "Í"
  }, n = RegExp("(" + Object.keys(t).join("|") + ")", "g");
  return typeof e != "string" ? "" : e.replace(n, function(r) {
    return t[r];
  });
}
async function ir(e) {
  await Qi.post("/errors/reports?no-mobile-redirection=1", e);
}
async function rr(e) {
  return (await ct.get(
    "/payment/configuration?no-mobile-redirection=1",
    {
      ...e
    }
  )).data;
}
async function or() {
  return (await ct.get(
    "/session/profile?no-mobile-redirection=1"
  )).data;
}
async function ar(e) {
  const t = await ct.get("countries?no-mobile-redirection=1", e);
  for (const n of t.data ?? [])
    n.name = nr(n.name);
  return t;
}
const sr = new Yi({
  reporterFunc(e) {
    return new Promise(() => {
      ir(e).catch(console.error);
    });
  }
});
class At {
  constructor(t, n) {
    this._errorCollector = t, this._init(n);
  }
  static $createInstance(t, n) {
    return new At(t, n);
  }
  /**
   * 将业务模块的错误处理成对应的视图错误，并根据配置选择性的收集错误
   * @param error 系统定义的错误值
   * @param details 接口返回的原生错误信息
   * @returns 一个错误实例
   */
  handle(t, n) {
    if (t instanceof At)
      return t;
    const r = new At(this._errorCollector, this._config);
    return r._error = t, r._rawError = n, r._setErrType(), r._collectErr(), r;
  }
  /**
   * @returns 视图层的错误值
   */
  getErrType() {
    return this._errType;
  }
  /**
   * @returns 接口返回的原生错误信息
   */
  getErrDetails() {
    return this._rawError;
  }
  _init(t) {
    const { module: n, map: r, collect: i } = t;
    return this._config = { module: n, map: r, default: t.default, collect: i }, this;
  }
  _setErrType() {
    const t = this._error, n = this._config.map;
    let r = !1;
    if (typeof t == "number") {
      for (const i in n)
        if (n[i].includes(t)) {
          this._errType = i, r = !0;
          break;
        }
    }
    r || (this._errType = this._config.default);
  }
  _collectErr() {
    var t;
    if (this._config.collect === !0 || this._errType === this._config.default || this._config.collect !== !1 && typeof this._error == "number" && ((t = this._config.collect) != null && t.includes(this._error))) {
      const n = {
        error: this._rawError,
        message: this._errType,
        ctx: {
          rawError: this._rawError,
          userAgent: navigator.userAgent
        }
      };
      this._errorCollector.sendError(n);
    }
  }
}
function cr(e) {
  const t = sr;
  return At.$createInstance(t, e);
}
let Ct = class {
  constructor() {
    this._list = {};
  }
  on(t, n) {
    const r = this._list[t];
    if (!r)
      this._list[t] = [];
    else {
      const i = r.indexOf(n);
      i !== -1 && r.splice(i, 1);
    }
    this._list[t].push(n);
  }
  emit(t, n) {
    const r = this._list[t];
    !r || r.length === 0 || r.forEach(
      (i) => {
        i(n);
      }
    );
  }
  off(t, n) {
    const r = this._list[t];
    if (!n) {
      this._list[t].splice(0);
      return;
    }
    if (!r || r.length === 0)
      return;
    const i = r.indexOf(n);
    i !== -1 && this._list[t].splice(i, 1);
  }
  once(t, n, ...r) {
    const i = () => {
      this.off(t, i), n(...r);
    };
    this.on(t, i);
  }
};
const St = new Ct();
class lr {
  get(t, n) {
    const r = n ?? (typeof document < "u" ? document.cookie : "");
    if (r) {
      const a = new RegExp("(^| )" + t + "=([^;]*)(;|$)").exec(r);
      return a ? a[2] : null;
    }
    return null;
  }
  set(t, n, r, i) {
    if (typeof document < "u") {
      const a = i || this.getCurrentDomain();
      let s = t + "=" + n + "; domain=" + a + "; path=/; secure";
      r && (s += "; expires=" + r), document.cookie = s;
    }
  }
  clear(t) {
    typeof document < "u" && this.set(t, "", new Date(0));
  }
  /** 取域名的后两级为cookie的目标域 */
  getCurrentDomain() {
    var r, i;
    const t = (i = (r = ge()) == null ? void 0 : r.location) == null ? void 0 : i.host.split("."), n = t.length;
    return `.${t.slice(n - 2).join(".")}`;
  }
}
const He = new lr();
var Et = /* @__PURE__ */ ((e) => (e[e.VALID = 1] = "VALID", e[e.NOT_EXISTED = -1] = "NOT_EXISTED", e[e.TIMEOUT = -2] = "TIMEOUT", e[e.OTHER_ERRORS = -3] = "OTHER_ERRORS", e))(Et || {});
const An = {
  cache: {},
  _loadPromise: null,
  async getResource() {
    var e, t;
    window._NBSettings = {
      apiKey: "public_8a0ca492b48035da2cbca0c2ac85db3f",
      autoFieldHookup: !1,
      // 关闭自动绑定
      displayPoweredBy: !1,
      inputLatency: 1e3,
      feedback: !1,
      blockThrottledAttempts: !1,
      timeout: 3
    }, this._loadPromise === null && (this._loadPromise = Mi("https://cdn.neverbounce.com/widget/dist/NeverBounce.js", (t = (e = ge()) == null ? void 0 : e.document) == null ? void 0 : t.body)), await this._loadPromise;
  },
  getValidation(e) {
    return new Promise(function(t, n) {
      var r, i;
      typeof ((i = (r = window._nb) == null ? void 0 : r.api) == null ? void 0 : i.getValidatePublic) == "function" ? window._nb.api.getValidatePublic(
        e,
        (a) => {
          t(a);
        },
        (a) => {
          n(a);
        }
      ) : n(Error("getValidation failed"));
    });
  },
  /**
   * @param   {String} email 待校验真实性的邮箱
   * @returns {Promise<EAuthResult>} 邮箱真实性验证结果
   */
  async getEmailAuthenticity(e) {
    try {
      return window._nb || await this.getResource(), this.cache[e] ? this.cache[e] : ((await this.getValidation(e)).response.allow_entry ? this.cache[e] = Et.VALID : this.cache[e] = Et.NOT_EXISTED, this.cache[e]);
    } catch (t) {
      return t === "Timeout" ? Et.TIMEOUT : Et.OTHER_ERRORS;
    }
  }
}, ur = An.getEmailAuthenticity.bind(An);
class dr {
  constructor() {
    this._callbacks = [], this.emit = ft.Async.once(this._emit.bind(this));
  }
  register(t) {
    this._callbacks.push(t), this._data && this._walk();
  }
  _walk() {
    let t = this._callbacks.splice(0, 1)[0];
    for (; t; )
      t(this._data), t = this._callbacks.splice(0, 1)[0];
  }
  _emit(t) {
    this._data || (this._data = t, this._walk());
  }
}
new dr();
class fr {
  constructor() {
    this._regexs = {
      username: /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]{3,16}$/,
      method: /^(.+)\((.+)\)$/,
      start2End: /^(.+)\[(\d?,\d?)\]$/,
      email: /^[-+_a-z0-9][-+_.a-z0-9]{0,62}@[a-z0-9][-a-z0-9]{0,62}(\.[a-z0-9][-a-z0-9]{0,62})*$/i,
      phone: /^[\s#0-9_\-+()]+$/,
      password: /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]{6,30}$/,
      numeric: /^[+-]?([0-9]*[.])?[0-9]+$/,
      numericNoSymbols: /^[0-9]+$/,
      int: /^[-+]?(0|[1-9]\d*)$/,
      uint: /^(0|[1-9]\d*)$/,
      float: /^([+-]?((0|[1-9]\d*)\.[0-9]*))|([+-]?(0|[1-9]\d*))$/,
      alpha: /^[a-zA-Z]+$/,
      alphaNumeric: /^[a-zA-Z0-9]+$/,
      alphaDash: /^[a-zA-Z0-9_-]+$/
    }, this._testHooks = {
      required: (t) => {
        const { fieldValue: n, type: r, checked: i } = t;
        return r === "checkbox" || r === "radio" ? i === !0 : n !== null && n !== "";
      },
      isEmail: (t) => this._regexs.email.test(t.fieldValue),
      minLength: (t, n) => this._regexs.numeric.test(n) ? t.fieldValue.length >= parseInt(n, 10) : !1,
      maxLength: (t, n) => this._regexs.numeric.test(n) ? t.fieldValue.length <= parseInt(n, 10) : !1,
      exactLength: (t, n) => this._regexs.numeric.test(n) ? t.fieldValue.length === parseInt(n, 10) : !1
    };
  }
  check(t, n) {
    const r = this._regexs.method.exec(t);
    if (r) {
      const i = this._testHooks[r[1]];
      return i({ fieldValue: n }, r[2]);
    } else {
      const i = this._testHooks[t];
      return i({ fieldValue: n });
    }
  }
}
const mr = new fr();
class hr {
  constructor() {
    this._cookieKey = "gdprLocalName", this.euCountries = [
      "AT",
      "BE",
      "BG",
      "HR",
      "CY",
      "CZ",
      "DK",
      "EE",
      "FI",
      "FR",
      "DE",
      "GR",
      "HU",
      "IE",
      "IT",
      "LV",
      "LT",
      "LU",
      "MT",
      "NL",
      "PL",
      "PT",
      "RO",
      "SK",
      "SI",
      "ES",
      "SE",
      "GB"
    ];
  }
  // 判断是否是欧盟国家
  isEurap(t) {
    return this.euCountries.includes(t.toUpperCase());
  }
  /**
   * 首次进入时，没有权限存储数据，默认为true
   * 欧盟、非欧盟都执行
   * 不为空时，说明是经过设置的，即该国家为欧盟国家，再根据其结果进行对应的设置
   */
  getGDPRPermission(t, n) {
    try {
      const r = He.get(this._cookieKey);
      if (!r)
        n(!0);
      else {
        const i = JSON.parse(r);
        t in i && n(i[t]);
      }
    } catch (r) {
      console.error(r);
    }
  }
  setPermission(t) {
    t && t instanceof Object && He.set(
      this._cookieKey,
      JSON.stringify(t),
      new Date(new Date().getTime() + 864e5 * 365),
      He.getCurrentDomain()
    );
  }
}
const gr = new hr();
function bn() {
  const [e, t] = M(he() < 768 ? "mobile" : "pc");
  return ne(() => {
    const n = () => {
      he() < 768 ? t("mobile") : t("pc");
    };
    return window.addEventListener("resize", n), () => {
      window.removeEventListener("resize", n);
    };
  }, []), e;
}
const yr = (e) => {
  const [
    t,
    n
  ] = M(ft.Env.getGlobalProperty("innerWidth", (e == null ? void 0 : e.widthOfWindow) ?? 0)), [
    r,
    i
  ] = M(ft.Env.getGlobalProperty("innerHeight", (e == null ? void 0 : e.heightOfWindow) ?? 0)), a = V(() => {
    const s = window.innerWidth, c = window.innerHeight;
    n(s), i(c);
  }, []);
  return ne(() => {
    const s = ft.Optimization.throttle(a, 300);
    return s(), window.addEventListener("resize", s), () => {
      window.removeEventListener("resize", s);
    };
  }, [a]), { widthOfWindow: t, heightOfWindow: r };
};
function Ft(e, t) {
  const n = new Date().getTime();
  return n > e && n < t;
}
function vr(e) {
  return typeof e == "function";
}
function ai(e) {
  var i;
  const t = (i = ge()) == null ? void 0 : i.document;
  if (!t)
    return;
  const n = t.createElement("input"), r = t.getElementsByTagName("body")[0];
  n.value = e, r.appendChild(n), n.select(), t.execCommand("copy"), r.removeChild(n);
}
function Ut(e, t) {
  if (!e)
    return "";
  const n = /\d$/, r = e.toString();
  return n.test(r) ? r + (t ?? "px") : r;
}
function On(e) {
  return typeof e == "number" || typeof e == "string";
}
function br(e) {
  function t(n, r, i) {
    return n < r ? i ? -1 : 1 : n > r ? i ? 1 : -1 : 0;
  }
  return function(n, r) {
    for (const i of e) {
      const a = i.key, s = n[a], c = r[a];
      if (!On(s) || !On(c))
        return 0;
      if (s !== c) {
        const m = (i.order ?? "asc") === "asc";
        return t(s, c, m);
      }
    }
    return 0;
  };
}
function dn(e, t) {
  if (!e)
    return null;
  const n = e instanceof Array ? e : Object.values(e);
  for (const r of n)
    if (r.key === t)
      return r;
  return null;
}
function _r(e, t) {
  const n = [];
  if (t) {
    const r = Object.keys(e).sort();
    for (const i of r)
      n.push(i + "=" + encodeURIComponent(e[i]));
  } else
    for (const r in e)
      e[r] !== null && e[r] !== void 0 && n.push(r + "=" + encodeURIComponent(e[r]));
  return n.join("&");
}
async function Cr(e, t) {
  const n = document.createElement("script");
  if (n.setAttribute("type", "text/javascript"), n.src = e, t)
    for (const r in t)
      n.setAttribute(r, t[r]);
  return new Promise((r, i) => {
    n.onload = () => {
      r();
    }, n.onerror = () => {
      i();
    }, document.body.append(n);
  });
}
function wr(e, t) {
  var i, a, s, c, u;
  let n = "", r = "formatter";
  if (t) {
    const m = new Date(t), v = m.getFullYear(), y = m.getMonth() + 1, T = m.getDate(), f = e.common[`month-${y}`], w = ((a = (i = ge()) == null ? void 0 : i.REOLINK_CONFIG) == null ? void 0 : a.currentLanguage) ?? "en", P = ((c = (s = ge()) == null ? void 0 : s.REOLINK_CONFIG) == null ? void 0 : c.country) ?? "US";
    w === "en" && P === "US" && (r = "formatter_us"), n = (u = e.common[r]) == null ? void 0 : u.replace("{day}", T).replace("{month}", f).replace("{year}", v);
  }
  return n;
}
function si() {
  var e, t;
  return ((t = (e = ge()) == null ? void 0 : e.REOLINK_CONFIG) == null ? void 0 : t.currentLanguage) ?? "en";
}
function Tt(e) {
  return Je.cdnDomain + e;
}
function Pr(e) {
  return ft.Env.getGlobalThis()[e] !== void 0;
}
const kr = /^\s*javascript:\s*void\(0\);\s*$/;
function Yt(e) {
  return kr.test(e);
}
function Tr(e, t) {
  var a, s;
  const n = decodeURIComponent(t ?? ((s = (a = ge()) == null ? void 0 : a.location) == null ? void 0 : s.search.slice(1))), i = new RegExp("(^|&)" + e + "=([^&]*)(&|$)").exec(n);
  return i ? i[2] : "";
}
function Sr() {
  return [
    "DZ",
    "BJ",
    "ET",
    "MA",
    "NG",
    "ZA",
    "TR",
    "IL",
    "KW",
    "QA",
    "SA",
    "AE",
    "HK",
    "ID",
    "JP",
    "KR",
    "MY",
    "PH",
    "SG",
    "TH",
    "VN",
    "AR",
    "BR",
    "CL",
    "CO",
    "EC",
    "PE",
    "BZ",
    "LC",
    "TT",
    "CR",
    "DO",
    "GT",
    "PA"
  ];
}
function ci(e) {
  e.preventDefault();
}
const _n = () => {
  var t, n, r, i;
  const e = (n = (t = ge()) == null ? void 0 : t.document) == null ? void 0 : n.querySelector("html,body");
  e && (e.className = e.className.includes("banScroll") ? e.className : `${e.className} banScroll`), (i = (r = ge()) == null ? void 0 : r.document) == null || i.addEventListener("touchmove", ci, !1);
}, Cn = () => {
  var t, n, r, i;
  const e = (n = (t = ge()) == null ? void 0 : t.document) == null ? void 0 : n.querySelector("html,body");
  e && (e.className = e.className.replace(/\s*banScroll\s*/, "")), (i = (r = ge()) == null ? void 0 : r.document) == null || i.removeEventListener("touchmove", ci, !1);
}, Nr = (e, t = !1, n = window) => {
  var c, u;
  if (!e)
    return null;
  const r = (u = (c = ge()) == null ? void 0 : c.document) == null ? void 0 : u.getElementsByTagName("html")[0], i = {
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    scrollBottom: 0,
    scrollLeft: 0,
    scrollRight: 0,
    width: 0
  };
  let a = 0, s = 0;
  return t && (i.top += e.offsetHeight), n instanceof Window || typeof n === null || (a = n.getBoundingClientRect().top + window.pageYOffset, s = n.getBoundingClientRect().left + window.pageXOffset), i.scrollBottom = r.getBoundingClientRect().bottom + a - (e.getBoundingClientRect().bottom + a), i.scrollLeft = e.getBoundingClientRect().left + window.pageXOffset - s, i.scrollRight = e.getBoundingClientRect().left + window.pageXOffset - s + e.getBoundingClientRect().width, i.bottom = window.innerHeight - e.getBoundingClientRect().bottom, i.top += e.getBoundingClientRect().top + window.pageYOffset, i.left += e.getBoundingClientRect().left + window.pageXOffset, i.right += e.getBoundingClientRect().right + window.pageXOffset, i.width = e.getBoundingClientRect().width, i;
};
function he() {
  var e, t;
  return Pr("document") ? document.documentElement.clientWidth ?? Math.max((e = ge()) == null ? void 0 : e.outerWidth, (t = ge()) == null ? void 0 : t.screen.availWidth) : 1280;
}
function Ir(e, t) {
  var n, r;
  (r = (n = ge()) == null ? void 0 : n.document) == null || r.getElementsByTagName("html")[0].scrollTo({ top: e });
}
function rt(e, t) {
  return e.className === void 0 ? !1 : new RegExp("(?:^| +)" + t + "(?: +|$)", "g").test(e.className);
}
function Ln(e, t) {
  rt(e, t) || (e.className += ` ${t}`);
}
function Vt(e, t) {
  if (rt(e, t)) {
    const n = new RegExp("(?:^| +)" + t + "(?: +|$)", "g");
    e.className = e.className.replace(n, "");
  }
}
function xt(e, t) {
  let n = e.parentElement;
  for (; n && !rt(n, t); )
    n = n.parentElement;
  return n;
}
function wn() {
  var e, t;
  return (t = (e = ge()) == null ? void 0 : e.location) == null ? void 0 : t.pathname.endsWith("/cart/");
}
function pr() {
  var e, t, n;
  return ((t = (e = ge()) == null ? void 0 : e.location) == null ? void 0 : t.pathname.endsWith("/distributor-reseller/")) || ((n = ge()) == null ? void 0 : n.__IS_DISTRIBUTOR_PAGE__);
}
function zt() {
  var e, t;
  return (t = (e = ge()) == null ? void 0 : e.location) == null ? void 0 : t.pathname.endsWith("/flash-sale/");
}
function Gt(e) {
  return Je.officialDomain + e;
}
function xr(e) {
  const t = e.toLowerCase();
  return Gt(!e || e === "en" ? "/blog/" : `/${t}/blog/`);
}
function It(e, t) {
  return Er.getCountryPath(e, t);
}
var ut = /* @__PURE__ */ ((e) => (e.EN = "en", e.DE = "de", e.FR = "fr", e.IT = "it", e.ES = "es", e.JP = "jp", e.PT = "pt", e.RU = "ru", e))(ut || {}), li = /* @__PURE__ */ ((e) => (e.OPEN_PORTAL = "OPEN_PORTAL", e.INITED = "INITED", e))(li || {});
class Rr extends Ct {
  constructor() {
    super(), this._inited = !1, this._notifiedCookieKey = "notified_country_notice", this._countryCookieKey = "REO_COUNTRY", this._langCookieKey = "REO_LANGUAGE", this._currentCountry = "__", this._realCountry = "__", this._otherRegion = "__", this._sellableCountries = [], this._configuration = {
      country: {
        // 每个语言需要定制的国家名称
        de: "Deutschland",
        it: "Italia",
        fr: "France",
        es: "España",
        jp: "日本",
        pt: "Portugal",
        ru: "Russia",
        other: "Other Regions"
      },
      lang: {},
      continent: [
        {
          code: "NA",
          name: {
            en: "North America",
            fr: "Amérique du Nord",
            de: "Nordamerika",
            it: "Nord America",
            es: "Norteamérica",
            jp: "北米",
            pt: "América do Norte",
            ru: "Северная Америка"
          }
        },
        {
          code: "EU",
          name: {
            en: "Europe",
            fr: "Europe",
            de: "Europa",
            it: "Europa",
            es: "Europa",
            jp: "ヨーロッパ",
            pt: "Europa",
            ru: "Европа"
          }
        },
        {
          code: "OC",
          name: {
            en: "Oceania",
            fr: "Océanie",
            de: "Ozeanien",
            it: "Oceania",
            es: "Oceanía",
            jp: "オセアニア",
            pt: "Oceânia",
            ru: "Океания"
          }
        },
        {
          code: "SA",
          name: {
            en: "South America",
            fr: "Amérique du Sud",
            de: "Südamerika",
            it: "Sud America",
            es: "Sudamérica",
            jp: "南米",
            pt: "América do Sul",
            ru: "Южная Америка"
          }
        },
        {
          code: "AS",
          name: {
            en: "Asia",
            fr: "Asie",
            de: "Asien",
            it: "Asia",
            es: "Asia",
            jp: "アジア",
            pt: "Ásia",
            ru: "Азия"
          }
        },
        {
          code: "AF",
          name: {
            en: "Africa",
            fr: "Afrique",
            de: "Afrika",
            it: "Africa",
            es: "África",
            jp: "アフリカ",
            pt: "África",
            ru: "Африка"
          }
        }
      ]
    }, this._pagesNeedPrefix = [], this._currentPage = "/";
  }
  get langCookieKey() {
    return this._langCookieKey;
  }
  async ensureInited(t) {
    this._inited || (await this._init(t), this._inited = !0);
  }
  async _init(t) {
    var n, r;
    try {
      this._realCountry = t.realCountry, this._sellableCountries = t.supportedRegions, this._currentCountry = this.isSellableCountry(t.currentCountry) ? t.currentCountry : this._otherRegion;
      const i = {
        [ut.EN]: "English",
        [ut.DE]: "Deutsch",
        [ut.FR]: "Français",
        [ut.IT]: "Italiano",
        [ut.ES]: "Español",
        [ut.JP]: "日本語",
        [ut.PT]: "Português",
        [ut.RU]: "Русский"
      }, a = t.supportedLangs ?? Object.keys(i), s = {};
      for (const u in i)
        a.includes(u) && (s[u] = i[u]);
      this._configuration.lang = s, this._currentLang = t.currentLang, this._currentPage = ((r = (n = ge()) == null ? void 0 : n.location) == null ? void 0 : r.pathname) ?? "/";
      const c = this.hasCountryPrefix(this._currentPage) ? this._getPathCountry(this._currentPage) : this._currentCountry;
      c && (He.clear(this._countryCookieKey), He.set(
        this._countryCookieKey,
        c.toUpperCase(),
        new Date(Date.now() + 86400 * 1e3 * 3600),
        He.getCurrentDomain()
      )), this.emit(li.INITED);
    } catch (i) {
      console.error(i);
    }
  }
  getSellableCountryList() {
    const t = this._sellableCountries.slice(0).sort((i, a) => i.countryName > a.countryName ? 1 : -1), n = this._configuration.country, r = this._configuration.continent.map((i) => {
      const a = t.filter((s) => s.continent.toUpperCase() === i.code.toUpperCase());
      return {
        continentTitle: i.name[this._currentLang],
        continentCode: i.code,
        countryList: a
      };
    }).filter((i) => i.countryList.length > 0);
    for (const i of r) {
      for (const a of i.countryList) {
        const s = a.country.toLowerCase();
        Object.keys(n).includes(s) && (a.countryName = n[s]);
      }
      i.countryList.push({
        continent: i.continentCode,
        country: "__",
        countryName: n.other,
        language: ["en"]
      });
    }
    return r;
  }
  getSupportedLangList() {
    const t = [], n = this._configuration.lang;
    for (const r in n)
      t.push({
        langKey: r,
        langText: n[r]
      });
    return t;
  }
  getCurrentLang() {
    return this._currentLang;
  }
  getRealCountryCode() {
    return this._realCountry;
  }
  /** 返回一个大写的当前国家码，如果是未开售国家则返回 __ */
  getCurrentCountryCode() {
    const t = He.get(this._countryCookieKey);
    let n = t || this._currentCountry;
    return this.isSellableCountry(n) || (n = this._otherRegion), n.toUpperCase();
  }
  isSellableCountry(t) {
    return !!this._sellableCountries.find((r) => r.country.toUpperCase() === t.toUpperCase());
  }
  // 返回指定国家所在的洲板块简码，如北美洲为 NA
  getContinentOfCountry(t) {
    if (t === "__" || t === "")
      return "";
    const n = this._sellableCountries.find((r) => r.country.toUpperCase() === t.toUpperCase());
    return n ? n.continent.toUpperCase() : "";
  }
  updateCurrentCountry(t) {
    this._currentCountry = t.toUpperCase(), He.clear(this._countryCookieKey), He.set(
      this._countryCookieKey,
      this._currentCountry,
      new Date(Date.now() + 86400 * 1e3 * 3600),
      He.getCurrentDomain()
    ), He.set(this._notifiedCookieKey, 1, void 0, He.getCurrentDomain());
  }
  updateCurrentLang(t) {
    this._currentLang = t, He.clear(this._langCookieKey), He.set(
      this._langCookieKey,
      this._currentLang,
      new Date(Date.now() + 86400 * 1e3 * 3600),
      He.getCurrentDomain()
    );
  }
  /**
   * 返回校正国家前缀的 url
   * @param path url 路径，可以是相对路径也可以是完整路径
   * @param isStore 是否是 store 域名下的页面
   * @param isUserChange 用户切换国家触发当前页面地址转换的标识，为 true 时 path 为当前页面 url
   * @returns 添加了国家前缀的 url
   */
  getCountryPath(t, n, r) {
    if (t.replace(/\s/g, "") === "javascript:void(0);")
      return t;
    const i = /^https?:\/\/[\w-.]+(:\d+)?\/?/;
    let a = n ? Je.storeDomain : Je.officialDomain, s = t;
    if (s.startsWith("http")) {
      const u = i.exec(s);
      s = u ? s.replace(u[0], "") : s, a = u ? u[0] : a;
    }
    if (a.endsWith("/") && (a = a.slice(0, -1)), s.startsWith("/") || (s = `/${s}`), a !== Je.storeDomain && a !== Je.officialDomain)
      return t;
    if (new RegExp(`^(?:${Je.officialDomain})?/blog/(?:[a-z]{2,})?$`).test(t))
      return xr(this._currentLang ? this._currentLang : "en");
    if (this._sellableCountries.length === 0)
      return `${a}${s}`;
    const c = this._getPathCountry(s);
    if (c && (s = s.replace(`/${c}`, "")), r)
      return this.hasCountryPrefix(s) ? `${a}/${this._currentCountry.toLowerCase()}${s}` : `${a}${s}`;
    if (this.hasCountryPrefix(s)) {
      const u = this.hasCountryPrefix(this._currentPage) ? this._getPathCountry(this._currentPage) : this._currentCountry;
      return u !== "" ? `${a}/${u.toLowerCase()}${s}` : `${a}${s}`;
    }
    return `${a}${s}`;
  }
  /**
  * 转换从服务器获取数据动态输出的文本中的链接
  * 因path具有不确定性，所以只转换store页面的链接以及首页、产品页、和blog首页
  * @param {String} path 目标地址
  * @param {Boolean} isStore 是否为Store域名
  */
  getRenderTextPath(t, n) {
    if (n)
      return this.getCountryPath(t, n);
    const r = [
      new RegExp(`^${Je.storeDomain}`),
      new RegExp(`^(${Je.officialDomain})?(/product/|/?$)`),
      new RegExp(`^(${Je.officialDomain})?/blog/$`)
    ];
    let i = !1, a = !1;
    for (let s = 0; s < r.length; s++)
      if (r[s].test(t)) {
        i = !0, s === 0 && (a = !0);
        break;
      }
    return i ? this.getCountryPath(t, a) : t;
  }
  hasCountryPrefix(t) {
    let n = t;
    const r = this._getPathCountry(n);
    return n.startsWith("/") || (n = `/${n}`), r !== "" && (n = n.replace(`/${r}`, "")), n.includes("?") && (n = n.slice(0, n.indexOf("?"))), n.includes("#") && (n = n.slice(0, n.indexOf("#"))), n.endsWith("/") || (n = `${n}/`), this._pagesNeedPrefix.some((a) => {
      const s = a.replace("*", ".*");
      return new RegExp(`^${s}$`).test(n);
    });
  }
  _getPathCountry(t) {
    const r = (t.startsWith("/") ? t : `/${t}`).split("/")[1].toLowerCase();
    return r && (this.isSellableCountry(r) || r === this._otherRegion) ? r : "";
  }
  hasNotified() {
    return He.get(this._notifiedCookieKey) !== null;
  }
  markIsNoticed() {
    He.set(
      this._notifiedCookieKey,
      1,
      new Date(Date.now() + 86400 * 1e3 * 3600),
      He.getCurrentDomain()
    );
  }
  isTheSame(t, n) {
    return t.toUpperCase() === n.toUpperCase();
  }
  /**
   * 测试时打开，其他场景不允许调用此方法
   */
  simulateCurrentPageIs(t) {
    this._currentPage = t;
  }
}
const Er = new Rr();
var ui = /* @__PURE__ */ ((e) => (e[e.UNKNOWN_ERROR = 0] = "UNKNOWN_ERROR", e[e.PARSE_ERROR = 1] = "PARSE_ERROR", e[e.NETWORK_ERROR = 2] = "NETWORK_ERROR", e[e.SERVER_ERROR = 3] = "SERVER_ERROR", e))(ui || {}), me = /* @__PURE__ */ ((e) => (e[e.PRODUCT_QUANTITY_ERROR = 0] = "PRODUCT_QUANTITY_ERROR", e[e.PRODUCT_NOT_FOUND = 1] = "PRODUCT_NOT_FOUND", e[e.PRODUCT_NEED_VARIATION = 2] = "PRODUCT_NEED_VARIATION", e[e.PRODUCT_OUT_OF_STOCK = 3] = "PRODUCT_OUT_OF_STOCK", e[e.PRODUCT_STOCK_NOT_ENOUGH = 4] = "PRODUCT_STOCK_NOT_ENOUGH", e[e.PRODUCT_ONLY_INDIVIDUALLY_SALE = 5] = "PRODUCT_ONLY_INDIVIDUALLY_SALE", e[e.ACTIVITY_NOT_VALID = 6] = "ACTIVITY_NOT_VALID", e[e.ACTIVITY_CONDITION_NOT_REACH = 7] = "ACTIVITY_CONDITION_NOT_REACH", e[e.ACTIVITY_CAN_NOT_CIRCLE = 8] = "ACTIVITY_CAN_NOT_CIRCLE", e[e.ACTIVITY_GIFT_MAX_LIMIT = 9] = "ACTIVITY_GIFT_MAX_LIMIT", e[e.GET_CART_FAILED = 10] = "GET_CART_FAILED", e[e.PARAMETER_ERROR = 11] = "PARAMETER_ERROR", e[e.CART_IS_EMPTY = 12] = "CART_IS_EMPTY", e[e.CART_ITEM_NOT_FOUND = 13] = "CART_ITEM_NOT_FOUND", e[e.GIFT_CAT_NOT_BE_UPDATED = 14] = "GIFT_CAT_NOT_BE_UPDATED", e[e.GIFT_GET_LIST_FAIL = 15] = "GIFT_GET_LIST_FAIL", e[e.CART_GET_LIST_FAIL = 16] = "CART_GET_LIST_FAIL", e[e.UNKNOWN_ERROR = 17] = "UNKNOWN_ERROR", e[e.NETWORK_ERROR = 18] = "NETWORK_ERROR", e[e.REMOVE_COUPON_FAIL = 19] = "REMOVE_COUPON_FAIL", e))(me || {}), Bt = /* @__PURE__ */ ((e) => (e[e.OR = 1] = "OR", e[e.AND = 2] = "AND", e))(Bt || {}), at = /* @__PURE__ */ ((e) => (e[e.IN_STOCK = 0] = "IN_STOCK", e[e.LIMITED_SALE = 1] = "LIMITED_SALE", e[e.OUT_OF_STOCK = 2] = "OUT_OF_STOCK", e[e.DISCONTINUED = 3] = "DISCONTINUED", e[e.COMING_SOON = 4] = "COMING_SOON", e[e.PRE_ORDER = 5] = "PRE_ORDER", e))(at || {});
const Ar = cr({
  module: "cart",
  map: {
    "cart.activity_not_valid": [me.ACTIVITY_NOT_VALID],
    "cart.activity_can_not_circle": [me.ACTIVITY_CAN_NOT_CIRCLE],
    "cart.activity_condition_not_reach": [me.ACTIVITY_CONDITION_NOT_REACH],
    "cart.activity_gift_max_limity": [me.ACTIVITY_GIFT_MAX_LIMIT],
    "cart.product_only_individually_sale": [me.PRODUCT_ONLY_INDIVIDUALLY_SALE],
    "cart.product_out_of_stock": [me.PRODUCT_OUT_OF_STOCK],
    "cart.product_stock_not_enough": [me.PRODUCT_STOCK_NOT_ENOUGH],
    "cart.product_quantity_error": [me.PRODUCT_QUANTITY_ERROR],
    "cart.unknown_error": [me.UNKNOWN_ERROR],
    "cart.parameter_error": [me.PARAMETER_ERROR],
    "cart.product_need_variation_error": [me.PRODUCT_NEED_VARIATION],
    "cart.product_not_found_error": [me.PRODUCT_NOT_FOUND],
    "cart.cart_is_empty": [me.CART_IS_EMPTY],
    "cart.cart_item_not_found": [me.CART_ITEM_NOT_FOUND],
    "cart.gift_can_not_updated": [me.GIFT_CAT_NOT_BE_UPDATED],
    "cart.gift_get_list_fail": [me.GIFT_GET_LIST_FAIL],
    "cart.cart_get_list_fail": [me.CART_GET_LIST_FAIL],
    "cart.remove_coupon_fail": [me.REMOVE_COUPON_FAIL]
  },
  default: "cart.unknown_error",
  collect: [ui.UNKNOWN_ERROR, me.ACTIVITY_NOT_VALID, me.ACTIVITY_CAN_NOT_CIRCLE, me.ACTIVITY_CONDITION_NOT_REACH, me.ACTIVITY_GIFT_MAX_LIMIT, me.PRODUCT_ONLY_INDIVIDUALLY_SALE, me.PRODUCT_ONLY_INDIVIDUALLY_SALE, me.PRODUCT_STOCK_NOT_ENOUGH, me.PRODUCT_OUT_OF_STOCK, me.GET_CART_FAILED, me.PRODUCT_QUANTITY_ERROR, me.PRODUCT_NOT_FOUND, me.CART_IS_EMPTY, me.CART_ITEM_NOT_FOUND, me.GIFT_CAT_NOT_BE_UPDATED, me.GIFT_GET_LIST_FAIL, me.CART_GET_LIST_FAIL, me.REMOVE_COUPON_FAIL, me.UNKNOWN_ERROR]
});
class Or extends Ct {
  constructor(t) {
    super(), this._errHandler = t;
  }
  // public async getCartData(): Promise<I.ICart> {
  //     try {
  //         const result = await api.getCartList();
  //         return result;
  //     }
  //     catch(error: unknown) {
  //         throw this._errHandler.handle(E.CART_GET_LIST_FAIL, error);
  //     }
  // }
  // public async removeCartItem(key: string): Promise<I.ICart> {
  //     try {
  //         const result = await api.removeCartItem(key);
  //         this.emit<I.ICart>(ICARTEVENT_TYPE.CART_MODIFIED, result);
  //         return result;
  //     }
  //     catch(error: unknown) {
  //         throw this._errHandler.handle(E.UNKNOWN_ERROR, error);
  //     }
  // }
  // public async updateCart(key: string, quantity: number): Promise<I.ICart> {
  //     try {
  //         const result = await api.updateCart(key, quantity);
  //         this.emit<I.ICart>(ICARTEVENT_TYPE.CART_MODIFIED, result);
  //         return result;
  //     }
  //     catch(error: unknown) {
  //         if((error as I.ICartError)?.detail?.code !== undefined) {
  //             switch((error as I.ICartError)?.detail.code) {
  //                 case 'PRODUCT_OUT_OF_STOCK':
  //                 case 'PRODUCT_STOCK_NOT_ENOUGH':
  //                 case 'PRODUCT_NOT_FOUND':
  //                 case 'PRODUCT_QUANTITY_ERROR':
  //                 case 'PARAMETER_ERROR':
  //                 case 'PRODUCT_NEED_VARIATION':
  //                 case 'ACTIVITY_NOT_VALID':
  //                 case 'ACTIVITY_CAN_NOT_CIRCLE':
  //                 case 'ACTIVITY_CONDITION_NOT_REACH':
  //                 case 'ACTIVITY_GIFT_MAX_LIMIT':
  //                 case 'PRODUCT_ONLY_INDIVIDUALLY_SALE':
  //                 case 'CART_IS_EMPTY':
  //                 case 'GIFT_CAT_NOT_BE_UPDATED':
  //                     throw this._errHandler.handle(E.GIFT_CAT_NOT_BE_UPDATED, error);
  //                 default:
  //                     throw this._errHandler.handle(E.UNKNOWN_ERROR, error);
  //             }
  //         }
  //         else {
  //             throw this._errHandler.handle(E.UNKNOWN_ERROR, error);
  //         }
  //     }
  // }
  async addToCartBatch(t, n, r, i) {
    try {
      const a = {
        products: t
      };
      return n && (a.recommendation = n), r && (a.gifts = r), i && (a.activity_id = i), (await ct.post("cart/batch?processed_data=1&no-mobile-redirection=1", a)).data;
    } catch (a) {
      throw this._getAddToCartError(a);
    }
  }
  _getAddToCartError(t) {
    var n, r;
    if (((n = t == null ? void 0 : t.detail) == null ? void 0 : n.code) !== void 0)
      switch ((r = t == null ? void 0 : t.detail) == null ? void 0 : r.code) {
        case "PRODUCT_STOCK_NOT_ENOUGH":
          return this._errHandler.handle(me.PRODUCT_OUT_OF_STOCK, t);
        case "PRODUCT_OUT_OF_STOCK":
        case "ACTIVITY_NOT_VALID":
        case "ACTIVITY_CONDITION_NOT_REACH":
        case "ACTIVITY_CAN_NOT_CIRCLE":
        case "ACTIVITY_GIFT_MAX_LIMIT":
        case "PRODUCT_NEED_VARIATION":
        case "PRODUCT_QUANTITY_ERROR":
        case "PRODUCT_NOT_FOUND":
        case "PRODUCT_ONLY_INDIVIDUALLY_SALE":
        case "PARAMETER_ERROR":
          return this._errHandler.handle(me.PARAMETER_ERROR, t);
        default:
          return this._errHandler.handle(me.NETWORK_ERROR, t);
      }
    else
      return this._errHandler.handle(me.UNKNOWN_ERROR, t);
  }
  // public async getGiftsForCart(): Promise<I.IGift> {
  //     try {
  //         const result = await api.getGiftsForCart();
  //         return result;
  //     }
  //     catch(error: unknown) {
  //         throw this._errHandler.handle(E.GIFT_GET_LIST_FAIL, error);
  //     }
  // }
  // public async removeCoupon(key: string, coupon: string): Promise<void> {
  //     try {
  //         await checkoutAPI.removeCoupon(key, coupon);
  //         this.emit(ICARTEVENT_TYPE.COUPON_REMOVE);
  //     }
  //     catch (error: unknown) {
  //         throw this._errHandler.handle(E.REMOVE_COUPON_FAIL, error);
  //     }
  // }
  // public async undoCartItem(key: string): Promise<I.ICart> {
  //     try {
  //         const result = await api.undoCartItem(key);
  //         this.emit<I.ICart>(ICARTEVENT_TYPE.CART_MODIFIED, result);
  //         return result;
  //     }
  //     catch (error: unknown) {
  //         throw this._errHandler.handle(E.UNKNOWN_ERROR, error);
  //     }
  // }
}
const di = new Or(Ar), Rt = {};
class Ze {
  constructor(t, n) {
    var i;
    this._productsData = [], this._userCountry = "US", n && (this._userCountry = n);
    const r = t ? t instanceof Array ? t : Object.values(t) : [];
    for (const a of r) {
      const s = (i = a.subversion) == null ? void 0 : i.products;
      s != null && s.length && (r.push(...s), a.subversion.products = []);
    }
    this._productsData = r;
  }
  async init() {
    et.inited || et.init();
    for (const t of this._productsData)
      t.defaultVariationKey || await this._handleData(t);
    for (const t of this._productsData)
      t.defaultVariationKey || this._handleVariations(t, pr());
  }
  get productsData() {
    return this._productsData;
  }
  getProductById(t) {
    for (const n of this._productsData)
      if (n.id === t)
        return n;
    return null;
  }
  getProductByKey(t) {
    for (const n of this._productsData)
      if (n.key === t)
        return n;
    return null;
  }
  getVariationByKey(t, n) {
    if (!t || t.simpleType || !t.children)
      return null;
    for (const r in t.children) {
      const i = t.children[r];
      if (i.key === n)
        return i;
    }
    return null;
  }
  // 处理价格折扣、库存状态、是否配件、自动coupon等
  async _handleData(t) {
    var i, a;
    if (!t)
      return;
    t.isAccessory = t.categories.filter((s) => s.key === "accessories").length > 0, t.isRefurbished = t.categories.filter((s) => s.key === "refurbished-cameras").length > 0, t.isCombination = !!((i = t.combinations) != null && i.length);
    const n = (a = t.activities) == null ? void 0 : a.lightningDeal;
    n && !(n instanceof Array) && !(n.autoCoupon instanceof Array) && (t.hasAutoCoupon = !0), this._handlePrice(t), await this._handleStockStatus(t), this._handleLimitedTime(t), this._handleSmartHome(t);
    const r = this._productsData.findIndex((s) => s.id === t.id);
    r !== -1 ? this._productsData.splice(r, 1, t) : this._productsData.push(t);
  }
  setDefaultVariation(t, n) {
    this._setDefaultVariation(t, n);
  }
  // 价格折扣信息
  _handlePrice(t) {
    const n = t.price;
    if (Number(n.regularPrice) && (t.hasPrice = !0, Number(n.regularPrice) && Number(n.currentPrice) < Number(n.regularPrice))) {
      const r = Number(n.regularPrice) - Number(n.currentPrice);
      if (n.discountType === "amount")
        t.discountOff = t.currency.symbol.replace("{}", r.toFixed(t.currency.precision));
      else {
        const i = Math.round(r / Number(n.regularPrice) * 100);
        t.discountOff = i ? `${i}%` : 0;
      }
    }
  }
  // 库存状态处理
  async _handleStockStatus(t) {
    var n, r, i;
    if (t.salePolicies.sellable)
      t.stock.status === at.COMING_SOON || !t.isAccessory && t.stock.status === at.LIMITED_SALE && t.stock.quantity === 0 || !t.hasPrice ? (t.isComingSoon = !0, this._handleNotSaleRecommendation(t)) : t.stock.status === at.OUT_OF_STOCK || (t.stock.status === at.IN_STOCK || t.stock.status === at.LIMITED_SALE || t.stock.status === at.PRE_ORDER) && t.stock.quantity === 0 ? (t.isOutOfStock = !0, this._handleNotSaleRecommendation(t)) : t.stock.status === at.PRE_ORDER && t.stock.quantity > 0 ? t.isPreOrder = !0 : t.stock.status === at.DISCONTINUED ? (t.isDiscontinued = !0, t.isInvisible = !0) : t.isInSale = !0;
    else {
      window && !((n = ge()) != null && n.aliexpressActivities) && await this.getAliexpressActivities();
      const a = (r = ge()) == null ? void 0 : r.aliexpressActivities;
      if ((i = a == null ? void 0 : a.products) != null && i.length) {
        const s = a.products.filter((c) => c.id === t.id)[0];
        if (s != null && s.link) {
          t.isAliExpress = !0, t.salePolicies.link = s.link;
          const c = a.aliExpress;
          c && Ft(c.notBefore, c.notAfter) && (t.salePolicies.aliPrice = s.price, t.salePolicies.aliSalePrice = s.salePrice, c.notes && (t.salePolicies.aliNote = c.notes));
        } else
          t.isOutOfStock = !0, this._handleNotSaleRecommendation(t);
      } else
        t.isOutOfStock = !0, this._handleNotSaleRecommendation(t);
    }
  }
  // 多版本的子版本处理
  _handleVariations(t, n) {
    this._filterVariations(t, n), this._setDefaultVariation(t);
  }
  // 筛选子版本
  _filterVariations(t, n) {
    var s;
    if (t.simpleType)
      return;
    t.children = {};
    const r = [], i = [];
    t.saleVariations = [];
    const a = t.subversion.versionProductIds;
    if (a != null && a.length) {
      for (const c of a) {
        const u = this.getProductById(c);
        u && (u.threeDModel = t.threeDModel, u.parent = {
          id: t.id,
          key: t.key
        }, t.children[c] = u, u.stock.status !== at.DISCONTINUED && r.push(c), (u.isInSale || u.isPreOrder) && t.saleVariations.push(c), ((s = u.activities) == null ? void 0 : s.distributor) instanceof Array || i.push(c));
      }
      t.subversion.versionProductIds = n ? i : r;
    }
  }
  _setDefaultVariation(t, n) {
    const r = Ze.getDefaultVariationProduct(t, this._productsData, n);
    t.children && n && (t.children[r.id] = r), t.defaultVariationKey = r.key, t.defaultVariationId = r.id;
  }
  /**
   * 获取产品的默认子版本
   * @param product 主版本/单版本产品
   * @param productData 产品列表
   * @param withRelatedProduct
   * @returns
   */
  static getDefaultVariationProduct(t, n, r) {
    var l, _, d, x;
    if (t.simpleType)
      return t;
    const i = (N) => {
      for (const I of n)
        if (I.id === N)
          return I;
      return null;
    }, a = Tr("attribute_pa_version"), s = (_ = (l = ge()) == null ? void 0 : l.document) == null ? void 0 : _.getElementsByTagName("body")[0].getAttribute("data-key");
    let c = 0, u, m, v, y, T, f, w, P, p, h, b, k;
    for (const N of t.subversion.versionProductIds) {
      const I = (d = t.children) == null ? void 0 : d[N];
      if (I) {
        if (s === t.key && a === I.version && (u = I), b || (b = I), I.isInSale || I.isPreOrder) {
          if (!m && I.stock.isLimited && (m = I), p || (p = I), I.discountOff) {
            const B = I.price;
            let ie = (Number(B.regularPrice) - Number(B.currentPrice)) / Number(B.regularPrice);
            ie = Number(ie), ie > c && (c = ie, P = I);
          }
        } else {
          if (!k && I.stock.outOfStockRecommendation) {
            const B = i(I.stock.outOfStockRecommendation.product);
            B && (k = B);
          }
          !h && I.isComingSoon && (h = I);
        }
        if (((x = t.subversion.defaultVersion) == null ? void 0 : x.id) === I.id)
          if (v = I, I.isInSale || I.isPreOrder)
            y = I, I.stock.isLimited && (f = I);
          else {
            if (I.stock.outOfStockRecommendation) {
              const B = i(I.stock.outOfStockRecommendation.product);
              B && (w = B);
            }
            I.isComingSoon && (T = I);
          }
      }
    }
    let C = t;
    return u ? C = u : f ? C = f : m ? C = m : y && !zt() ? C = y : P ? C = P : p ? C = p : r && w ? C = w : r && k ? C = k : T ? C = T : h ? C = h : v ? C = v : b && (C = b), C;
  }
  // 倒计时处理
  _handleLimitedTime(t) {
    var u, m;
    let n = 0, r = 0;
    const i = [], a = [], s = (u = t.activities) == null ? void 0 : u.lightningDeal;
    s && !(s instanceof Array) && (s.startAt && s.endAt && (i.push(s.startAt), a.push(s.endAt)), s.autoCoupon.startAt && s.autoCoupon.endAt && (i.push(s.autoCoupon.startAt), a.push(s.autoCoupon.endAt)), s.notAutoCoupon.startAt && s.notAutoCoupon.endAt && (i.push(s.notAutoCoupon.startAt), a.push(s.notAutoCoupon.endAt)));
    const c = (m = t.activities) == null ? void 0 : m.priceBreak;
    c && (i.push(c.startAt), a.push(c.endAt)), i.length > 0 && a.length > 0 ? (n = Math.min.apply(null, i), r = Math.min.apply(null, a), t.startTime = n, t.endTime = r) : (t.startTime = 0, t.endTime = 0);
  }
  // 不可售关联产品处理
  _handleNotSaleRecommendation(t) {
    const n = t.stock.outOfStockRecommendation;
    if (n) {
      const r = n.product, i = this.getProductById(r);
      i && (i.extraName = n.name, i.extraTip = n.note);
    }
  }
  // SmartHome处理
  _handleSmartHome(t) {
    var i, a;
    const n = (i = t.smartHome) == null ? void 0 : i.filter((s) => s.name === "Google Assistant")[0], r = (a = t.smartHome) == null ? void 0 : a.filter((s) => s.name === "Alexa")[0];
    n != null && n.isOnline && (n.country.includes("ALL") || n.country.includes(this._userCountry)) && (t.supportGoogleAssistant = !0), r != null && r.isOnline && (r.country.includes("ALL") || r.country.includes(this._userCountry)) && (t.supportAlexa = !0);
  }
  // 获取速卖通活动
  async getAliexpressActivities() {
    try {
      const t = await er();
      ge().aliexpressActivities = { ...t };
    } catch (t) {
      console.error(t);
    }
  }
}
class Lr {
  constructor() {
    this._giftActivities = {}, this._currency = {
      code: "USD",
      precision: 2,
      symbol: "{} US $"
    }, this._country = "";
  }
  get currency() {
    return this._currency;
  }
  get country() {
    return this._country;
  }
  set country(t) {
    t && (this._country = t);
  }
  // 获取满赠活动并进行分类（单品、组合、任意搭配、分类）
  async getGiftActivities(t, n) {
    var c, u;
    let r = [];
    const i = [], a = (c = t == null ? void 0 : t.activities) == null ? void 0 : c.giftActivity;
    if (t && a) {
      if (this._currency = { ...t.currency }, t.simpleType) {
        for (const m of a)
          if (!i.includes(m.id)) {
            if (n === "board" && !m.apply_area.includes("ad_banner"))
              continue;
            i.push(m.id);
          }
      } else
        for (const m in t.children) {
          const y = (u = t.children[m].activities) == null ? void 0 : u.giftActivity;
          if (y) {
            for (const T of y)
              if (!i.includes(T.id)) {
                if (n === "board" && !T.apply_area.includes("ad_banner"))
                  continue;
                i.push(T.id);
              }
          }
        }
      this._giftActivities[t.id] ? r = this._giftActivities[t.id] : (r = await En(i.join(",")), this._giftActivities[t.id] = r);
    } else if (n === "flash-sale") {
      const m = await Ji(!0), v = [...m.multiple, ...m.single];
      r = await En(v.join(","), !0);
      const y = await or();
      this._currency = {
        code: y.me.currency ?? "USD",
        precision: y.me.currencyPrecision ?? 2,
        symbol: y.me.currencySymbol ?? "{} US $"
      };
    }
    return this._classifyGiftActivities(r);
  }
  _classifyGiftActivities(t) {
    const n = {
      single: [],
      bundle: [],
      random: [],
      category: []
    };
    if (!(t != null && t.length))
      return n;
    for (const r of t) {
      const i = [];
      r.handled_products = [], r.handled_gift_products = [];
      for (const c of r.products) {
        const u = c.product_id;
        i.includes(u) || (r.handled_products.push(
          r.products.filter((y) => y.product_id === u)
        ), i.push(u));
        const m = Number(c.regular_price), v = Number(c.price);
        c.discount_percentage = Math.round((m - v) * 100 / m);
      }
      const a = [];
      for (const c of r.gift_products) {
        const u = c.product_id;
        a.includes(u) || (r.handled_gift_products.push(
          r.gift_products.filter((y) => y.product_id === u)
        ), a.push(u));
        const m = Number(c.regular_price), v = Number(c.price);
        c.discount_percentage = Math.round((m - v) * 100 / m);
      }
      const s = r.gift_products.map((c) => c.discount_percentage);
      if (r.gifts_max_discount = Math.max(...s), r.gifts_same_discount = s.filter((c) => c === r.gifts_max_discount).length === s.length, r.product_condition === Bt.OR)
        if (r.product_categories.length)
          r.type = "category", n.category.push(r);
        else {
          let c = r.products.map((u) => u.product_id);
          c = Array.from(new Set(c)), c.length === 1 ? (r.single_condition = !0, r.products[0].combinations.length ? (r.type = "bundle", n.bundle.push(r)) : (r.type = "single", n.single.push(r))) : (r.type = "random", n.random.push(r));
        }
      else {
        r.type = "bundle", n.bundle.push(r);
        let c = r.products.map((u) => u.product_id);
        c = Array.from(new Set(c)), c.length === 1 && (r.single_condition = !0);
      }
    }
    return n;
  }
}
const jt = new Lr();
class Dr {
  async getPaypalSdk(t) {
    var n;
    return this._paypalSdk || (await this.getPaypalConfig(t), await this.loadPaypalSdk()), (n = ge()) == null ? void 0 : n.paypal;
  }
  async getPaypalConfig(t) {
    if (!this._paypalConfig) {
      const r = (await rr({ ...t })).payment.paypal;
      this._paypalConfig = r;
    }
    return this._paypalConfig;
  }
  async loadPaypalSdk() {
    const t = {
      "client-id": this._paypalConfig.payPalClientId,
      currency: this._paypalConfig.currency,
      components: "messages"
    }, n = "https://www.paypal.com/sdk/js", r = document.createElement("script");
    return r.setAttribute("type", "text/javascript"), r.setAttribute("defer", "defer"), r.src = `${n}?${_r(t)}`, document.body.append(r), new Promise((i, a) => {
      r.onload = () => {
        i();
      }, r.onerror = () => {
        a();
      };
    });
  }
}
const Dn = new Dr();
const fi = Ie((e) => {
  var m, v, y, T, f;
  const { include: t } = e, [n, r] = M();
  ne(() => {
    (async () => {
      const w = new Ze(e.productsData, e.country);
      await w.init(), r(w);
    })().catch(console.error);
  }, [e]);
  const i = F(() => n ? n.getProductByKey(e.productKey) : null, [n, e]), a = F(() => {
    if (i != null && i.simpleType)
      return i;
    {
      if (!(i != null && i.children))
        return null;
      const w = e.currentVariationKey ? e.currentVariationKey : i.defaultVariationKey;
      for (const P in i.children) {
        const p = i.children[P];
        if (p.key === w)
          return p;
      }
      return null;
    }
  }, [i, e]), s = F(() => (a == null ? void 0 : a.isInSale) ?? (a == null ? void 0 : a.isPreOrder), [a]), c = F(() => {
    var w, P;
    if (i && !i.salePolicies.sellable) {
      const p = (P = (w = ge()) == null ? void 0 : w.aliexpressActivities) == null ? void 0 : P.products;
      if (p != null && p.length) {
        const h = p.filter((b) => b.id === i.id)[0];
        if (h != null && h.link)
          return !0;
      }
    }
    return !1;
  }, [i]), u = V((w) => {
    w == null || w.stopPropagation(), window.location.href = i == null ? void 0 : i.salePolicies.link;
  }, [i]);
  return a ? /* @__PURE__ */ S("div", { className: "reo-product-tags", children: [
    t.includes("deals") && s ? /* @__PURE__ */ o("span", { className: "product-tag tag-deals", children: (m = e.langPack) == null ? void 0 : m["reo-product"].deals }) : null,
    t.includes("sale") && s && a.discountOff ? /* @__PURE__ */ o("span", { className: "product-tag tag-sale", children: (v = e.langPack) == null ? void 0 : v["reo-product"].sale }) : null,
    t.includes("pre-order") && a.isPreOrder ? /* @__PURE__ */ o("span", { className: "product-tag tag-pre-order", children: (y = e.langPack) == null ? void 0 : y["reo-product"].pre_order }) : null,
    t.includes("discount") && s && a.discountOff ? /* @__PURE__ */ o("span", { className: "product-tag tag-discount", children: (f = (T = e.langPack) == null ? void 0 : T["reo-product"].$1_off) == null ? void 0 : f.replace("$1", a.discountOff.toString()) }) : null,
    t.includes("aliexpress") && c ? /* @__PURE__ */ o(
      "img",
      {
        src: Tt("/wp-content/assets/aliexpress-icon.png"),
        className: "tag-aliexpress",
        onClick: u
      }
    ) : null
  ] }) : null;
}), fn = Ie((e) => {
  const t = F(() => e.productData, [e]), n = F(() => {
    if (!t)
      return null;
    if (t.simpleType)
      return t;
    const c = e.currentVariationKey ? e.currentVariationKey : t == null ? void 0 : t.defaultVariationKey;
    for (const u in t.children) {
      const m = t.children[u];
      if (m.key === c)
        return m;
    }
    return null;
  }, [e, t]), r = F(() => {
    var c;
    return t != null && t.isCombination ? /* @__PURE__ */ o("ul", { className: "name-list", children: (c = t.combinations) == null ? void 0 : c.map((u) => {
      var m;
      return /* @__PURE__ */ S("li", { children: [
        /* @__PURE__ */ o("span", { className: "product-name font-medium", children: u.parent }),
        /* @__PURE__ */ o("span", { className: "product-version font-normal", children: (m = e.langPack) == null ? void 0 : m["product-versions"][u.version] }),
        /* @__PURE__ */ S("span", { className: "product-amount font-medium", children: [
          "x ",
          u.amount
        ] })
      ] }, u.id);
    }) }) : null;
  }, [t, e]), i = F(() => {
    var c;
    return (c = e.attributeTags) != null && c.length ? /* @__PURE__ */ o("ul", { className: "product-attribute-tag", children: e.attributeTags.map((u) => /* @__PURE__ */ o(
      "li",
      {
        className: "product-attribute-tag-item",
        children: u
      },
      u
    )) }) : null;
  }, [e.attributeTags]), a = F(() => {
    var m, v;
    let c = (t == null ? void 0 : t.name) ?? "", u = (t == null ? void 0 : t.href) ?? "";
    return e.useExtraName ? t != null && t.extraName ? c = t.extraName : t != null && t.isCombination && (c = (m = e.langPack) == null ? void 0 : m["reo-product"]["security-kit"]) : e.useVariationName && n ? (c = n.name, u = n.href) : e.useVersionText && n && (c = (v = e.langPack) == null ? void 0 : v["product-versions"][n.version], u = n.href), /* @__PURE__ */ S("div", { className: "product-name", children: [
      !(t != null && t.isCombination) && e.nameWithLink && u && !Yt(u) ? /* @__PURE__ */ o("a", { href: It(u), children: c }) : /* @__PURE__ */ o("span", { dangerouslySetInnerHTML: { __html: c } }),
      t != null && t.isCombination && !e.combinationNoBalloon ? /* @__PURE__ */ o(
        Lt,
        {
          type: "multiLine",
          placement: Dt.TOP_CENTER,
          content: r,
          trigger: "hover",
          className: "ml-6 text-0 inline-block",
          contentClassName: "z-1000 name-balloon",
          children: /* @__PURE__ */ o(
            st,
            {
              name: "icon-icon_question",
              width: "16px",
              color: "#777"
            }
          )
        }
      ) : null
    ] });
  }, [t, n, r, e]), s = F(() => {
    var m;
    const c = t == null ? void 0 : t.profile, u = e.featuresQty ?? 4;
    return /* @__PURE__ */ S("div", { className: "description-content", children: [
      !e.hideDescription && (c != null && c.description) ? /* @__PURE__ */ o(
        "p",
        {
          className: "product-description",
          dangerouslySetInnerHTML: { __html: c.description }
        }
      ) : null,
      e.showFeatures && (c != null && c.features.length) ? /* @__PURE__ */ o("ul", { className: "feature-list", children: c.features.map((v, y) => y < u && v ? /* @__PURE__ */ o("li", { children: v }, y) : null) }) : null,
      e.hasExtraLink && t && !Yt(t.href) ? /* @__PURE__ */ o(
        gn,
        {
          href: It(t.href),
          target: "_blank",
          icon: "icon-icon_arrow-right",
          className: "product-link",
          color: "#0E6AFF",
          iconColor: "#0E6AFF",
          children: (m = e.langPack) == null ? void 0 : m.common["learn-more"]
        }
      ) : null
    ] });
  }, [t, e]);
  return !n || !t ? null : /* @__PURE__ */ S("div", { className: "product-des-content", children: [
    i,
    a,
    s
  ] });
});
var mi = {}, tn = {}, Qt = {}, Mr = {
  get exports() {
    return Qt;
  },
  set exports(e) {
    Qt = e;
  }
}, Xt = {}, Fr = {
  get exports() {
    return Xt;
  },
  set exports(e) {
    Xt = e;
  }
}, Ne = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Mn;
function Br() {
  return Mn || (Mn = 1, function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, s = e ? Symbol.for("react.provider") : 60109, c = e ? Symbol.for("react.context") : 60110, u = e ? Symbol.for("react.async_mode") : 60111, m = e ? Symbol.for("react.concurrent_mode") : 60111, v = e ? Symbol.for("react.forward_ref") : 60112, y = e ? Symbol.for("react.suspense") : 60113, T = e ? Symbol.for("react.suspense_list") : 60120, f = e ? Symbol.for("react.memo") : 60115, w = e ? Symbol.for("react.lazy") : 60116, P = e ? Symbol.for("react.block") : 60121, p = e ? Symbol.for("react.fundamental") : 60117, h = e ? Symbol.for("react.responder") : 60118, b = e ? Symbol.for("react.scope") : 60119;
    function k(K) {
      return typeof K == "string" || typeof K == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      K === r || K === m || K === a || K === i || K === y || K === T || typeof K == "object" && K !== null && (K.$$typeof === w || K.$$typeof === f || K.$$typeof === s || K.$$typeof === c || K.$$typeof === v || K.$$typeof === p || K.$$typeof === h || K.$$typeof === b || K.$$typeof === P);
    }
    function C(K) {
      if (typeof K == "object" && K !== null) {
        var pe = K.$$typeof;
        switch (pe) {
          case t:
            var oe = K.type;
            switch (oe) {
              case u:
              case m:
              case r:
              case a:
              case i:
              case y:
                return oe;
              default:
                var Ue = oe && oe.$$typeof;
                switch (Ue) {
                  case c:
                  case v:
                  case w:
                  case f:
                  case s:
                    return Ue;
                  default:
                    return pe;
                }
            }
          case n:
            return pe;
        }
      }
    }
    var l = u, _ = m, d = c, x = s, N = t, I = v, B = r, ie = w, X = f, se = n, Q = a, ve = i, ye = y, ue = !1;
    function _e(K) {
      return ue || (ue = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), E(K) || C(K) === u;
    }
    function E(K) {
      return C(K) === m;
    }
    function $(K) {
      return C(K) === c;
    }
    function ce(K) {
      return C(K) === s;
    }
    function Z(K) {
      return typeof K == "object" && K !== null && K.$$typeof === t;
    }
    function R(K) {
      return C(K) === v;
    }
    function O(K) {
      return C(K) === r;
    }
    function L(K) {
      return C(K) === w;
    }
    function z(K) {
      return C(K) === f;
    }
    function W(K) {
      return C(K) === n;
    }
    function q(K) {
      return C(K) === a;
    }
    function Y(K) {
      return C(K) === i;
    }
    function re(K) {
      return C(K) === y;
    }
    Ne.AsyncMode = l, Ne.ConcurrentMode = _, Ne.ContextConsumer = d, Ne.ContextProvider = x, Ne.Element = N, Ne.ForwardRef = I, Ne.Fragment = B, Ne.Lazy = ie, Ne.Memo = X, Ne.Portal = se, Ne.Profiler = Q, Ne.StrictMode = ve, Ne.Suspense = ye, Ne.isAsyncMode = _e, Ne.isConcurrentMode = E, Ne.isContextConsumer = $, Ne.isContextProvider = ce, Ne.isElement = Z, Ne.isForwardRef = R, Ne.isFragment = O, Ne.isLazy = L, Ne.isMemo = z, Ne.isPortal = W, Ne.isProfiler = q, Ne.isStrictMode = Y, Ne.isSuspense = re, Ne.isValidElementType = k, Ne.typeOf = C;
  }()), Ne;
}
var Fn;
function hi() {
  return Fn || (Fn = 1, function(e) {
    e.exports = Br();
  }(Fr)), Xt;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var nn, Bn;
function Vr() {
  if (Bn)
    return nn;
  Bn = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(a) {
    if (a == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(a);
  }
  function i() {
    try {
      if (!Object.assign)
        return !1;
      var a = new String("abc");
      if (a[5] = "de", Object.getOwnPropertyNames(a)[0] === "5")
        return !1;
      for (var s = {}, c = 0; c < 10; c++)
        s["_" + String.fromCharCode(c)] = c;
      var u = Object.getOwnPropertyNames(s).map(function(v) {
        return s[v];
      });
      if (u.join("") !== "0123456789")
        return !1;
      var m = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(v) {
        m[v] = v;
      }), Object.keys(Object.assign({}, m)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return nn = i() ? Object.assign : function(a, s) {
    for (var c, u = r(a), m, v = 1; v < arguments.length; v++) {
      c = Object(arguments[v]);
      for (var y in c)
        t.call(c, y) && (u[y] = c[y]);
      if (e) {
        m = e(c);
        for (var T = 0; T < m.length; T++)
          n.call(c, m[T]) && (u[m[T]] = c[m[T]]);
      }
    }
    return u;
  }, nn;
}
var rn, Vn;
function gi() {
  if (Vn)
    return rn;
  Vn = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return rn = e, rn;
}
var on, $n;
function yi() {
  return $n || ($n = 1, on = Function.call.bind(Object.prototype.hasOwnProperty)), on;
}
var an, Kn;
function $r() {
  if (Kn)
    return an;
  Kn = 1;
  var e = function() {
  };
  {
    var t = gi(), n = {}, r = yi();
    e = function(a) {
      var s = "Warning: " + a;
      typeof console < "u" && console.error(s);
      try {
        throw new Error(s);
      } catch {
      }
    };
  }
  function i(a, s, c, u, m) {
    for (var v in a)
      if (r(a, v)) {
        var y;
        try {
          if (typeof a[v] != "function") {
            var T = Error(
              (u || "React class") + ": " + c + " type `" + v + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof a[v] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
            );
            throw T.name = "Invariant Violation", T;
          }
          y = a[v](s, v, u, c, null, t);
        } catch (w) {
          y = w;
        }
        if (y && !(y instanceof Error) && e(
          (u || "React class") + ": type specification of " + c + " `" + v + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof y + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
        ), y instanceof Error && !(y.message in n)) {
          n[y.message] = !0;
          var f = m ? m() : "";
          e(
            "Failed " + c + " type: " + y.message + (f ?? "")
          );
        }
      }
  }
  return i.resetWarningCache = function() {
    n = {};
  }, an = i, an;
}
var sn, Un;
function Kr() {
  if (Un)
    return sn;
  Un = 1;
  var e = hi(), t = Vr(), n = gi(), r = yi(), i = $r(), a = function() {
  };
  a = function(c) {
    var u = "Warning: " + c;
    typeof console < "u" && console.error(u);
    try {
      throw new Error(u);
    } catch {
    }
  };
  function s() {
    return null;
  }
  return sn = function(c, u) {
    var m = typeof Symbol == "function" && Symbol.iterator, v = "@@iterator";
    function y(E) {
      var $ = E && (m && E[m] || E[v]);
      if (typeof $ == "function")
        return $;
    }
    var T = "<<anonymous>>", f = {
      array: h("array"),
      bigint: h("bigint"),
      bool: h("boolean"),
      func: h("function"),
      number: h("number"),
      object: h("object"),
      string: h("string"),
      symbol: h("symbol"),
      any: b(),
      arrayOf: k,
      element: C(),
      elementType: l(),
      instanceOf: _,
      node: I(),
      objectOf: x,
      oneOf: d,
      oneOfType: N,
      shape: ie,
      exact: X
    };
    function w(E, $) {
      return E === $ ? E !== 0 || 1 / E === 1 / $ : E !== E && $ !== $;
    }
    function P(E, $) {
      this.message = E, this.data = $ && typeof $ == "object" ? $ : {}, this.stack = "";
    }
    P.prototype = Error.prototype;
    function p(E) {
      var $ = {}, ce = 0;
      function Z(O, L, z, W, q, Y, re) {
        if (W = W || T, Y = Y || z, re !== n) {
          if (u) {
            var K = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw K.name = "Invariant Violation", K;
          } else if (typeof console < "u") {
            var pe = W + ":" + z;
            !$[pe] && // Avoid spamming the console because they are often not actionable except for lib authors
            ce < 3 && (a(
              "You are manually calling a React.PropTypes validation function for the `" + Y + "` prop on `" + W + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), $[pe] = !0, ce++);
          }
        }
        return L[z] == null ? O ? L[z] === null ? new P("The " + q + " `" + Y + "` is marked as required " + ("in `" + W + "`, but its value is `null`.")) : new P("The " + q + " `" + Y + "` is marked as required in " + ("`" + W + "`, but its value is `undefined`.")) : null : E(L, z, W, q, Y);
      }
      var R = Z.bind(null, !1);
      return R.isRequired = Z.bind(null, !0), R;
    }
    function h(E) {
      function $(ce, Z, R, O, L, z) {
        var W = ce[Z], q = ve(W);
        if (q !== E) {
          var Y = ye(W);
          return new P(
            "Invalid " + O + " `" + L + "` of type " + ("`" + Y + "` supplied to `" + R + "`, expected ") + ("`" + E + "`."),
            { expectedType: E }
          );
        }
        return null;
      }
      return p($);
    }
    function b() {
      return p(s);
    }
    function k(E) {
      function $(ce, Z, R, O, L) {
        if (typeof E != "function")
          return new P("Property `" + L + "` of component `" + R + "` has invalid PropType notation inside arrayOf.");
        var z = ce[Z];
        if (!Array.isArray(z)) {
          var W = ve(z);
          return new P("Invalid " + O + " `" + L + "` of type " + ("`" + W + "` supplied to `" + R + "`, expected an array."));
        }
        for (var q = 0; q < z.length; q++) {
          var Y = E(z, q, R, O, L + "[" + q + "]", n);
          if (Y instanceof Error)
            return Y;
        }
        return null;
      }
      return p($);
    }
    function C() {
      function E($, ce, Z, R, O) {
        var L = $[ce];
        if (!c(L)) {
          var z = ve(L);
          return new P("Invalid " + R + " `" + O + "` of type " + ("`" + z + "` supplied to `" + Z + "`, expected a single ReactElement."));
        }
        return null;
      }
      return p(E);
    }
    function l() {
      function E($, ce, Z, R, O) {
        var L = $[ce];
        if (!e.isValidElementType(L)) {
          var z = ve(L);
          return new P("Invalid " + R + " `" + O + "` of type " + ("`" + z + "` supplied to `" + Z + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return p(E);
    }
    function _(E) {
      function $(ce, Z, R, O, L) {
        if (!(ce[Z] instanceof E)) {
          var z = E.name || T, W = _e(ce[Z]);
          return new P("Invalid " + O + " `" + L + "` of type " + ("`" + W + "` supplied to `" + R + "`, expected ") + ("instance of `" + z + "`."));
        }
        return null;
      }
      return p($);
    }
    function d(E) {
      if (!Array.isArray(E))
        return arguments.length > 1 ? a(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : a("Invalid argument supplied to oneOf, expected an array."), s;
      function $(ce, Z, R, O, L) {
        for (var z = ce[Z], W = 0; W < E.length; W++)
          if (w(z, E[W]))
            return null;
        var q = JSON.stringify(E, function(re, K) {
          var pe = ye(K);
          return pe === "symbol" ? String(K) : K;
        });
        return new P("Invalid " + O + " `" + L + "` of value `" + String(z) + "` " + ("supplied to `" + R + "`, expected one of " + q + "."));
      }
      return p($);
    }
    function x(E) {
      function $(ce, Z, R, O, L) {
        if (typeof E != "function")
          return new P("Property `" + L + "` of component `" + R + "` has invalid PropType notation inside objectOf.");
        var z = ce[Z], W = ve(z);
        if (W !== "object")
          return new P("Invalid " + O + " `" + L + "` of type " + ("`" + W + "` supplied to `" + R + "`, expected an object."));
        for (var q in z)
          if (r(z, q)) {
            var Y = E(z, q, R, O, L + "." + q, n);
            if (Y instanceof Error)
              return Y;
          }
        return null;
      }
      return p($);
    }
    function N(E) {
      if (!Array.isArray(E))
        return a("Invalid argument supplied to oneOfType, expected an instance of array."), s;
      for (var $ = 0; $ < E.length; $++) {
        var ce = E[$];
        if (typeof ce != "function")
          return a(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + ue(ce) + " at index " + $ + "."
          ), s;
      }
      function Z(R, O, L, z, W) {
        for (var q = [], Y = 0; Y < E.length; Y++) {
          var re = E[Y], K = re(R, O, L, z, W, n);
          if (K == null)
            return null;
          K.data && r(K.data, "expectedType") && q.push(K.data.expectedType);
        }
        var pe = q.length > 0 ? ", expected one of type [" + q.join(", ") + "]" : "";
        return new P("Invalid " + z + " `" + W + "` supplied to " + ("`" + L + "`" + pe + "."));
      }
      return p(Z);
    }
    function I() {
      function E($, ce, Z, R, O) {
        return se($[ce]) ? null : new P("Invalid " + R + " `" + O + "` supplied to " + ("`" + Z + "`, expected a ReactNode."));
      }
      return p(E);
    }
    function B(E, $, ce, Z, R) {
      return new P(
        (E || "React class") + ": " + $ + " type `" + ce + "." + Z + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + R + "`."
      );
    }
    function ie(E) {
      function $(ce, Z, R, O, L) {
        var z = ce[Z], W = ve(z);
        if (W !== "object")
          return new P("Invalid " + O + " `" + L + "` of type `" + W + "` " + ("supplied to `" + R + "`, expected `object`."));
        for (var q in E) {
          var Y = E[q];
          if (typeof Y != "function")
            return B(R, O, L, q, ye(Y));
          var re = Y(z, q, R, O, L + "." + q, n);
          if (re)
            return re;
        }
        return null;
      }
      return p($);
    }
    function X(E) {
      function $(ce, Z, R, O, L) {
        var z = ce[Z], W = ve(z);
        if (W !== "object")
          return new P("Invalid " + O + " `" + L + "` of type `" + W + "` " + ("supplied to `" + R + "`, expected `object`."));
        var q = t({}, ce[Z], E);
        for (var Y in q) {
          var re = E[Y];
          if (r(E, Y) && typeof re != "function")
            return B(R, O, L, Y, ye(re));
          if (!re)
            return new P(
              "Invalid " + O + " `" + L + "` key `" + Y + "` supplied to `" + R + "`.\nBad object: " + JSON.stringify(ce[Z], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(E), null, "  ")
            );
          var K = re(z, Y, R, O, L + "." + Y, n);
          if (K)
            return K;
        }
        return null;
      }
      return p($);
    }
    function se(E) {
      switch (typeof E) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !E;
        case "object":
          if (Array.isArray(E))
            return E.every(se);
          if (E === null || c(E))
            return !0;
          var $ = y(E);
          if ($) {
            var ce = $.call(E), Z;
            if ($ !== E.entries) {
              for (; !(Z = ce.next()).done; )
                if (!se(Z.value))
                  return !1;
            } else
              for (; !(Z = ce.next()).done; ) {
                var R = Z.value;
                if (R && !se(R[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function Q(E, $) {
      return E === "symbol" ? !0 : $ ? $["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && $ instanceof Symbol : !1;
    }
    function ve(E) {
      var $ = typeof E;
      return Array.isArray(E) ? "array" : E instanceof RegExp ? "object" : Q($, E) ? "symbol" : $;
    }
    function ye(E) {
      if (typeof E > "u" || E === null)
        return "" + E;
      var $ = ve(E);
      if ($ === "object") {
        if (E instanceof Date)
          return "date";
        if (E instanceof RegExp)
          return "regexp";
      }
      return $;
    }
    function ue(E) {
      var $ = ye(E);
      switch ($) {
        case "array":
        case "object":
          return "an " + $;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + $;
        default:
          return $;
      }
    }
    function _e(E) {
      return !E.constructor || !E.constructor.name ? T : E.constructor.name;
    }
    return f.checkPropTypes = i, f.resetWarningCache = i.resetWarningCache, f.PropTypes = f, f;
  }, sn;
}
var zn;
function Ur() {
  if (zn)
    return Qt;
  zn = 1;
  {
    var e = hi(), t = !0;
    Mr.exports = Kr()(e.isElement, t);
  }
  return Qt;
}
var jn;
function zr() {
  return jn || (jn = 1, function(e) {
    (function(t, n) {
      n(e, j, Ur());
    })(oi, function(t, n, r) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.setHasSupportToCaptureOption = w;
      var i = s(n), a = s(r);
      function s(b) {
        return b && b.__esModule ? b : {
          default: b
        };
      }
      var c = Object.assign || function(b) {
        for (var k = 1; k < arguments.length; k++) {
          var C = arguments[k];
          for (var l in C)
            Object.prototype.hasOwnProperty.call(C, l) && (b[l] = C[l]);
        }
        return b;
      };
      function u(b, k) {
        var C = {};
        for (var l in b)
          k.indexOf(l) >= 0 || Object.prototype.hasOwnProperty.call(b, l) && (C[l] = b[l]);
        return C;
      }
      function m(b, k) {
        if (!(b instanceof k))
          throw new TypeError("Cannot call a class as a function");
      }
      var v = function() {
        function b(k, C) {
          for (var l = 0; l < C.length; l++) {
            var _ = C[l];
            _.enumerable = _.enumerable || !1, _.configurable = !0, "value" in _ && (_.writable = !0), Object.defineProperty(k, _.key, _);
          }
        }
        return function(k, C, l) {
          return C && b(k.prototype, C), l && b(k, l), k;
        };
      }();
      function y(b, k) {
        if (!b)
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return k && (typeof k == "object" || typeof k == "function") ? k : b;
      }
      function T(b, k) {
        if (typeof k != "function" && k !== null)
          throw new TypeError("Super expression must either be null or a function, not " + typeof k);
        b.prototype = Object.create(k && k.prototype, {
          constructor: {
            value: b,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), k && (Object.setPrototypeOf ? Object.setPrototypeOf(b, k) : b.__proto__ = k);
      }
      var f = !1;
      function w(b) {
        f = b;
      }
      try {
        addEventListener("test", null, Object.defineProperty({}, "capture", { get: function() {
          w(!0);
        } }));
      } catch {
      }
      function P() {
        var b = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : { capture: !0 };
        return f ? b : !1;
      }
      function p(b) {
        if ("touches" in b) {
          var k = b.touches[0], C = k.pageX, l = k.pageY;
          return { x: C, y: l };
        }
        var _ = b.screenX, d = b.screenY;
        return { x: _, y: d };
      }
      var h = function(b) {
        T(k, b);
        function k() {
          var C;
          m(this, k);
          for (var l = arguments.length, _ = Array(l), d = 0; d < l; d++)
            _[d] = arguments[d];
          var x = y(this, (C = k.__proto__ || Object.getPrototypeOf(k)).call.apply(C, [this].concat(_)));
          return x._handleSwipeStart = x._handleSwipeStart.bind(x), x._handleSwipeMove = x._handleSwipeMove.bind(x), x._handleSwipeEnd = x._handleSwipeEnd.bind(x), x._onMouseDown = x._onMouseDown.bind(x), x._onMouseMove = x._onMouseMove.bind(x), x._onMouseUp = x._onMouseUp.bind(x), x._setSwiperRef = x._setSwiperRef.bind(x), x;
        }
        return v(k, [{
          key: "componentDidMount",
          value: function() {
            this.swiper && this.swiper.addEventListener("touchmove", this._handleSwipeMove, P({
              capture: !0,
              passive: !1
            }));
          }
        }, {
          key: "componentWillUnmount",
          value: function() {
            this.swiper && this.swiper.removeEventListener("touchmove", this._handleSwipeMove, P({
              capture: !0,
              passive: !1
            }));
          }
        }, {
          key: "_onMouseDown",
          value: function(l) {
            this.props.allowMouseEvents && (this.mouseDown = !0, document.addEventListener("mouseup", this._onMouseUp), document.addEventListener("mousemove", this._onMouseMove), this._handleSwipeStart(l));
          }
        }, {
          key: "_onMouseMove",
          value: function(l) {
            this.mouseDown && this._handleSwipeMove(l);
          }
        }, {
          key: "_onMouseUp",
          value: function(l) {
            this.mouseDown = !1, document.removeEventListener("mouseup", this._onMouseUp), document.removeEventListener("mousemove", this._onMouseMove), this._handleSwipeEnd(l);
          }
        }, {
          key: "_handleSwipeStart",
          value: function(l) {
            var _ = p(l), d = _.x, x = _.y;
            this.moveStart = { x: d, y: x }, this.props.onSwipeStart(l);
          }
        }, {
          key: "_handleSwipeMove",
          value: function(l) {
            if (this.moveStart) {
              var _ = p(l), d = _.x, x = _.y, N = d - this.moveStart.x, I = x - this.moveStart.y;
              this.moving = !0;
              var B = this.props.onSwipeMove({
                x: N,
                y: I
              }, l);
              B && l.cancelable && l.preventDefault(), this.movePosition = { deltaX: N, deltaY: I };
            }
          }
        }, {
          key: "_handleSwipeEnd",
          value: function(l) {
            this.props.onSwipeEnd(l);
            var _ = this.props.tolerance;
            this.moving && this.movePosition && (this.movePosition.deltaX < -_ ? this.props.onSwipeLeft(1, l) : this.movePosition.deltaX > _ && this.props.onSwipeRight(1, l), this.movePosition.deltaY < -_ ? this.props.onSwipeUp(1, l) : this.movePosition.deltaY > _ && this.props.onSwipeDown(1, l)), this.moveStart = null, this.moving = !1, this.movePosition = null;
          }
        }, {
          key: "_setSwiperRef",
          value: function(l) {
            this.swiper = l, this.props.innerRef(l);
          }
        }, {
          key: "render",
          value: function() {
            var l = this.props;
            l.tagName;
            var _ = l.className, d = l.style, x = l.children;
            l.allowMouseEvents, l.onSwipeUp, l.onSwipeDown, l.onSwipeLeft, l.onSwipeRight, l.onSwipeStart, l.onSwipeMove, l.onSwipeEnd, l.innerRef, l.tolerance;
            var N = u(l, ["tagName", "className", "style", "children", "allowMouseEvents", "onSwipeUp", "onSwipeDown", "onSwipeLeft", "onSwipeRight", "onSwipeStart", "onSwipeMove", "onSwipeEnd", "innerRef", "tolerance"]);
            return i.default.createElement(
              this.props.tagName,
              c({
                ref: this._setSwiperRef,
                onMouseDown: this._onMouseDown,
                onTouchStart: this._handleSwipeStart,
                onTouchEnd: this._handleSwipeEnd,
                className: _,
                style: d
              }, N),
              x
            );
          }
        }]), k;
      }(n.Component);
      h.displayName = "ReactSwipe", h.propTypes = {
        tagName: a.default.string,
        className: a.default.string,
        style: a.default.object,
        children: a.default.node,
        allowMouseEvents: a.default.bool,
        onSwipeUp: a.default.func,
        onSwipeDown: a.default.func,
        onSwipeLeft: a.default.func,
        onSwipeRight: a.default.func,
        onSwipeStart: a.default.func,
        onSwipeMove: a.default.func,
        onSwipeEnd: a.default.func,
        innerRef: a.default.func,
        tolerance: a.default.number.isRequired
      }, h.defaultProps = {
        tagName: "div",
        allowMouseEvents: !1,
        onSwipeUp: function() {
        },
        onSwipeDown: function() {
        },
        onSwipeLeft: function() {
        },
        onSwipeRight: function() {
        },
        onSwipeStart: function() {
        },
        onSwipeMove: function() {
        },
        onSwipeEnd: function() {
        },
        innerRef: function() {
        },
        tolerance: 0
      }, t.default = h;
    });
  }(tn)), tn;
}
(function(e) {
  (function(t, n) {
    n(e, zr());
  })(oi, function(t, n) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = i(n);
    function i(a) {
      return a && a.__esModule ? a : {
        default: a
      };
    }
    t.default = r.default;
  });
})(mi);
const jr = /* @__PURE__ */ Wi(mi);
var mn = {}, Wr = {
  get exports() {
    return mn;
  },
  set exports(e) {
    mn = e;
  }
};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function n() {
      for (var r = [], i = 0; i < arguments.length; i++) {
        var a = arguments[i];
        if (a) {
          var s = typeof a;
          if (s === "string" || s === "number")
            r.push(a);
          else if (Array.isArray(a)) {
            if (a.length) {
              var c = n.apply(null, a);
              c && r.push(c);
            }
          } else if (s === "object") {
            if (a.toString !== Object.prototype.toString && !a.toString.toString().includes("[native code]")) {
              r.push(a.toString());
              continue;
            }
            for (var u in a)
              t.call(a, u) && a[u] && r.push(u);
          }
        }
      }
      return r.join(" ");
    }
    e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
  })();
})(Wr);
const Re = mn, Ge = {
  root: (e) => Re({
    "carousel-root": !0,
    [e ?? ""]: !!e
  }),
  carousel: (e) => Re({
    carousel: !0,
    "carousel-slider": e
  }),
  wrapper: (e, t) => Re({
    "thumbs-wrapper m-20 overflow-hidden": !e,
    "slider-wrapper": e,
    "axis-horizontal": t === "horizontal",
    "axis-vertical": t !== "horizontal"
  }),
  slider: (e, t) => Re({
    thumbs: !e,
    "slider-wrap": e,
    animated: !t
  }),
  item: (e, t, n) => Re({
    thumb: !e,
    slide: e,
    active: t,
    previous: n
  }),
  arrow: (e) => Re({
    normalArrow: !e,
    hoverArrow: e
  }),
  arrowPrev: (e) => Re({
    "control-arrow control-prev": !0,
    "control-disabled": e
  }),
  arrowNext: (e) => Re({
    "control-arrow control-next": !0,
    "control-disabled": e
  }),
  dot: (e) => Re({
    dot: !0,
    active: e
  }),
  dotAimation: (e) => Re({
    NextSelected: e,
    PrevSelected: !e
  }),
  drag: (e) => Re({
    "move-drag": e
  })
}, dt = (e, t, n) => {
  const r = e === 0 ? e : e + t, i = n === "horizontal" ? [r, 0, 0] : [0, r, 0], a = "translate3d", s = "(" + i.join(",") + ")";
  return a + s;
}, Hr = (e, t) => `${e} of ${t}`, vi = (e) => e ? Object.prototype.hasOwnProperty.call(e, "key") : !1, Ot = (e, t) => {
  if (t.infiniteLoop && (e = e + 2), e === 0)
    return 0;
  const n = U.Children.count(t.children);
  if (t.leftMode)
    return -e * t.centerSlidePercentage;
  if (t.centerMode && t.axis === "horizontal" && t.slideToChange === 1) {
    let r = -e * t.centerSlidePercentage;
    const i = n - 1;
    return e && (e !== i || t.infiniteLoop) ? r += (100 - t.centerSlidePercentage) / 2 : r += 100 - t.centerSlidePercentage, r;
  }
  return -e * 100;
}, bi = (e, t) => ({ transform: dt(e, "%", t) }), qr = (e) => {
  let t = e.offsetWidth;
  const n = getComputedStyle(e);
  return t += parseInt(n.marginLeft) + parseInt(n.marginRight), t;
}, Yr = (e) => e === null || e.length === 0 ? e : e.filter((t) => !!t), Gr = (e, t, n) => {
  const r = {}, { selectedItem: i } = t, c = (typeof n < "u" ? n : i) / e.slideToChange, u = Ot(c, e), m = dt(u, "%", e.axis), v = e.transitionTime + "ms";
  return r.itemListStyle = {
    transform: m,
    transitionDuration: v
  }, r;
}, Qr = (e, t, n, r) => {
  const i = {}, a = t.axis === "horizontal", s = U.Children.count(t.children), c = 0, u = Ot(n.selectedItem, t), m = t.infiniteLoop ? Ot(s - 1, t) - 100 : Ot(s - 1, t), v = a ? e.x : e.y;
  let y = v, T;
  u === c && v > 0 && (y = 0), u === m && v < 0 && (y = 0), n.itemSize === 1 ? T = u : T = u + 100 / (n.itemSize / y);
  const f = Math.abs(v) > t.swipeScrollTolerance;
  return (!t.preventMovementUntilSwipeScrollTolerance || f || n.swipeMovementStarted) && (n.swipeMovementStarted || r({ type: "swipeMovementStarted", swipeMovementStarted: { swipeMovementStarted: !0 } }), i.itemListStyle = { ...bi(T, t.axis) }), f && !n.cancelClick && r({ type: "cancelClick", cancelClick: { cancelClick: !0 } }), i;
}, Xr = (e, t) => {
  const n = Ot(t.selectedItem, e);
  return { itemListStyle: {
    transform: bi(n, e.axis).transform,
    transitionDuration: e.transitionTime + "ms"
  } };
}, Jr = (e, t) => {
  const n = e.transitionTime + "ms";
  let i = {
    display: "block",
    zIndex: -1,
    minHeight: "100%",
    opacity: 0,
    top: 0,
    right: 0,
    bottom: 0,
    transitionTimingFunction: "ease-in-out",
    transitionDuration: e.transitionTime + "ms"
  };
  return t.swiping || (i = {
    ...i,
    transitionDuration: n
  }), {
    slideStyle: i,
    prevStyle: { ...i },
    selectedStyle: { ...i, opacity: 1, position: "absolute" }
  };
}, Zr = {
  axis: "horizontal",
  centerSlidePercentage: 80,
  centerSlidePadding: 0,
  autoPlay: !0,
  slideToChange: 1,
  isHoverArrow: !0,
  interval: 3e3,
  leftMode: !1,
  labels: {
    leftArrow: "revious slide / item",
    rightArrow: "next slide / item",
    item: "slide item"
  },
  thumbWidth: 80,
  preventMovementUntilSwipeScrollTolerance: !1,
  renderArrowPrev: (e, t, n) => /* @__PURE__ */ o(
    "div",
    {
      className: Ge.arrowPrev(!t),
      "aria-label": n,
      onClick: e,
      children: /* @__PURE__ */ o(
        st,
        {
          name: "icon-icon_arrow-left",
          color: "#ffffff",
          width: Je.screen === "mobile" ? 12 : 22,
          className: "arrow-icon"
        }
      )
    }
  ),
  renderArrowNext: (e, t, n) => /* @__PURE__ */ o(
    "div",
    {
      className: Ge.arrowNext(!t),
      "aria-label": n,
      onClick: e,
      children: /* @__PURE__ */ o(
        st,
        {
          name: "icon-icon_arrow-right",
          color: "#ffffff",
          width: Je.screen === "mobile" ? 12 : 22,
          className: "arrow-icon"
        }
      )
    }
  ),
  renderIndicator: (e, t, n, r, i, a) => /* @__PURE__ */ o(
    "li",
    {
      className: Re(Ge.dot(t), t && !a ? Ge.dotAimation(i) : ""),
      onClick: e,
      onKeyDown: e,
      value: n,
      role: "button",
      tabIndex: 0,
      "aria-label": `${r} ${n + 1}`
    },
    n
  ),
  renderItem: (e) => e,
  renderThumbs: (e) => {
    const t = j.Children.map(e, (n) => {
      let r = n;
      if (n.type !== "img" && (r = j.Children.toArray(n.props.children).find(
        (i) => i.type === "img"
      )), !!r)
        return r;
    });
    return t.filter((n) => n).length === 0 ? (console.warn(
      "No images found! Can't build the thumb list without images. If you don't need thumbs, set showThumbs={false} in the Carousel."
    ), []) : t;
  },
  statusFormatter: Hr,
  selectedItem: 0,
  showArrows: !0,
  showIndicators: !0,
  showStatus: !1,
  showThumbs: !1,
  stopOnHover: !0,
  infiniteLoop: !0,
  swipeScrollTolerance: 5,
  swipeable: !0,
  transitionTime: 600,
  veriticalSwipe: "standard",
  width: "100%",
  animationHandler: "slide",
  //fade
  swipeAnimationHandler: Qr,
  stopSwipingHandler: Xr,
  emulateTouch: !0
}, eo = {
  axis: "horizontal",
  labels: {
    leftArrow: "previous slide / item",
    rightArrow: "next slide / item",
    item: "slide item"
  },
  selectedItem: 0,
  thumbWidth: 80,
  transitionTime: 500
}, _i = U.forwardRef((e, t) => {
  var k, C;
  const n = U.useRef(), r = U.useRef(), i = U.useRef(), a = U.useRef({ initial: !1, children: !1 }), s = {
    selectedItem: e.selectedItem,
    swiping: !1,
    showArrows: !1,
    firstItem: 0,
    itemSize: 0,
    visibleItems: 0,
    lastPosition: 0
  }, c = e.selectedItem, u = (l, _) => {
    const d = _.type;
    switch (d) {
      case "selectedItem":
      case "swiping":
      case "itemSize":
      case "showArrows":
      case "firstItem":
      case "visibleItems":
      case "lastPosition":
        return {
          ...l,
          ..._[d]
        };
      case "all":
        return {
          ...l,
          ..._.all
        };
      default:
        return l;
    }
  }, [m, v] = U.useReducer(u, {
    ...s
  }), y = U.useCallback((l) => {
    let _ = l;
    return l >= m.lastPosition && (_ = m.lastPosition), l < m.firstItem + m.visibleItems && (_ = m.firstItem), _ < m.firstItem && (_ = l), _;
  }, [m.firstItem, m.lastPosition, m.visibleItems]), T = U.useCallback(() => {
    if (!e.children || !n.current || !i.current)
      return;
    const l = U.Children.count(e.children), _ = n.current.clientWidth, d = e.thumbWidth && typeof e.thumbWidth == "number" ? e.thumbWidth : qr(i.current[0]), x = Math.floor(_ / d), N = l - x, I = x < l;
    v({ type: "all", all: { itemSize: d, visibleItems: x, firstItem: I ? y(e.selectedItem) : 0, lastPosition: N, showArrows: I } });
  }, [y, e.children, e.selectedItem, e.thumbWidth]);
  U.useImperativeHandle(t, () => ({
    updateSizes: () => {
      T();
    }
  }));
  function f() {
    T();
  }
  const w = (l, _) => {
    i.current || (i.current = []), i.current[_] = l;
  }, P = (l) => {
    r.current = l;
  }, p = (l, _, d) => {
    if (!vi(d) || d.key === "Enter") {
      const x = e.onSelectItem;
      typeof x == "function" && x(l, _);
    }
  };
  U.useEffect(() => (f(), () => {
  }), []), U.useEffect(() => {
    e.selectedItem !== m.selectedItem && v({ type: "all", all: { selectedItem: e.selectedItem, firstItem: y(e.selectedItem) } }), T();
  }, [y, e, m.selectedItem, T]), U.useEffect(() => {
    a.current.children && T();
  }, [e.children, T]);
  const h = (l) => {
    const _ = {}, d = -l.firstItem * (l.itemSize ?? 0), x = dt(d, "px", e.axis), N = e.transitionTime + "ms";
    return _.transform = x, _.transitionDuration = N, _;
  };
  function b() {
    return e.children.map((l, _) => {
      var I, B;
      const d = Ge.item(!1, _ === c), x = ((I = e.thumbClassList) == null ? void 0 : I.thumbItemClassName) === void 0 ? "" : (B = e.thumbClassList) == null ? void 0 : B.thumbItemClassName, N = {
        ref: (ie) => w(ie, _),
        className: Re(`${d}`, `${x}`),
        onClick: (ie) => {
          p(_, e.children[_], ie);
        },
        onKeyDown: (ie) => {
          p(_, e.children[_], ie);
        },
        "aria-label": `${e.labels.item} ${_ + 1}`
      };
      return /* @__PURE__ */ o(
        "li",
        {
          ...N,
          role: "button",
          tabIndex: 0,
          children: l
        },
        _
      );
    });
  }
  return /* @__PURE__ */ o(
    "div",
    {
      className: Re(`${Ge.carousel(!1)}`, `${((k = e.thumbClassList) == null ? void 0 : k.thumbClassName) === void 0 ? "" : (C = e.thumbClassList) == null ? void 0 : C.thumbClassName}`),
      ref: t,
      children: /* @__PURE__ */ o(
        "div",
        {
          className: Ge.wrapper(!1),
          ref: n,
          children: /* @__PURE__ */ o(
            "ul",
            {
              className: Ge.slider(!1, m.swiping),
              ref: (l) => P(l),
              style: h(m),
              children: b()
            }
          )
        }
      )
    }
  );
});
_i.defaultProps = eo;
const it = (e) => /* @__PURE__ */ o(ke, { children: e.children }), mt = (e) => {
  var tt, Ye;
  const t = U.useRef(null), n = U.useRef(), r = U.useRef(null), i = U.useRef([]), a = U.useRef(null), s = e.animationHandler === "slide" ? Gr : Jr, c = U.useRef({ isInitial: !1, isSelectedItem: !1, isAutoPlay: !1, isFocus: !1, isSwiping: !1 }), u = U.useMemo(() => Yr(e.children), [e.children]);
  function m() {
    const [, A] = U.useState(0);
    return U.useCallback(() => {
      A((J) => (J + 1) % (Number.MAX_SAFE_INTEGER - 1));
    }, []);
  }
  const v = m(), y = U.useMemo(() => ({
    initialized: !1,
    previousItem: e.selectedItem,
    selectedItem: e.selectedItem,
    hasMount: !1,
    isMouseEntered: !1,
    autoPlay: e.autoPlay,
    swiping: !1,
    swipeMovementStarted: !1,
    cancelClick: !1,
    itemSize: e.axis === "horizontal" ? i.current[0] ? i.current[0].clientWidth : 1 : i.current[0] ? i.current[0].clientHeight : 1,
    // itemSize: props.axis === 'horizontal'? (itemsRef.current[0].clientWidth ): (itemsRef.current[0].clientHeight),
    itemListStyle: {},
    slideStyle: {},
    selectedStyle: {},
    prevStyle: {},
    isSliding: !1
  }), [e.autoPlay, e.axis, e.selectedItem]), T = (A, J) => {
    const te = J.type;
    switch (te) {
      case "initialized":
      case "previousItem":
      case "selectedItem":
      case "hasMount":
      case "isMouseEntered":
      case "autoplay":
      case "swiping":
      case "swipeMovementStarted":
      case "cancelClick":
      case "itemSize":
      case "isSliding":
      case "itemListStyle":
      case "slideStyle":
      case "selectedStyle":
      case "prevStyle":
        return {
          ...A,
          ...J[te]
        };
      case "all":
        return {
          ...A,
          ...J.all
        };
      default:
        return A;
    }
  }, [f, w] = U.useReducer(T, {
    ...y,
    ...s(e, y)
  }), P = e.swipeable && U.Children.count(u) > 1 && e.slideToChange === 1, p = e.axis === "horizontal", h = U.useCallback((A, J) => {
    if (A === U.Children.count(u) - e.slideToChange && J === 0) {
      let te = "";
      e.centerMode && e.slideToChange === 1 ? te = dt(-((U.Children.count(u) + 1) * e.centerSlidePercentage - (100 - e.centerSlidePercentage) / 2), "%", e.axis) : e.leftMode && e.slideToChange === 1 ? te = dt(-(U.Children.count(u) + 1) * e.centerSlidePercentage, "%", e.axis) : te = dt(-((U.Children.count(u) / e.slideToChange + 1) * 100), "%", e.axis), w({ type: "itemListStyle", itemListStyle: { itemListStyle: {
        transform: te,
        transitionDuration: "unset"
      } } });
    } else if (A === 0 && J === U.Children.count(u) - e.slideToChange) {
      let te = "";
      e.centerMode && e.slideToChange === 1 ? te = dt(-e.centerSlidePercentage * 2 + (100 - e.centerSlidePercentage) / 2, "%", e.axis) : e.leftMode && e.slideToChange === 1 ? te = dt(-e.centerSlidePercentage * 2, "%", e.axis) : te = dt(-200, "%", e.axis), w({ type: "itemListStyle", itemListStyle: { itemListStyle: {
        transform: te,
        transitionDuration: "unset"
      } } });
    }
    setTimeout(function() {
      w({ type: "isSliding", isSliding: { isSliding: !1 } });
    }, 50);
  }, [u, e.axis, e.centerMode, e.centerSlidePercentage, e.leftMode, e.slideToChange]), b = (A, J) => {
    i.current[J] = A;
  }, k = (A) => {
    r.current = A;
  }, C = U.useCallback(() => {
    const A = e.axis === "horizontal", J = i.current[0];
    if (!J)
      return;
    const te = A ? J.clientWidth : J.clientHeight;
    w({ type: "itemSize", itemSize: { itemSize: te } }), t.current && t.current.updateSizes();
  }, [e.axis]), l = () => {
    var A, J, te, we, Me;
    return n.current ? !1 : !!(((J = (A = ge()) == null ? void 0 : A.document) == null ? void 0 : J.activeElement) === n.current || (Me = n.current) != null && Me.contains((we = (te = ge()) == null ? void 0 : te.document) == null ? void 0 : we.activeElement));
  }, _ = U.useCallback((A, J) => {
    U.Children.count(u) <= 1 || e.onChange && e.onChange(A, J);
  }, [u, e]), d = U.useCallback((A, J) => {
    const te = { ...f, ...A }, we = s(e, te, J), Me = { ...A, previousItem: f.selectedItem, ...we, isSliding: !0 };
    w({ type: "all", all: Me }), _(te.selectedItem, U.Children.toArray(u)[te.selectedItem]);
  }, [s, u, _, e, f]), x = U.useCallback((A) => {
    if (typeof A != "number")
      return;
    const J = A, te = e.slideToChange === 1 ? U.Children.count(u) - 1 : (Math.ceil(U.Children.count(u) / e.slideToChange) - 1) * e.slideToChange;
    A < 0 && (A = e.infiniteLoop ? te : 0), A > te && (A = e.infiniteLoop ? 0 : te), d({ selectedItem: A, swiping: f.swiping }, J);
  }, [u, e.infiniteLoop, e.slideToChange, d, f.swiping]), N = U.useCallback((A = 1) => {
    x(f.selectedItem + (typeof A == "number" ? A : 1));
  }, [x, f.selectedItem]), I = U.useCallback((A = 1) => {
    x(f.selectedItem - (typeof A == "number" ? A : 1));
  }, [x, f.selectedItem]), B = U.useCallback((A) => {
    if (l() || f.isSliding)
      return;
    const { axis: J } = e, te = J === "horizontal", we = {
      ArrowUp: 38,
      ArrowRight: 39,
      ArrowDown: 40,
      ArrowLeft: 37
    }, Me = te ? we.ArrowRight : we.ArrowDown, Fe = te ? we.ArrowLeft : we.ArrowUp;
    Me === A.keyCode ? N(e.slideToChange) : Fe === A.keyCode && I(e.slideToChange);
  }, [I, N, e, f.isSliding]), ie = U.useCallback(() => {
    C(), w({ type: "hasMount", hasMount: { hasMount: !0 } });
  }, [C]), X = () => {
    a.current && clearTimeout(a.current);
  }, se = U.useCallback(() => {
    U.Children.count(u) <= 1 || (X(), f.isMouseEntered || (a.current = setTimeout(() => {
      N(e.slideToChange);
    }, e.interval)));
  }, [u, N, e.interval, e.slideToChange, f.isMouseEntered]), Q = U.useCallback(() => {
    X(), se();
  }, [se]), ve = U.useCallback(() => {
    w({ type: "isMouseEntered", isMouseEntered: { isMouseEntered: !0 } }), X();
  }, []), ye = U.useCallback(() => {
    Q(), w({ type: "isMouseEntered", isMouseEntered: { isMouseEntered: !1 } });
  }, [Q]), ue = U.useCallback(() => {
    se();
    const A = n.current;
    e.stopOnHover && A && (A.addEventListener("mouseenter", ve), A.addEventListener("mouseleave", ye));
  }, [se, e.stopOnHover, ye, ve]), _e = U.useCallback(() => {
    X();
    const A = n.current;
    e.stopOnHover && A && (A.removeEventListener("mouseenter", ve), A.removeEventListener("mouseleave", ye));
  }, [e.stopOnHover, ye, ve]), E = U.useCallback(() => {
    window.addEventListener("resize", C), e.useKeyboardArrows && window.document.addEventListener("keydown", B);
  }, [B, e.useKeyboardArrows, C]), $ = U.useCallback(() => {
    window.removeEventListener("resize", C), e.useKeyboardArrows && window.document.removeEventListener("keydown", B);
  }, [B, e.useKeyboardArrows, C]);
  function ce() {
    var A;
    (A = n.current) == null || A.focus();
  }
  const Z = U.useCallback(() => {
    w({ type: "all", all: { all: y } }), E(), f.autoPlay && U.Children.count(u) > 1 && ue(), e.autoFocus && ce(), ie(), w({ type: "itemSize", itemSize: { itemSize: i.current[0].clientWidth } }), w({ type: "initialized", initialized: { initialized: !0 } });
  }, [E, u, y, e.autoFocus, ie, ue, f.autoPlay]), R = U.useCallback(() => {
    f.initialized && ($(), _e());
  }, [_e, f.initialized, $]), O = U.useCallback((A, J) => {
    if (U.Children.count(u) !== 0 && !f.isSliding) {
      if (f.cancelClick) {
        w({ type: "cancelClick", cancelClick: { cancelClick: !1 } });
        return;
      }
      e.onClickItem && e.onClickItem(A, J);
    }
  }, [u, e, f.cancelClick, f.isSliding]), L = U.useCallback((A, J) => {
    e.onClickThumb && e.onClickThumb(A, J), x(A);
  }, [x, e]), z = U.useCallback(() => {
    h(f.selectedItem, f.previousItem);
  }, [h, f.previousItem, f.selectedItem]), W = U.useCallback(() => {
    w({ type: "isSliding", isSliding: { isSliding: !1 } });
  }, []), q = (A) => {
    f.isSliding || (w({ type: "swiping", swiping: { swiping: !0 } }), e.onSwipeStart && e.onSwipeStart(A), X());
  }, Y = (A) => {
    if (f.isSliding)
      return;
    w({ type: "all", all: {
      swiping: !1,
      cancelClick: !1,
      swipeMovementStarted: !1
    } }), e.onSwipeEnd && e.onSwipeEnd(A), f.autoPlay && se();
  }, re = (A, J) => {
    if (f.isSliding || e.animationHandler !== "slide")
      return !1;
    e.onSwipeMove && e.onSwipeMove(J);
    const te = e.swipeAnimationHandler(
      A,
      e,
      f,
      w
    );
    return w({ type: "all", all: { ...te } }), !!Object.keys(te).length;
  }, K = () => (f.selectedItem > 0 || e.infiniteLoop) ?? !1, pe = () => (f.selectedItem < (e.slideToChange === 1 ? U.Children.count(u) - 1 : (Math.ceil(U.Children.count(u) / e.slideToChange) - 1) * e.slideToChange) || e.infiniteLoop) ?? !1, oe = () => {
    f.isSliding || !pe() || (N(e.slideToChange), e.emulateTouch && w({ type: "cancelClick", cancelClick: { cancelClick: !0 } }));
  }, Ue = () => {
    f.isSliding || !K() || (I(e.slideToChange), e.emulateTouch && w({ type: "cancelClick", cancelClick: { cancelClick: !0 } }));
  }, Be = () => {
    !e.infiniteLoop && f.selectedItem === U.Children.count(u) - 1 || (N(e.slideToChange), e.emulateTouch && w({ type: "cancelClick", cancelClick: { cancelClick: !0 } }));
  }, G = () => {
    f.isSliding || !e.infiniteLoop && f.selectedItem === 0 || (I(e.slideToChange), e.emulateTouch && w({ type: "cancelClick", cancelClick: { cancelClick: !0 } }));
  }, de = (A) => (J) => {
    f.isSliding || f.selectedItem === A || (!vi(J) || (J == null ? void 0 : J.key) === "Enter") && x(A);
  }, fe = (A) => {
    var te;
    const J = (te = i.current) == null ? void 0 : te[A];
    if (f.hasMount && J && J.children.length) {
      const we = J.children[0].getElementsByTagName("img") || [];
      if (we.length > 0) {
        const $e = we[0], _t = () => {
          v(), $e && $e.removeEventListener("load", _t);
        };
        $e.addEventListener("load", _t);
      }
      const Fe = (we[0] || J.children[0]).clientHeight;
      return Fe > 0 ? Fe : null;
    }
    return null;
  };
  function xe(A) {
    return u ? U.Children.map(u, (J, te) => {
      const we = te === f.selectedItem, Me = te === f.previousItem;
      let Fe = we && f.selectedStyle || Me && f.prevStyle || f.slideStyle || {};
      e.centerMode && e.axis === "horizontal" ? Fe = { ...Fe, minWidth: e.centerSlidePercentage + "%", padding: `0 ${e.centerSlidePadding}px` } : e.centerMode && e.axis === "vertical" ? Fe = { ...Fe, padding: `${e.centerSlidePadding}px 0` } : e.leftMode && e.axis === "horizontal" && (Fe = { ...Fe, minWidth: e.centerSlidePercentage + "%", padding: `0 ${e.centerSlidePadding}px` });
      const $e = {
        ref: (_t) => b(_t, te),
        key: "itemKey" + te + (A ? "clone" : ""),
        className: Ge.item(!0, te === f.selectedItem, te === f.previousItem),
        onClick: () => {
          O(te, J);
        },
        style: Fe
      };
      return /* @__PURE__ */ o("li", { ...$e, children: e.renderItem(J, {
        isSelected: te === f.selectedItem,
        isPrevious: te === f.previousItem
      }) });
    }) : [];
  }
  const ee = xe(!0), Te = e.leftMode ? Math.max(Math.ceil(100 / e.centerSlidePercentage), e.slideToChange * 2) : e.slideToChange * 2, be = [], De = [];
  for (let A = ee.length - Te; A < ee.length; A++)
    be.push(ee[A]);
  for (let A = 0; A < Te; A++)
    De.push(ee[A]);
  const Ee = (A, J) => U.cloneElement(A, {
    key: `itemKeyClone${J}`
  }), Oe = () => {
    const A = {
      className: Ge.slider(!0, f.swiping),
      onSwipeMove: re,
      onSwipeStart: q,
      onSwipeEnd: Y,
      style: f.itemListStyle,
      tolerance: e.swipeScrollTolerance
    };
    return p ? (A.onSwipeLeft = Be, A.onSwipeRight = G) : (A.onSwipeUp = e.veriticalSwipe === "natural" ? G : Be, A.onSwipeDown = e.veriticalSwipe === "natural" ? Be : G, A.style = { ...A.style, height: f.itemSize }), A;
  }, Le = () => {
    const A = {};
    if (p) {
      if (e.dynamicHeigh) {
        const J = fe(f.selectedItem);
        A.height = J ?? "auto";
      }
    } else
      A.height = f.itemSize;
    return A;
  };
  U.useEffect(() => {
    w({ type: "all", all: {
      ...y,
      ...s(e, y)
    } });
  }, [s, y, e]), U.useEffect(() => {
    if (u)
      return Z(), () => {
        R();
      };
  }, [u, e]), U.useEffect(
    () => (e.autoPlay && U.Children.count(u) > 1 ? (Q(), e.stopOnHover && n.current && (n.current.addEventListener("mouseenter", ve), n.current.addEventListener("mouseleave", ye))) : X(), () => {
      n.current && (n.current.removeEventListener("mouseenter", ve), n.current.removeEventListener("mouseleave", ye));
    }),
    [u, e.autoPlay, e.stopOnHover, Q, ye, ve]
  ), U.useEffect(() => (e.infiniteLoop && e.animationHandler === "slide" ? r.current.addEventListener("transitionend", z, { once: !0 }) : r.current.addEventListener("transitionend", function() {
    w({ type: "isSliding", isSliding: { isSliding: !1 } });
  }, { once: !0 }), () => {
    r.current && (e.infiniteLoop && e.animationHandler === "slide" ? r.current.removeEventListener("transitionend", z) : r.current.removeEventListener("transitionend", W));
  }), [h, z, W, e.animationHandler, e.infiniteLoop, f.previousItem, f.selectedItem]), U.useEffect(() => {
    c.current.isFocus ? ce() : c.current.isFocus = !0;
  }, [e.autoFocus]);
  function We() {
    const { showIndicators: A, labels: J, renderIndicator: te } = e;
    if (!A)
      return null;
    const we = [];
    for (let $e = 0; $e < U.Children.count(u); $e++)
      $e % e.slideToChange === 0 && we.push($e);
    const Me = e.slideToChange === 1 ? U.Children.count(u) - 1 : (Math.ceil(U.Children.count(u) / e.slideToChange) - 1) * e.slideToChange, Fe = (f.selectedItem === 0 && f.previousItem === Me || f.selectedItem === Me && f.previousItem === 0 || Math.abs(f.selectedItem - f.previousItem) !== 1) && U.Children.count(u) !== 2;
    return /* @__PURE__ */ S("div", { children: [
      /* @__PURE__ */ o("ul", { className: Re("control-dots", e.indicatorClassName ?? "default-dots"), children: U.Children.map(we, ($e) => te(de($e), $e === f.selectedItem, $e, J.item, $e === f.selectedItem && f.selectedItem > f.previousItem, Fe)) }),
      /* @__PURE__ */ o("ul", { className: Re("control-dots", e.indicatorClassName ?? "default-dots", "back-index"), children: U.Children.map(we, ($e) => te(() => {
      }, !1, $e, J.item, !1, !0)) })
    ] });
  }
  function je() {
    return !e.showThumbs || !u || U.Children.count(u) === 0 ? null : /* @__PURE__ */ o(
      _i,
      {
        axis: e.axis,
        ref: t,
        onSelectItem: L,
        selectedItem: f.selectedItem,
        transitionTime: e.transitionTime,
        thumbWidth: e.thumbWidth === void 0 ? "80px" : e.thumbWidth,
        moveCarousel: x,
        labels: e.labels,
        carouselState: f,
        thumbClassList: e.thumbClassName,
        children: e.renderThumbs(u)
      }
    );
  }
  function Ve() {
    return e.showStatus ? /* @__PURE__ */ o("p", { className: "carousel-status", children: e.statusFormatter(f.selectedItem + 1, U.Children.count(u)) }) : null;
  }
  return /* @__PURE__ */ S(
    "div",
    {
      className: Ge.root(e.className),
      ref: n,
      tabIndex: 0,
      children: [
        e.customRenderArrowPrev && e.customRenderArrowNext && /* @__PURE__ */ S("div", { className: "custom-controll", children: [
          (tt = e.customRenderArrowPrev) == null ? void 0 : tt.call(e, Ue),
          (Ye = e.customRenderArrowNext) == null ? void 0 : Ye.call(e, oe)
        ] }),
        /* @__PURE__ */ S(
          "div",
          {
            className: Re(Ge.carousel(!0), e.containerClass ? e.containerClass : "", Ge.arrow(e.isHoverArrow)),
            style: { width: e.width },
            children: [
              We(),
              e.showArrows && e.renderArrowPrev(Ue, K(), e.labels.leftArrow),
              /* @__PURE__ */ o(
                "div",
                {
                  className: Re(Ge.wrapper(!0, e.axis), Ge.drag(f.swiping !== void 0 ? f.swiping : !1)),
                  style: Le(),
                  children: P ? /* @__PURE__ */ S(
                    jr,
                    {
                      tagName: "ul",
                      innerRef: (A) => k(A),
                      ...Oe(),
                      allowMouseEvents: e.emulateTouch,
                      children: [
                        e.animationHandler == "slide" && e.infiniteLoop && U.Children.map(be, function(A, J) {
                          return Ee(A, J);
                        }),
                        xe(),
                        e.animationHandler === "slide" && e.infiniteLoop && U.Children.map(De, function(A, J) {
                          return Ee(A, J);
                        })
                      ]
                    }
                  ) : /* @__PURE__ */ S(
                    "ul",
                    {
                      className: Ge.slider(!0, f.swiping),
                      ref: (A) => k(A),
                      style: f.itemListStyle ?? {},
                      children: [
                        e.animationHandler == "slide" && e.infiniteLoop && U.Children.map(be, function(A, J) {
                          return Ee(A, J);
                        }),
                        xe(),
                        e.animationHandler === "slide" && e.infiniteLoop && U.Children.map(De, function(A, J) {
                          return Ee(A, J);
                        })
                      ]
                    }
                  )
                }
              ),
              e.showArrows && e.renderArrowNext(oe, pe(), e.labels.rightArrow),
              Ve(),
              je()
            ]
          }
        )
      ]
    }
  );
};
mt.defaultProps = Zr;
const to = Ie(() => {
  const { data: e, visible: t } = bt(ht);
  return !t || !(e != null && e.extraTip) ? null : /* @__PURE__ */ o(
    "div",
    {
      className: "reo-extra-tip",
      dangerouslySetInnerHTML: { __html: e.extraTip }
    }
  );
}), vt = Ie((e) => e.hideIcon ? null : /* @__PURE__ */ o(
  ot,
  {
    name: e.name,
    width: "36px",
    color: "#999",
    className: "reo-tip-icon"
  }
)), no = Ie(() => {
  var c, u, m, v;
  const { data: e, visible: t, exclude: n, hideIcon: r, langPack: i } = bt(ht);
  if (n.includes("coupon") || !t)
    return null;
  const a = (c = e == null ? void 0 : e.activities) == null ? void 0 : c.lightningDeal;
  let s;
  if (e != null && e.hasPrice && a && !(a instanceof Array) && !(a.autoCoupon instanceof Array) && Object.keys(a.autoCoupon).length !== 0) {
    const y = a.autoCoupon;
    return y.discountType === "amount" ? s = e.currency.symbol.replace("{}", Number(y.discount).toFixed(e.currency.precision)) : s = Math.round(y.discount * 100 / Number(e.price.currentPrice)) + "%", /* @__PURE__ */ S("div", { className: "reo-auto-coupon", children: [
      /* @__PURE__ */ o(
        vt,
        {
          name: "icon-icon-coupon-0902",
          hideIcon: r
        }
      ),
      e.discountOff || (u = e.activities) != null && u.priceBreak ? i == null ? void 0 : i["reo-product"].extra : "",
      /* @__PURE__ */ o(
        "span",
        {
          className: "reo-autocoupon-discount",
          dangerouslySetInnerHTML: {
            __html: `<span class="text-red-e74300">${(m = i == null ? void 0 : i["reo-product"].$1_off) == null ? void 0 : m.replace("$1", s)} </span>`
          }
        }
      ),
      /* @__PURE__ */ o("span", { className: "reo-autocoupon-code", children: (v = i == null ? void 0 : i["reo-product"].auto_coupon) == null ? void 0 : v.replace("$1", y.couponCode) })
    ] });
  } else
    return null;
}), io = Ie(() => {
  var a;
  const { data: e, visible: t, exclude: n, hideIcon: r, langPack: i } = bt(ht);
  return n.includes("time") || !t ? null : e != null && e.isPreOrder && e.stock.expectedDeliveryTime ? /* @__PURE__ */ S("div", { className: "reo-estimated-delivery-time", children: [
    /* @__PURE__ */ o(
      vt,
      {
        name: "icon-icon-Estimated-time-of-arrival",
        hideIcon: r
      }
    ),
    /* @__PURE__ */ o("span", { dangerouslySetInnerHTML: {
      __html: (a = i["reo-product"].estimated_delivery_time) == null ? void 0 : a.replace("$1", `
                        <span class="text-red-e74300">${wr(i, e.stock.expectedDeliveryTime)}</span>
                    `)
    } })
  ] }) : null;
}), ro = Ie(() => {
  var C, l, _, d, x, N;
  const { data: e, visible: t, exclude: n, hideIcon: r, langPack: i, country: a } = bt(ht), [s, c] = M(!1), u = V(() => {
    c(!0);
  }, []), m = V(() => {
    Cn(), c(!1);
  }, []), v = F(() => {
    var I, B;
    return ((B = (I = e == null ? void 0 : e.activities) == null ? void 0 : I.priceBreak) == null ? void 0 : B.gradient) ?? [];
  }, [e]), y = F(() => {
    var I, B;
    return ((B = (I = e == null ? void 0 : e.activities) == null ? void 0 : I.priceBreak) == null ? void 0 : B.products) ?? [];
  }, [e]), T = F(() => {
    var I, B;
    return ((B = (I = e == null ? void 0 : e.activities) == null ? void 0 : I.priceBreak) == null ? void 0 : B.type) === "amount";
  }, [e]), f = V((I) => e && T ? e.currency.symbol.replace("{}", Number(I.amount).toFixed(e.currency.precision)) : I.amount.toString(), [e, T]), w = V((I) => I.discount.includes("%") ? I.discount : e.currency.symbol.replace("{}", Number(I.discount).toFixed(e.currency.precision)), [e]), P = F(() => /* @__PURE__ */ o("ul", { className: "full-reduction-balloon-inner", children: y.map((I, B) => /* @__PURE__ */ S("li", { children: [
    /* @__PURE__ */ o("span", { className: "dot" }),
    /* @__PURE__ */ o("a", { href: I.href, children: I.name })
  ] }, B)) }), [y]), p = V((I) => {
    const ie = /(.*?)(<[^>]+?trigger-target[^>]+>[^<]+<[^>]+>)(.*)/.exec(I);
    return ie ? /* @__PURE__ */ S(ke, { children: [
      /* @__PURE__ */ o("span", { dangerouslySetInnerHTML: { __html: ie[1] } }),
      /* @__PURE__ */ o(
        ln,
        {
          type: "multiLine",
          placement: un.TOP_CENTER,
          content: P,
          trigger: "hover",
          className: "balloon-trigger-target",
          contentClassName: "z-1000 full-reduction-balloon",
          children: /* @__PURE__ */ o("span", { dangerouslySetInnerHTML: { __html: ie[2] } })
        }
      ),
      /* @__PURE__ */ o("span", { dangerouslySetInnerHTML: { __html: ie[3] } })
    ] }) : null;
  }, [P]), h = V((I) => {
    var ie, X, se;
    const B = (ie = e == null ? void 0 : e.activities) == null ? void 0 : ie.priceBreak;
    if (!B)
      return null;
    if (B.type !== "single" && y.length > 1) {
      let Q = "multiple-quantity-full-redection";
      T && (Q = "multiple-amount-full-redection");
      const ve = (X = i["reo-product"][Q]) == null ? void 0 : X.replace("{condition}", f(I)).replace("{discount}", w(I));
      return /* @__PURE__ */ o(ke, { children: v.length > 1 ? /* @__PURE__ */ S(ke, { children: [
        /* @__PURE__ */ o("span", { dangerouslySetInnerHTML: { __html: ve } }),
        P
      ] }) : p(ve) });
    } else {
      let Q = "single-quantity-full-redection";
      return B.allProducts ? T ? Q = "all-amount-full-redection" : Q = "all-quantity-full-redection" : T && (Q = "single-amount-full-redection"), /* @__PURE__ */ o("span", { dangerouslySetInnerHTML: {
        __html: (se = i["reo-product"][Q]) == null ? void 0 : se.replace("{condition}", f(I)).replace("{discount}", w(I))
      } });
    }
  }, [
    e,
    v,
    T,
    i,
    P,
    y,
    f,
    w,
    p
  ]), b = F(() => {
    var I;
    return /* @__PURE__ */ S(ke, { children: [
      /* @__PURE__ */ o("span", { children: (I = i == null ? void 0 : i["reo-product"]) == null ? void 0 : I["multiple-gradients-full-redection"] }),
      /* @__PURE__ */ o(
        ln,
        {
          type: "multiLine",
          placement: un.TOP_CENTER,
          content: /* @__PURE__ */ o("div", { className: "full-reduction-balloon-inner", children: v.map((B, ie) => /* @__PURE__ */ o(
            "div",
            {
              className: "single-gradient",
              children: h(B)
            },
            ie
          )) }),
          trigger: "hover",
          className: "full-reduction-question",
          contentClassName: "z-1000 full-reduction-balloon",
          children: /* @__PURE__ */ o(
            ot,
            {
              name: "icon-icon_question1",
              width: "14px",
              color: "#0E6AFF"
            }
          )
        }
      )
    ] });
  }, [v, i, h]), k = F(() => {
    var I;
    return (I = e == null ? void 0 : e.activities) != null && I.priceBreak ? /* @__PURE__ */ o("div", { className: "full-reduction", children: v.length > 1 ? b : h(v[0]) }) : null;
  }, [e, v, b, h]);
  if (n.includes("promotion") || !t)
    return null;
  if (e != null && e.hasPrice && ((C = e.activities) != null && C.priceBreak || (_ = (l = e.activities) == null ? void 0 : l.giftActivity) != null && _.length)) {
    const I = ((x = (d = e.activities) == null ? void 0 : d.giftActivity) == null ? void 0 : x.map((B) => B.id)) ?? [];
    return /* @__PURE__ */ S("div", { className: "reo-promotion-info", children: [
      /* @__PURE__ */ o(
        vt,
        {
          name: "icon-coupon2",
          hideIcon: r
        }
      ),
      k,
      I.length ? /* @__PURE__ */ S(ke, { children: [
        (N = e.activities) != null && N.priceBreak ? /* @__PURE__ */ o(
          ot,
          {
            name: "icon-icon_plus",
            className: "mx-4",
            color: "#777",
            width: "12px"
          }
        ) : null,
        /* @__PURE__ */ S(
          "span",
          {
            className: "gift-item cursor-pointer",
            onClick: u,
            children: [
              /* @__PURE__ */ o("span", { children: i["reo-product"].buy_and_get_promotion }),
              /* @__PURE__ */ o(
                ot,
                {
                  name: "icon-icon_question1",
                  color: "#0E6AFF",
                  width: "14px",
                  className: "ml-6"
                }
              )
            ]
          }
        ),
        s && /* @__PURE__ */ o(
          go,
          {
            productData: e,
            country: a,
            onClose: m,
            langPack: i
          }
        )
      ] }) : ""
    ] });
  } else
    return null;
}), oo = Ie(() => {
  var s, c, u, m;
  const { data: e, visible: t, exclude: n, hideIcon: r, langPack: i } = bt(ht);
  if (n.includes("stock") || !t)
    return null;
  const a = e == null ? void 0 : e.stock;
  if (a && (a.quantity > 0 && a.quantity < 50 || a.isDisplay || a.isLimited)) {
    const v = {
      width: a.quantityPercent
    };
    return a.displayType === "percent" ? /* @__PURE__ */ S("div", { className: "reo-lack-stock", children: [
      /* @__PURE__ */ o(
        vt,
        {
          name: "icon-stock",
          hideIcon: r
        }
      ),
      /* @__PURE__ */ S("div", { className: "percentage-stock-wrap", children: [
        /* @__PURE__ */ o("div", { className: "total-stock-box", children: /* @__PURE__ */ o(
          "div",
          {
            className: "saled-stock-box",
            style: v
          }
        ) }),
        /* @__PURE__ */ o("span", { className: "percentage-stock-text", children: (c = (s = i == null ? void 0 : i["reo-product"]) == null ? void 0 : s.$1_claimed) == null ? void 0 : c.replace("$1", a.quantityPercent) })
      ] })
    ] }) : /* @__PURE__ */ S("div", { className: "reo-lack-stock", children: [
      /* @__PURE__ */ o(
        vt,
        {
          name: "icon-stock",
          hideIcon: r
        }
      ),
      /* @__PURE__ */ o("span", { dangerouslySetInnerHTML: {
        __html: (m = (u = i == null ? void 0 : i["reo-product"]) == null ? void 0 : u.only_$1_left_in_stock) == null ? void 0 : m.replace("$1", `<span class="text-red-e74300">${a.quantity}</span>`)
      } })
    ] });
  } else
    return null;
}), ao = Ie((e) => {
  const { data: t, visible: n, exclude: r, hideIcon: i, langPack: a } = bt(ht), s = V((P) => !!(P != null && P.includes("trigger-target")), []), c = V((P, p) => {
    const h = P.currentTarget, b = document.createElement("div");
    if (b.className = "trigger-content", h.getAttribute("text")) {
      const _ = document.createElement("p");
      _.innerHTML = h.getAttribute("text"), b.appendChild(_);
    }
    const k = document.createElement("div");
    k.className = "compare-content";
    for (let _ = 1; _ < 5 && h.getAttribute("version-" + _); _++) {
      const d = document.createElement("div");
      d.className = "compare-item", d.innerHTML = "<span>" + h.getAttribute("version-" + _) + '</span><div class="compare-img" style="background-image: url(' + h.getAttribute("img-" + _) + ')"></div>', k.appendChild(d);
    }
    b.appendChild(k);
    const C = h.getBoundingClientRect(), l = 168;
    if (C) {
      let _ = C.left + C.width / 2;
      _ - l < 0 ? _ = l : _ + l > he() && (_ = he() - l), b.setAttribute("style", `top: ${C.top}px; left: ${_}px;`);
    }
    if (!zt() && he() > 1280 || zt() && he() > 540) {
      const _ = document.createElement("div");
      _.className = `tips-popup trigger ${p} ${zt() ? "deals" : ""}`, b.setAttribute("parent", p ?? ""), _.appendChild(b), document.body.appendChild(_);
    } else {
      const _ = xt(h, p);
      _ && !_.getElementsByClassName("trigger-content").length && _.appendChild(b);
    }
  }, []), u = V((P) => {
    var C, l;
    (C = P == null ? void 0 : P.stopPropagation) == null || C.call(P);
    const p = P.currentTarget, h = xt(p, "reo-shipping-info"), b = xt(p, "reo-various-note"), k = xt(p, "trigger");
    if (P.type === "mouseenter" || P.type === "click" && !k)
      h ? (c(P, "reo-shipping-info"), setTimeout(() => {
        Ln(h, "trigger");
      })) : b && (c(P, "reo-various-note"), setTimeout(() => {
        Ln(b, "trigger");
      }));
    else if (P.type === "mouseleave" || P.type === "click" && k) {
      const _ = Array.from(document.getElementsByClassName("trigger-content"));
      let d;
      h ? (d = _.filter((x) => x.getAttribute("parent") === "reo-shipping-info")[0], Vt(h, "trigger")) : b && (d = _.filter((x) => x.getAttribute("parent") === "reo-various-note")[0], Vt(b, "trigger")), d && ((l = xt(d, "tips-popup")) == null || l.remove());
    }
  }, [c]), m = V(() => {
    const P = Array.from(document.getElementsByClassName("tips-popup"));
    if (P.length) {
      const p = Array.from(document.getElementsByClassName("reo-shipping-info")), h = Array.from(document.getElementsByClassName("reo-various-note"));
      p.forEach((b) => Vt(b, "trigger")), h.forEach((b) => Vt(b, "trigger")), P.forEach((b) => b.remove());
    }
  }, []);
  ne(() => (window.addEventListener("scroll", m), document.body.addEventListener("click", m), () => {
    window.removeEventListener("scroll", m), document.body.removeEventListener("click", m);
  }), [m]);
  const v = V((P) => {
    const p = P.getElementsByClassName("trigger-target")[0];
    p && (he() > 1280 ? (p.addEventListener("mouseenter", (h) => {
      u(h);
    }), p.addEventListener("mouseleave", (h) => {
      u(h);
    })) : p.addEventListener("click", (h) => {
      h.stopPropagation(), u(h);
    }));
  }, [u]), y = V((P) => {
    P.innerHTML = a == null ? void 0 : a.common.copy;
  }, [a]), T = V((P) => {
    var p;
    if (P !== null && s(t == null ? void 0 : t.note) && v(P), P && ((p = t == null ? void 0 : t.note) != null && p.includes("coupon-code"))) {
      const h = P.getElementsByClassName("coupon-code")[0], b = P.getElementsByClassName("copy-btn")[0];
      b == null || b.addEventListener("click", (k) => {
        k.stopPropagation(), ai(h == null ? void 0 : h.innerHTML);
        const C = a == null ? void 0 : a.common.copied;
        b.innerHTML = C, setTimeout(() => {
          y(b);
        }, 3e3);
      });
    }
  }, [v, t, s, a, y]), f = V((P) => {
    P !== null && s(t == null ? void 0 : t.stock.reminder) && v(P);
  }, [v, t, s]), w = F(() => {
    var p;
    if (!t || !e.combineShippingAndNote)
      return null;
    const P = (p = ge()) == null ? void 0 : p.document;
    if (!P)
      return null;
    if (s(t.note)) {
      const h = P.createElement("div");
      h.innerHTML = t.note;
      const b = P.createElement("div");
      b.className = "trigger-content";
      const k = h.getElementsByClassName("trigger-target")[0], C = k.getAttribute("text");
      if (C) {
        const _ = P.createElement("p");
        _.innerHTML = C, b.appendChild(_);
      }
      const l = P.createElement("div");
      l.className = "compare-content";
      for (let _ = 1; _ < 5; _++) {
        const d = k.getAttribute("version-" + _), x = k.getAttribute("img-" + _);
        if (d && x) {
          const N = P.createElement("div");
          N.className = "compare-item", N.innerHTML = `<span>${d}</span>
                                            <div class="compare-img" style="background-image: url(${x})"></div>`, l.append(N);
        } else
          break;
      }
      b.appendChild(l), h.appendChild(b), t.note = h.innerHTML ?? "";
    }
    return /* @__PURE__ */ o(
      "span",
      {
        ref: T,
        className: "reo-various-note",
        dangerouslySetInnerHTML: { __html: t.note }
      }
    );
  }, [t, e, T, s]);
  return !t || e.imageHasShippingAndNote && he() >= 540 ? null : /* @__PURE__ */ o(ke, { children: e.combineShippingAndNote && t.stock.reminder && t.note && n ? /* @__PURE__ */ S(
    "div",
    {
      className: "reo-shipping-info",
      ref: f,
      children: [
        /* @__PURE__ */ o(
          vt,
          {
            name: "icon-icon_shipping",
            hideIcon: i
          }
        ),
        /* @__PURE__ */ o(
          "span",
          {
            className: "inline",
            dangerouslySetInnerHTML: { __html: t.stock.reminder }
          }
        ),
        /* @__PURE__ */ o(
          ln,
          {
            type: "multiLine",
            placement: un.TOP_CENTER,
            content: w,
            trigger: "hover",
            className: "shipping-question",
            contentClassName: "z-1000 note-balloon " + (t.note.includes("trigger-target") ? "has-reminder" : ""),
            children: /* @__PURE__ */ o(
              st,
              {
                name: "icon-icon_question",
                width: "14px",
                color: "#777"
              }
            )
          }
        )
      ]
    }
  ) : /* @__PURE__ */ S(ke, { children: [
    !r.includes("shipping") && t.stock.reminder && n ? /* @__PURE__ */ S(
      "div",
      {
        className: "reo-shipping-info",
        ref: f,
        children: [
          /* @__PURE__ */ o(
            vt,
            {
              name: "icon-icon_shipping",
              hideIcon: i
            }
          ),
          /* @__PURE__ */ o("div", { dangerouslySetInnerHTML: { __html: t.stock.reminder } })
        ]
      }
    ) : null,
    !r.includes("note") && t.note ? /* @__PURE__ */ o(
      "div",
      {
        className: "reo-various-note",
        ref: T,
        dangerouslySetInnerHTML: { __html: t.note }
      }
    ) : null
  ] }) });
}), so = Ie((e) => {
  const { langPack: t } = bt(ht), [n, r] = M(t == null ? void 0 : t.common.copy), i = V(() => {
    r(t == null ? void 0 : t.common.copy);
  }, [t]), a = V((s) => {
    s.stopPropagation();
    const c = e.target.current;
    if (c) {
      ai(c == null ? void 0 : c.innerHTML);
      const u = t == null ? void 0 : t.common.copied;
      r(u), setTimeout(i, 3e3);
    }
  }, [e.target, t, i]);
  return /* @__PURE__ */ o(
    "span",
    {
      className: "copy-btn",
      onClick: a,
      children: n
    }
  );
}), co = Ie(() => {
  var u, m, v;
  const { data: e, visible: t, exclude: n, hideIcon: r, langPack: i } = bt(ht), a = ae(null);
  if (n.includes("not-auto-coupon") || !t)
    return null;
  let s;
  const c = (u = e == null ? void 0 : e.activities) == null ? void 0 : u.lightningDeal;
  if (e != null && e.hasPrice && c && !(c instanceof Array) && !(c.notAutoCoupon instanceof Array) && Object.keys(c.notAutoCoupon).length !== 0) {
    const y = c.notAutoCoupon;
    return y.discountType === "amount" ? s = e.currency.symbol.replace(
      "{}",
      Number(y.discount).toFixed(e.currency.precision)
    ) : s = Math.round(y.discountValue * 100) + "%", /* @__PURE__ */ S("div", { className: "reo-not-auto-coupon", children: [
      /* @__PURE__ */ o(
        vt,
        {
          name: "icon-icon-coupon-1",
          hideIcon: r
        }
      ),
      e.discountOff || (m = e.activities) != null && m.priceBreak ? i == null ? void 0 : i["reo-product"].extra : "",
      /* @__PURE__ */ o(
        "span",
        {
          className: "reo-coupon-discount",
          dangerouslySetInnerHTML: {
            __html: `<span>${(v = i == null ? void 0 : i["reo-product"].not_auto_coupon_discount) == null ? void 0 : v.replace("$1", s)} </span>`
          }
        }
      ),
      /* @__PURE__ */ o(
        "span",
        {
          className: "not-auto-code",
          ref: a,
          children: y.couponCode
        }
      ),
      /* @__PURE__ */ o(
        so,
        {
          target: a
        }
      )
    ] });
  } else
    return null;
});
const ht = Li({
  data: null,
  exclude: [],
  visible: !1,
  hideIcon: !1,
  langPack: {},
  country: ""
}), Ci = Ie((e) => {
  const t = F(() => e.productData, [e]), n = F(() => {
    if (!t)
      return null;
    if (t.simpleType)
      return t;
    const a = e.currentVariationKey ?? (t == null ? void 0 : t.defaultVariationKey);
    for (const s in t.children) {
      const c = t.children[s];
      if (c.key === a)
        return c;
    }
    return null;
  }, [e, t]), r = F(() => !!(n != null && n.isInSale || n != null && n.isPreOrder || e != null && e.alwaysVisible), [n, e.alwaysVisible]), i = F(() => ({
    data: n,
    exclude: e.exclude ?? [],
    visible: r,
    hideIcon: !!e.hideIcon,
    langPack: e.langPack ?? {},
    country: e.country ?? ""
  }), [n, r, e]);
  return n ? /* @__PURE__ */ o(ht.Provider, { value: i, children: /* @__PURE__ */ S("div", { className: "product-tips-content " + (e.hideIcon ? "" : "has-icon"), children: [
    e.hasExtraTip ? /* @__PURE__ */ o(to, {}) : null,
    /* @__PURE__ */ o(no, {}),
    /* @__PURE__ */ o(co, {}),
    /* @__PURE__ */ o(io, {}),
    /* @__PURE__ */ o(ro, {}),
    /* @__PURE__ */ o(oo, {}),
    /* @__PURE__ */ o(
      ao,
      {
        combineShippingAndNote: e.combineShippingAndNote,
        imageHasShippingAndNote: e.imageHasShippingAndNote
      }
    )
  ] }) }) : null;
}), $t = Ie((e) => {
  var t;
  return /* @__PURE__ */ S("div", { className: "single-image", children: [
    /* @__PURE__ */ S("div", { className: "inline-block relative", children: [
      /* @__PURE__ */ o("div", { dangerouslySetInnerHTML: { __html: e.product.image } }),
      /* @__PURE__ */ o("div", { className: "label-content absolute bottom-0 right-0", children: e.product.stockStatus === 5 && /* @__PURE__ */ o("div", { className: "product-tag tag-pre-order", children: (t = e.langPack) == null ? void 0 : t["reo-product"].pre_order }) })
    ] }),
    /* @__PURE__ */ S("span", { className: "product-amount font-normal", children: [
      "x ",
      e.product.amount
    ] })
  ] });
}), Wn = Ie((e) => {
  var t, n, r, i;
  return /* @__PURE__ */ o("div", { className: "images-box", children: e.combinationNoBalloon ? (n = (t = e.mainProductData) == null ? void 0 : t.combinations) == null ? void 0 : n.map((a) => e.hasLink && !Yt(a.href) ? /* @__PURE__ */ o(
    "a",
    {
      className: "block",
      href: It(a.href),
      children: /* @__PURE__ */ o(
        $t,
        {
          product: a,
          langPack: e.langPack
        }
      )
    },
    a.id
  ) : /* @__PURE__ */ o(
    $t,
    {
      product: a,
      langPack: e.langPack
    },
    a.id
  )) : (i = (r = e.mainProductData) == null ? void 0 : r.combinations) == null ? void 0 : i.map((a) => {
    var s;
    return /* @__PURE__ */ o(
      Lt,
      {
        type: "multiLine",
        placement: Dt.TOP_CENTER,
        content: /* @__PURE__ */ S("p", { className: "text-12", children: [
          /* @__PURE__ */ o("span", { className: "product-name font-medium", children: a.parent }),
          /* @__PURE__ */ o("span", { className: "product-version font-normal", children: (s = e.langPack) == null ? void 0 : s["product-versions"][a.version] }),
          /* @__PURE__ */ S("span", { className: "product-amount font-medium", children: [
            "x ",
            a.amount
          ] })
        ] }),
        trigger: "hover",
        contentClassName: "z-1000 image-balloon",
        children: e.hasLink && !a.href.includes("javascript") ? /* @__PURE__ */ o(
          "a",
          {
            className: "block",
            href: It(a.href),
            children: /* @__PURE__ */ o(
              $t,
              {
                product: a,
                langPack: e.langPack
              }
            )
          }
        ) : /* @__PURE__ */ o(
          $t,
          {
            product: a,
            langPack: e.langPack
          }
        )
      },
      a.id
    );
  }) });
}), lo = Ie((e) => {
  const { boxList: t } = e, n = V((s) => /* @__PURE__ */ o(ke, { children: s.map((c, u) => /* @__PURE__ */ S(
    "div",
    {
      className: "wib-item",
      children: [
        /* @__PURE__ */ o(
          "img",
          {
            src: c.boxes.content,
            alt: ""
          }
        ),
        /* @__PURE__ */ S("p", { className: "item-text", children: [
          c.boxes.title,
          " x ",
          c.quantity
        ] })
      ]
    },
    u
  )) }), []);
  if (!t.length)
    return null;
  const r = he() > 480 ? 9 : 6, i = Math.ceil(t.length / r), a = [];
  for (let s = 0; s < i; s++)
    a.push(t.slice(s * r, (s + 1) * r));
  return /* @__PURE__ */ o(ke, { children: a.length > 1 ? /* @__PURE__ */ o(
    mt,
    {
      showArrows: he() > 768,
      autoPlay: !1,
      children: a.map((s, c) => /* @__PURE__ */ o(it, { children: n(s) }, c))
    }
  ) : n(a[0]) });
}), uo = Ie((e) => {
  const { boxList: t } = e, [n, r] = M(!1), i = V(() => {
    r(!0), _n();
  }, []), a = V(() => {
    r(!1), Cn();
  }, []);
  if (!t.length)
    return null;
  let s = t;
  return s && s.length > 9 && (s = s.slice(0, 9)), /* @__PURE__ */ S(ke, { children: [
    /* @__PURE__ */ S(
      "div",
      {
        className: "wib-box",
        onClick: i,
        children: [
          s == null ? void 0 : s.map((c, u) => /* @__PURE__ */ o(
            "img",
            {
              src: c.boxes.content,
              alt: ""
            },
            u
          )),
          /* @__PURE__ */ o(
            st,
            {
              name: "icon-icon_full-screen",
              width: "16px",
              color: "#777",
              className: "full-screen"
            }
          )
        ]
      }
    ),
    n && /* @__PURE__ */ o(
      Nt,
      {
        mask: !0,
        center: !0,
        class: he() > 810 ? "" : "w-calc-full-40",
        onClose: a,
        children: /* @__PURE__ */ S("div", { className: "wib-details", children: [
          /* @__PURE__ */ o(lo, { boxList: t }),
          /* @__PURE__ */ o(
            "span",
            {
              className: "absolute top-0 right-0 transform -translate-y-1/2 rounded-full w-32 h-32 bg-black-opacity-70 flex items-center justify-center cursor-pointer",
              onClick: a,
              children: /* @__PURE__ */ o(
                st,
                {
                  name: "icon-cross2",
                  width: "12px",
                  color: "#fff"
                }
              )
            }
          )
        ] })
      }
    )
  ] });
}), Hn = Ie((e) => {
  const { currentVariationData: t } = e, [n, r] = M(!1);
  return t ? /* @__PURE__ */ o(ke, { children: t && /* @__PURE__ */ S("div", { className: "product-image " + (e.className ?? ""), children: [
    e.hasLink && !Yt(t.href) ? /* @__PURE__ */ o(
      "a",
      {
        className: "w-full h-full flex items-center justify-center",
        href: It(t.href),
        target: "_blank",
        rel: "noreferrer",
        children: e.preferSceneImg && t.image.store ? /* @__PURE__ */ o(
          "div",
          {
            className: "scene-image",
            style: { backgroundImage: `url(${t.image.store})` }
          }
        ) : /* @__PURE__ */ o(
          "img",
          {
            src: t.image.pc,
            alt: t.key + "-image"
          }
        )
      }
    ) : /* @__PURE__ */ o(ke, { children: e.preferSceneImg && t.image.store ? /* @__PURE__ */ o(
      "div",
      {
        className: "scene-image",
        style: { backgroundImage: `url(${t.image.store})` }
      }
    ) : /* @__PURE__ */ o(
      "img",
      {
        src: t.image.pc,
        alt: t.key + "-image"
      }
    ) }),
    e.promotionVideo ? /* @__PURE__ */ S(ke, { children: [
      /* @__PURE__ */ o(
        "div",
        {
          className: "reo-video-play",
          onClick: () => {
            r(!0);
          },
          children: /* @__PURE__ */ o(
            st,
            {
              name: "icon-icon_play-2",
              color: "#fff",
              width: "16px"
            }
          )
        }
      ),
      n && /* @__PURE__ */ o(
        ha,
        {
          options: { videoId: e.promotionVideo },
          onClose: () => {
            r(!1);
          },
          className: "reo-promotion-video-wrap",
          loadingClassName: "loading-center",
          videoClassName: "video-content",
          closeClassName: "close-btn"
        }
      )
    ] }) : null
  ] }) }) : null;
});
const fo = Ie((e) => {
  var c, u, m, v, y, T, f;
  const t = F(() => e.productData, [e]), n = F(() => e.currentVariationKey ? e.currentVariationKey : t == null ? void 0 : t.defaultVariationKey, [e, t]), r = F(() => {
    if (!t)
      return null;
    if (t.simpleType)
      return t;
    for (const w in t.children) {
      const P = t.children[w];
      if (P.key === n)
        return P;
    }
    return null;
  }, [t, n]), i = F(() => {
    if (!e.hasPromotionVideo || !(t != null && t.videos))
      return null;
    const w = t.videos.filter((P) => P.type === "promotion")[0];
    return w ? w.url : null;
  }, [e, t]), [a, s] = M("image");
  return !r || !t ? null : /* @__PURE__ */ S(ke, { children: [
    t.isCombination ? /* @__PURE__ */ o("div", { className: "combination-images " + (e.className ?? ""), children: !e.onlyCombinationImages && ((c = t.boxList) != null && c.length || (u = t.combinationImages) != null && u.length) ? /* @__PURE__ */ S(
      mt,
      {
        isHoverArrow: !1,
        autoPlay: !1,
        swipeable: he() < 768,
        children: [
          /* @__PURE__ */ o(it, { children: /* @__PURE__ */ o(
            Wn,
            {
              mainProductData: t,
              combinationNoBalloon: e.combinationNoBalloon,
              hasLink: e.hasLink,
              langPack: e.langPack
            }
          ) }),
          t.boxList && t.boxList.length > 0 ? /* @__PURE__ */ o(it, { children: /* @__PURE__ */ o(
            uo,
            {
              boxList: t.boxList
            }
          ) }) : "",
          (m = t.combinationImages) != null && m[0] ? /* @__PURE__ */ o(it, { children: /* @__PURE__ */ o(
            "img",
            {
              src: t.combinationImages[0],
              alt: ""
            }
          ) }) : "",
          (v = t.combinationImages) != null && v[1] ? /* @__PURE__ */ o(it, { children: /* @__PURE__ */ o(
            "img",
            {
              src: t.combinationImages[1],
              alt: ""
            }
          ) }) : "",
          (y = t.combinationImages) != null && y[2] ? /* @__PURE__ */ o(it, { children: /* @__PURE__ */ o(
            "img",
            {
              src: t.combinationImages[2],
              alt: ""
            }
          ) }) : ""
        ]
      }
    ) : /* @__PURE__ */ o(
      Wn,
      {
        mainProductData: t,
        combinationNoBalloon: e.combinationNoBalloon,
        hasLink: e.hasLink,
        langPack: e.langPack
      }
    ) }) : /* @__PURE__ */ o("div", { className: "images-box " + (e.className ?? ""), children: e.has3DPreview && t.threeDModel ? /* @__PURE__ */ S("div", { className: "image-and-3d", children: [
      a === "image" ? /* @__PURE__ */ o(
        Hn,
        {
          currentVariationData: r,
          promotionVideo: i,
          hasLink: e.hasLink,
          preferSceneImg: e.preferSceneImg,
          className: e.className
        }
      ) : /* @__PURE__ */ o(
        ia,
        {
          productData: t,
          active: a === "3d",
          size: "small",
          langPack: e.langPack,
          country: e.country
        }
      ),
      /* @__PURE__ */ o(
        Ki,
        {
          className: "mt-20",
          active: a,
          scroll: !1,
          scrollBtn: !1,
          showLine: !0,
          hoverColor: "#0E6AFF",
          activeColor: "#0E6AFF",
          optionName: {
            label: "name",
            value: "key"
          },
          options: [
            {
              key: "image",
              name: (T = e.langPack) == null ? void 0 : T["reo-product"].photo
            },
            {
              key: "3d",
              name: (f = e.langPack) == null ? void 0 : f["reo-product"]["360_view"]
            }
          ],
          onChange: (w) => {
            s(w);
          }
        }
      )
    ] }) : /* @__PURE__ */ o(
      Hn,
      {
        currentVariationData: r,
        promotionVideo: i,
        hasLink: e.hasLink,
        preferSceneImg: e.preferSceneImg,
        className: e.className
      }
    ) }),
    e.hasShippingAndNote && /* @__PURE__ */ o(
      Ci,
      {
        productData: t,
        currentVariationKey: e.currentVariationKey,
        combineShippingAndNote: e.combineShippingAndNote,
        hideIcon: e.hideIcon,
        exclude: ["coupon", "promotion", "stock", "time"],
        langPack: e.langPack,
        country: e.country
      }
    )
  ] });
}), wi = Ie((e) => {
  var i, a, s, c;
  const t = F(() => e.productData, [e]), n = F(() => e.currentVariationKey ? e.currentVariationKey : (t == null ? void 0 : t.defaultVariationKey) ?? "", [e, t]), r = F(() => {
    if (t != null && t.simpleType)
      return t;
    if (!(t != null && t.children))
      return null;
    for (const u in t.children) {
      const m = t.children[u];
      if (m.key === n)
        return m;
    }
    return null;
  }, [t, n]);
  return !(r != null && r.isInSale || r != null && r.isPreOrder) || !Array.isArray((i = r.activities) == null ? void 0 : i.lightningDeal) && ((s = (a = r.activities) == null ? void 0 : a.lightningDeal) == null ? void 0 : s.discount) == 0 || !(r != null && r.endTime && r.startTime) ? null : /* @__PURE__ */ o("div", { className: `limited-time ${e.className ?? ""}`, children: /* @__PURE__ */ o(
    Ti,
    {
      endTime: r.endTime,
      startTime: r.startTime,
      langPack: e.langPack ?? {},
      children: /* @__PURE__ */ o("span", { className: "limited-time-text", children: (c = e.langPack) == null ? void 0 : c["reo-product"].limited_time })
    }
  ) });
});
const Pi = Ie((e) => {
  var $, ce, Z;
  const { exclude: t, onlySaleable: n, buttonSize: r, saveVariationQty: i } = e, a = ae(e.initQty ?? 1), s = ae({}), c = ae(he() < 768), u = ae(si()), [m, v] = M(a.current), [y, T] = M(!1), [f, w] = M(!1), [P, p] = M(""), [h, b] = M(), [k, C] = M(!1);
  ne(() => {
    (async () => {
      const R = new Ze(e.productsData, e.country);
      await R.init(), b(R);
    })().catch(console.error);
  }, [e]);
  const l = F(() => e.isSSR ? dn(e.productsData, e.productKey ?? "") : h && e.productKey ? h.getProductByKey(e.productKey) : null, [e, h]), _ = F(() => e.currentVariationKey ? e.currentVariationKey : (l == null ? void 0 : l.defaultVariationKey) ?? "", [e, l]), d = F(() => l ? l.simpleType ? l : h ? h.getVariationByKey(l, _) : dn(e.productsData, _) : null, [l, _, h, e]), x = F(() => Sr(), []), N = F(() => x.includes(e.country), [x, e.country]), I = F(() => {
    var O;
    return (((O = l == null ? void 0 : l.uiData) == null ? void 0 : O.referrals) ?? []).length > 0;
  }, [l]);
  ne(() => {
    var R, O;
    if (l && !l.salePolicies.sellable) {
      const L = (O = (R = ge()) == null ? void 0 : R.aliexpressActivities) == null ? void 0 : O.products;
      if (L != null && L.length) {
        const z = L.filter((W) => W.id === l.id)[0];
        z != null && z.link && w(!0);
      }
    }
  }, [l]);
  const B = F(() => {
    var L, z, W, q;
    const R = {
      salePrice: null,
      prePrice: null
    }, O = d == null ? void 0 : d.price;
    if (f) {
      const Y = (z = (L = ge()) == null ? void 0 : L.aliexpressActivities) == null ? void 0 : z.aliExpress, re = (q = (W = ge()) == null ? void 0 : W.aliexpressActivities) == null ? void 0 : q.products.filter((K) => K.id === (l == null ? void 0 : l.id))[0];
      Y && Ft(Y.notBefore, Y.notAfter) && (Number(re == null ? void 0 : re.salePrice) && Number(re == null ? void 0 : re.price) && (R.salePrice = (re == null ? void 0 : re.salePrice) ?? null, Number(re == null ? void 0 : re.salePrice) < Number(re == null ? void 0 : re.price) && (R.prePrice = (re == null ? void 0 : re.price) ?? null)), Y.notes && p(Y.notes));
    } else
      d != null && d.isInSale || d != null && d.isPreOrder ? (R.salePrice = (O == null ? void 0 : O.currentPrice) ?? null, d.discountOff && (R.prePrice = (O == null ? void 0 : O.regularPrice) ?? null)) : Number(O == null ? void 0 : O.regularPrice) && (R.salePrice = (O == null ? void 0 : O.regularPrice) ?? null);
    return R;
  }, [d, l, f]), ie = V((R) => {
    var z;
    const O = d != null && d.discountOff ? "save_discount" : "save_now", L = {
      text: e.isDiscountBtn ? O : "add_to_cart",
      class: "is-in-sale",
      color: e.buttonGhost ? "#FF4B2B" : "#fff",
      borderColor: (e.buttonGhost, "#FF4B2B"),
      backgroundColor: e.buttonGhost ? "#fff" : "#FF4B2B",
      activeColor: "#fff",
      activeBorderColor: e.buttonGhost ? "#FF4B2B" : "rgba(255, 75, 43, 0.8)",
      activeBackgroundColor: e.buttonGhost ? "#FF4B2B" : "rgba(255, 75, 43, 0.8)",
      iconName: e.hasCartIcon ? "icon-icon_cart-992" : void 0,
      iconWidth: e.hasCartIcon ? "22px" : "",
      iconHeight: e.hasCartIcon ? "22px" : ""
    };
    switch (R) {
      case "referral": {
        const W = (z = l == null ? void 0 : l.uiData) == null ? void 0 : z.referrals[0];
        L.class = "is-referral", L.color = "#fff", L.activeColor = "#fff", L.text = W.button.text, L.borderColor = W.button.bgColor, L.backgroundColor = W.button.bgColor, L.activeBorderColor = W.button.bgColor, L.activeBackgroundColor = W.button.bgColor;
        break;
      }
      case "pre-order": {
        L.class = "is-pre-order", L.text = e.isDiscountBtn ? O : "pre_order_now";
        break;
      }
      case "coming-soon": {
        L.color = "#fff", L.borderColor = "#0E6AFF", L.backgroundColor = "#0E6AFF", L.activeColor = "#fff", L.activeBorderColor = "rgba(14,106,255,0.8)", L.activeBackgroundColor = "rgba(14,106,255,0.8)", L.text = "notify_me", L.class = "is-coming-soon";
        break;
      }
      case "out-of-stock": {
        L.text = "out_of_stock", L.class = "is-out-of-stock";
        break;
      }
      case "aliexpress": {
        L.text = "shop_at", L.class = "is-aliexpress";
        break;
      }
    }
    return L;
  }, [l, d, e.isDiscountBtn, e.buttonGhost, e.hasCartIcon]), X = F(() => {
    var O, L;
    T(!1);
    let R = "add-to-cart";
    return l != null && l.salePolicies.sellable ? I ? R = "referral" : e.isDependOnAllStock && !l.simpleType ? d != null && d.isInSale ? R = "add-to-cart" : d != null && d.isPreOrder ? R = "pre-order" : (O = l.saleVariations) != null && O.length ? l.saleVariations.filter((W) => {
      var q, Y;
      return (Y = (q = l.children) == null ? void 0 : q[W]) == null ? void 0 : Y.isInSale;
    }).length || (R = "pre-order") : l.subversion.versionProductIds.filter((W) => {
      var q, Y;
      return (Y = (q = l.children) == null ? void 0 : q[W]) == null ? void 0 : Y.isComingSoon;
    }).length ? R = "coming-soon" : (R = "out-of-stock", T(!0)) : e.showVariationContent ? e.isOfflineProduct && !x.includes(e.country) ? R = "add-to-cart" : l != null && l.simpleType ? (l.isComingSoon || l.isOutOfStock) && (R = "coming-soon") : (L = l.saleVariations) != null && L.length ? d != null && d.isPreOrder && (R = "pre-order") : R = "coming-soon" : e.alwaysCanPurchase ? d != null && d.isPreOrder && (R = "pre-order") : d != null && d.isInSale || d != null && d.isPreOrder ? d.isPreOrder && (R = "pre-order") : d != null && d.isComingSoon ? R = "coming-soon" : (R = "out-of-stock", T(!0)) : f ? R = "aliexpress" : (R = "out-of-stock", T(!0)), ie(R);
  }, [d, l, e, ie, f, x, I]);
  ne(() => {
    i && s.current[_] ? v(s.current[_]) : v(a.current);
  }, [_, i]), ne(() => {
    var R;
    if (c.current && P) {
      const O = (R = document.getElementsByClassName("mod-product-add-to-cart")[0]) == null ? void 0 : R.getElementsByClassName("ui-point")[0];
      O && (O.innerHTML = P);
    }
  }, [P]), j.useEffect(() => {
    var R;
    e.showVariationContent && e.initVariationContentShow && ((R = h == null ? void 0 : h.productsData) != null && R.length) && et.showPopup("variationContent", {
      productsData: h == null ? void 0 : h.productsData,
      productKey: l == null ? void 0 : l.key,
      currentVariationKey: _,
      hasAmzPrimeBtn: e.hasAmzPrimeBtn,
      isDistributor: e.isDistributor,
      langPack: e.langPack,
      country: e.country
    });
  }, [
    _,
    l == null ? void 0 : l.key,
    h == null ? void 0 : h.productsData,
    e.country,
    e.hasAmzPrimeBtn,
    e.initVariationContentShow,
    e.isDistributor,
    e.langPack,
    e.showVariationContent
  ]);
  const se = V(async (R) => {
    var L, z, W, q, Y, re, K, pe, oe, Ue, Be, G, de, fe, xe, ee, Te;
    const O = R.currentTarget;
    if (R == null || R.stopPropagation(), T(!0), rt(O, "is-referral"))
      window.location.href = l.uiData.referrals[0].link;
    else if (rt(O, "is-in-sale") || rt(O, "is-pre-order") || rt(O, "buy-now"))
      if (e.showVariationContent)
        et.showPopup("variationContent", {
          productsData: h == null ? void 0 : h.productsData,
          productKey: l == null ? void 0 : l.key,
          currentVariationKey: _,
          hasAmzPrimeBtn: e.hasAmzPrimeBtn,
          isDistributor: e.isDistributor,
          langPack: e.langPack,
          country: e.country
        });
      else {
        let be = [];
        const De = [];
        try {
          let Ee = [{
            id: d.id,
            number: m
          }], Oe = d.id;
          const Le = e.externalProsToPurchase;
          Le && (Ee = Le.products.map((Ve) => ({
            id: Ve.id,
            number: Ve.number
          })), Le.recommendation && (Oe = Le.recommendation));
          const We = await di.addToCartBatch(Ee, Oe), je = {
            currency: l.currency.code,
            value: 0,
            items: []
          };
          if (e.externalProsToPurchase)
            for (const Ve of e.externalProsToPurchase.products)
              je.items.push({
                item_id: Ve.mainId ?? 0,
                item_name: Ve.mainKey ?? "",
                item_category: Ve.category ?? "",
                price: Number(Ve.price),
                quantity: Ve.number
              }), je.value += Number(Ve.price) * Ve.number;
          else
            je.items.push({
              item_id: l.id,
              item_name: l.key,
              item_category: ((L = l == null ? void 0 : l.categories[0]) == null ? void 0 : L.key) ?? "",
              price: Number(d.price.currentPrice),
              quantity: m
            }), je.value = Number(d.price.currentPrice) * m;
          if ((W = (z = ge()) == null ? void 0 : z.gtag) == null || W.call(z, "event", "add_to_cart", je), (q = e.addToCartCallback) == null || q.call(e, je), e.country === "US" && ((re = (Y = ge()) == null ? void 0 : Y.rdt) == null || re.call(Y, "track", "AddToCart")), We) {
            if (rt(O, "buy-now")) {
              window.location.href = Gt("/cart/");
              return;
            }
            if ((K = We.combination) != null && K.length)
              be = We.combination;
            else if ((pe = We.recommendation) != null && pe.length && We.recommendationProduct && !(We.recommendationProduct instanceof Array)) {
              const Ve = new Ze(We.recommendationProduct, e.country);
              await Ve.init();
              for (const tt of We.recommendation) {
                const Ye = Ve.getProductById(tt);
                if (Ye) {
                  if (Ye.simpleType) {
                    if (!(Ye.isInSale || Ye.isPreOrder))
                      continue;
                  } else if (!((oe = Ye.saleVariations) != null && oe.length))
                    continue;
                  De.push(Ye);
                }
              }
            }
          }
          et.showPopup("handledResult", {
            type: "addToCartSuccess",
            combinations: be,
            recommendations: De,
            langPack: e.langPack,
            country: e.country
          }), document.body.dispatchEvent(new Event("afterAddToCart")), wn() && document.dispatchEvent(new Event("wc_update_cart"));
        } catch (Ee) {
          console.error(Ee);
          const Oe = (Ue = Ee == null ? void 0 : Ee._rawError) == null ? void 0 : Ue.detail;
          let Le = (Be = e.langPack) == null ? void 0 : Be["reo-product"]["UNKNOWN_ERROR".toLowerCase()], We = d.name;
          if ((G = Oe == null ? void 0 : Oe.fail_products) != null && G[0].product_name && (We = Oe == null ? void 0 : Oe.fail_products[0].product_name), Oe != null && Oe.code) {
            const je = (de = e.langPack) == null ? void 0 : de["reo-product"][Oe.code.toLowerCase()];
            We ? Le = je == null ? void 0 : je.replace("$1", We) : Le = je;
          }
          et.showPopup("handledResult", {
            type: "addToCartFailed",
            errorDes: Le,
            langPack: e.langPack,
            country: e.country
          });
        }
      }
    else if (rt(O, "is-coming-soon")) {
      const be = [];
      try {
        const De = await Zi(l.key);
        if ((fe = De.recommendation) != null && fe.length && De.recommendationProduct && !(De.recommendationProduct instanceof Array)) {
          const Ee = new Ze(De.recommendationProduct, e.country);
          await Ee.init();
          for (const Oe of De.recommendation) {
            const Le = Ee.getProductById(Oe);
            if (Le) {
              if (Le.simpleType) {
                if (!(Le.isInSale || Le.isPreOrder))
                  continue;
              } else if (!((xe = Le.saleVariations) != null && xe.length))
                continue;
              be.push(Le);
            }
          }
        }
        et.showPopup("handledResult", {
          type: "subscribeContent",
          productsData: h == null ? void 0 : h.productsData,
          productKey: l == null ? void 0 : l.key,
          currentVariationKey: _,
          recommendations: be,
          isSubscribeMainVersion: !!(e.isDependOnAllStock || e.showVariationContent),
          langPack: e.langPack,
          country: e.country
        });
      } catch (De) {
        console.error(De);
      }
    } else
      rt(O, "is-aliexpress") && (et.hidePopup("hideHandledResult"), (Te = (ee = ge()) == null ? void 0 : ee.gtag) == null || Te.call(ee, "event", "shop-at-aliexpress", {
        event_category: "aliexpress",
        event_label: location.href
      }), window.location.href = l == null ? void 0 : l.salePolicies.link);
    rt(O, "is-out-of-stock") || T(!1);
  }, [d, _, l, h, e, m]), Q = V((R, O) => {
    var z;
    const L = (h == null ? void 0 : h.getProductByKey(R)) ?? null;
    (z = e.onVariationChange) == null || z.call(e, R, L), O == null || O.stopPropagation();
  }, [e, h]), ve = V((R) => {
    var O;
    v(R), (O = e.onQuantityChange) == null || O.call(e, R, d), i && (s.current[d.key] = R);
  }, [e, d, i]), ye = V((R) => {
    var L, z;
    const O = R.data;
    return O ? R.versionType === "pa_color" ? /* @__PURE__ */ o(
      "div",
      {
        "data-id": O.id,
        className: `
                        accessory-variation-content
                        color-content
                        ${O.key === _ ? "active" : ""}
                    `,
        onClick: (W) => Q(O.key, W),
        children: e.hideColorVariationBalloon ? /* @__PURE__ */ o(
          "div",
          {
            className: "color-inner",
            style: { background: O.color }
          }
        ) : /* @__PURE__ */ o(
          Lt,
          {
            type: "singleLine",
            content: (L = e.langPack) == null ? void 0 : L["product-versions"][O.version],
            placement: Dt.TOP_CENTER,
            trigger: "hover",
            contentClassName: "color-text z-1000",
            children: /* @__PURE__ */ o(
              "div",
              {
                className: "color-inner",
                style: { background: O.color }
              }
            )
          }
        )
      },
      "product-" + O.id
    ) : /* @__PURE__ */ o(
      "div",
      {
        "data-id": O.id,
        className: `
                        accessory-variation-content
                        text-content
                        ${O.key === _ ? "active" : ""}
                    `,
        onClick: () => Q(O.key),
        children: (z = e.langPack) == null ? void 0 : z["product-versions"][O.version]
      },
      "product-" + O.id
    ) : null;
  }, [_, e, Q]), ue = V(() => {
    C(!0);
  }, []), _e = F(() => {
    var L, z, W;
    if (!l || l.simpleType || t != null && t.includes("selector") || I || f)
      return null;
    const R = n ? l.saleVariations : l.subversion.versionProductIds, O = ((L = l.subversion.defaultVersion) == null ? void 0 : L.paKey) ?? "";
    if (R != null && R.length) {
      if (e.useAccessoryVariation && l.isAccessory)
        return /* @__PURE__ */ o("div", { className: "accessory-select flex items-center", children: R.map((q) => {
          var Y;
          return ye({
            data: ((Y = l.children) == null ? void 0 : Y[q]) ?? null,
            versionType: O
          });
        }) });
      {
        const q = [];
        for (const Y of R) {
          const re = (z = l.children) == null ? void 0 : z[Y];
          re && q.push({
            key: re.key,
            text: ((W = e.langPack) == null ? void 0 : W["product-versions"][re.version]) ?? ""
          });
        }
        return /* @__PURE__ */ o(
          hn,
          {
            fullDropDownWords: !0,
            options: q,
            className: "reo-product-select",
            width: "100%",
            dropDownClassName: "z-1001",
            size: e.selectSize ?? "medium",
            value: _,
            onChange: Q
          }
        );
      }
    } else
      return null;
  }, [l, t, f, n, I, e.useAccessoryVariation, e.selectSize, e.langPack, ye, _, Q]), E = F(() => {
    var R, O, L, z, W;
    return t != null && t.includes("buttons") || !d ? null : I && X.class !== "is-aliexpress" ? /* @__PURE__ */ o(
      Qe,
      {
        className: "reo-product-btn " + X.class,
        size: r ?? "medium",
        color: X.color,
        borderColor: X.borderColor,
        backgroundColor: X.backgroundColor,
        activeColor: X.activeColor,
        activeBorderColor: X.activeBorderColor,
        activeBackgroundColor: X.activeBackgroundColor,
        disabled: y,
        onClick: (q) => {
          se(q).catch(console.error);
        },
        children: X.text
      }
    ) : N && !I ? /* @__PURE__ */ S(ke, { children: [
      /* @__PURE__ */ o(
        Qe,
        {
          className: "contact-sales",
          color: "#fff",
          activeColor: "#fff",
          size: r ?? "medium",
          onClick: ue,
          children: (R = e.langPack) == null ? void 0 : R["reo-product"]["contact-sales"]
        }
      ),
      /* @__PURE__ */ o(
        Zo,
        {
          open: k,
          langPack: e.langPack,
          lang: u.current,
          onCancel: () => {
            C(!1);
          }
        }
      )
    ] }) : /* @__PURE__ */ S(ke, { children: [
      e.addedJumpToCart && (d.isInSale || d.isPreOrder) ? null : /* @__PURE__ */ o(
        Qe,
        {
          className: "reo-product-btn " + X.class,
          disabled: y,
          size: r ?? "medium",
          color: X.color,
          borderColor: X.borderColor,
          backgroundColor: X.backgroundColor,
          activeColor: X.activeColor,
          activeBorderColor: X.activeBorderColor,
          activeBackgroundColor: X.activeBackgroundColor,
          icon: X.iconName,
          iconPosition: X.iconName === "icon-icon_cart-992" ? "left" : "right",
          onClick: (q) => {
            se(q).catch(console.error);
          },
          children: d.discountOff ? (L = (O = e.langPack) == null ? void 0 : O["reo-product"][X.text]) == null ? void 0 : L.replace("$1", d.discountOff.toString()) : (z = e.langPack) == null ? void 0 : z["reo-product"][X.text]
        }
      ),
      (e.hasBuyNowBtn || e.addedJumpToCart) && (d.isInSale || d.isPreOrder || e.alwaysCanPurchase) ? /* @__PURE__ */ o(
        Qe,
        {
          className: "buy-now",
          size: r ?? "medium",
          disabled: y,
          activeBackgroundColor: "#FF4B2B",
          activeBorderColor: "#FF4B2B",
          activeColor: "#fff",
          backgroundColor: "#fff",
          borderColor: "#FF4B2B",
          color: "#FF4B2B",
          onClick: (q) => {
            se(q).catch(console.error);
          },
          children: (W = e.langPack) == null ? void 0 : W["reo-product"].buy_now
        }
      ) : null
    ] });
  }, [se, ue, y, X, r, d, t, N, k, I, e]);
  if (!d || !l)
    return null;
  if (n) {
    if (l.simpleType && !l.isInSale && !l.isPreOrder)
      return null;
    if (!l.simpleType && !(($ = l.saleVariations) != null && $.length))
      return null;
  }
  return /* @__PURE__ */ S("div", { className: "product-buy-content", children: [
    _e,
    t != null && t.includes("price") ? null : /* @__PURE__ */ S("div", { className: "price-content", children: [
      B.salePrice && /* @__PURE__ */ o("span", { className: "sale-price", children: d.currency.symbol.replace("{}", Number(B.salePrice).toFixed(d.currency.precision)) }),
      e.priceShowDiscount && !f && (d.isInSale || d.isPreOrder) && d.discountOff ? /* @__PURE__ */ o("span", { className: "product-tag tag-discount", children: (Z = (ce = e.langPack) == null ? void 0 : ce["reo-product"].$1_off) == null ? void 0 : Z.replace("$1", d.discountOff.toString()) }) : null,
      !e.hidePrePrice && B.prePrice ? /* @__PURE__ */ o("del", { className: "pre-price", children: d.currency.symbol.replace("{}", Number(B.prePrice).toFixed(d.currency.precision)) }) : null
    ] }),
    /* @__PURE__ */ S("div", { className: "quantity-and-buttons " + (e.hasBuyNowBtn ? "has-buy-now-btn" : ""), children: [
      !(t != null && t.includes("quantity")) && (d.isInSale || d.isPreOrder) && !I ? /* @__PURE__ */ o(
        ii,
        {
          value: m,
          onChange: (R) => ve(R),
          minValue: a.current,
          maxValue: (e == null ? void 0 : e.addToCartLimit) ?? void 0,
          disabled: e.fixedQty,
          float: !1,
          className: "reo-quantity-controller"
        }
      ) : null,
      E
    ] }),
    P ? /* @__PURE__ */ o(
      "div",
      {
        className: "reo-aliexpress-note mt-20",
        dangerouslySetInnerHTML: { __html: P }
      }
    ) : null
  ] });
});
const wt = Ie((e) => {
  var k, C;
  const [t, n] = M(), r = ae(!1);
  ne(() => {
    (async () => {
      const l = new Ze(e.productsData, e.country);
      await l.init(), n(l);
    })().catch(console.error);
  }, [e]);
  const i = F(() => e.isSSR ? dn(e.productsData, e.productKey ?? "") : t && e.productKey ? t.getProductByKey(e.productKey) : null, [t, e]), a = V(() => {
    if (e.currentVariationKey)
      return e.currentVariationKey;
    if (i) {
      if (Rt != null && Rt[i.key] && !e.isSSR)
        return Rt[i.key];
      e.withRelatedProduct && (t == null || t.setDefaultVariation(i, !0));
      const l = i == null ? void 0 : i.defaultVariationKey;
      return l && e.isSSR && (Rt[i.key] = l), l;
    }
  }, [i, t, e.currentVariationKey, e.isSSR, e.withRelatedProduct]), [s, c] = M(a()), u = F(() => {
    var _;
    return (((_ = i == null ? void 0 : i.uiData) == null ? void 0 : _.referrals) ?? []).length > 0;
  }, [i]), m = F(() => {
    const l = ["pre-order"];
    return e.isDiscountBtn || l.push("discount"), e.showAliExpressTag && l.push("aliexpress"), l;
  }, [e]), v = V((l) => {
    c(l);
  }, []), y = F(() => {
    var l;
    return !i || (l = e.boxExclude) != null && l.includes("tips") || u ? null : /* @__PURE__ */ o(
      Ci,
      {
        productData: i,
        currentVariationKey: s,
        combineShippingAndNote: e.combineShippingAndNote,
        imageHasShippingAndNote: e.imageHasShippingAndNote,
        hideIcon: e.tipsHideIcon,
        alwaysVisible: e.tipsAlwaysVisible,
        exclude: e.tipsExclude,
        hasExtraTip: e.hasExtraTip,
        langPack: e.langPack,
        country: e.country
      }
    );
  }, [i, s, u, e]), T = F(() => {
    var l;
    return !i || (l = e.boxExclude) != null && l.includes("tags") || e.showLowPricePic ? null : /* @__PURE__ */ o(
      fi,
      {
        productsData: (t == null ? void 0 : t.productsData) ?? e.productsData,
        productKey: i.key,
        currentVariationKey: s,
        include: m,
        country: e.country,
        isDistributor: e.isDistributor,
        langPack: e.langPack
      }
    );
  }, [i, t, s, m, e]), f = F(() => {
    var l;
    return !i || (l = e.boxExclude) != null && l.includes("handle") ? null : /* @__PURE__ */ o(
      Pi,
      {
        productsData: (t == null ? void 0 : t.productsData) ?? e.productsData,
        productKey: i.key,
        currentVariationKey: s,
        isSSR: e.isSSR,
        exclude: e.panelExclude,
        onlySaleable: e.onlySaleable,
        buttonSize: e.buttonSize,
        buttonGhost: e.buttonGhost,
        selectSize: e.selectSize,
        hasCartIcon: e.hasCartIcon,
        initQty: e.initQty,
        fixedQty: e.fixedQty,
        saveVariationQty: e.saveVariationQty,
        showVariationContent: e.showVariationContent,
        initVariationContentShow: e.initVariationContentShow,
        isDependOnAllStock: e.isDependOnAllStock,
        useAccessoryVariation: e.useAccessoryVariation,
        hideColorVariationBalloon: e.hideColorVariationBalloon,
        priceShowDiscount: e.priceShowDiscount,
        isDiscountBtn: e.isDiscountBtn,
        hasBuyNowBtn: e.hasBuyNowBtn,
        hasAmzPrimeBtn: e.hasAmzPrimeBtn,
        addedJumpToCart: e.addedJumpToCart,
        langPack: e.langPack,
        country: e.country,
        isDistributor: e.isDistributor,
        isOfflineProduct: e.isOfflineProduct,
        onVariationChange: v,
        onQuantityChange: e.onQuantityChange,
        addToCartLimit: e.addToCartLimit,
        addToCartCallback: e.addToCartCallback,
        hidePrePrice: e.hidePrePrice
      }
    );
  }, [t, i, s, e, v]), w = F(() => {
    var l;
    return !i || (l = e.boxExclude) != null && l.includes("time") || e.showLowPricePic ? null : /* @__PURE__ */ o(
      wi,
      {
        productData: i,
        currentVariationKey: s,
        langPack: e.langPack,
        country: e.country
      }
    );
  }, [s, i, e]), P = F(() => {
    var l;
    return !i || (l = e.boxExclude) != null && l.includes("image") ? null : /* @__PURE__ */ S("div", { className: "image-content", children: [
      e.separateLimitedAndTag ? /* @__PURE__ */ S(ke, { children: [
        w,
        T
      ] }) : /* @__PURE__ */ S("div", { className: "limited-and-tag", children: [
        w,
        T
      ] }),
      /* @__PURE__ */ o(
        fo,
        {
          productData: i,
          currentVariationKey: s,
          hasLink: e.hasLink,
          has3DPreview: e.has3DPreview,
          preferSceneImg: e.preferSceneImg,
          hasShippingAndNote: e.imageHasShippingAndNote,
          combineShippingAndNote: e.combineShippingAndNote,
          hideIcon: e.tipsHideIcon,
          onlyCombinationImages: e.onlyCombinationImages,
          combinationNoBalloon: e.combinationNoBalloon,
          hasPromotionVideo: e.hasPromotionVideo,
          langPack: e.langPack,
          country: e.country
        }
      )
    ] });
  }, [i, s, e, w, T]), p = F(() => {
    var _, d;
    if (u)
      return !1;
    let l = !1;
    if (i != null && i.simpleType)
      ((_ = i.activities) == null ? void 0 : _.flashSale) instanceof Array || (l = !0);
    else if (i != null && i.children)
      for (const x in i.children) {
        const N = i.children[x];
        if (N && !(((d = N.activities) == null ? void 0 : d.flashSale) instanceof Array)) {
          l = !0;
          break;
        }
      }
    return l;
  }, [i, u]), h = V(() => {
    et.showPopup("variationContent", {
      productsData: t == null ? void 0 : t.productsData,
      productKey: i == null ? void 0 : i.key,
      currentVariationKey: s,
      showBundles: !0,
      isDistributor: e.isDistributor,
      langPack: e.langPack,
      country: e.country
    });
  }, [t, i, s, e]), b = F(() => {
    var l;
    return !i || (l = e.boxExclude) != null && l.includes("des") ? null : /* @__PURE__ */ o(
      fn,
      {
        productData: i,
        currentVariationKey: s,
        nameWithLink: e.hasLink,
        useVariationName: e.useVariationName,
        useVersionText: e.useVersionText,
        showFeatures: e.showFeatures,
        featuresQty: e.featuresQty,
        hideDescription: e.hideDescription,
        hasExtraLink: e.hasExtraLink,
        useExtraName: e.useExtraName,
        langPack: e.langPack,
        country: e.country,
        attributeTags: e.attributeTags
      }
    );
  }, [i, s, e]);
  if (ne(() => {
    var l;
    if (!r.current) {
      const _ = a();
      if (_) {
        const d = (t == null ? void 0 : t.getProductByKey(_)) ?? null;
        (l = e.onVariationChange) == null || l.call(e, _, d), r.current = !0;
      }
    }
  }, [a, t, e]), ne(() => {
    var l;
    if (s) {
      const _ = (t == null ? void 0 : t.getProductByKey(s)) ?? null;
      (l = e.onVariationChange) == null || l.call(e, s, _);
    }
  }, [s, t, e]), !i || i.isInvisible || e.onlySaleable && (i.simpleType && !i.isInSale || !i.simpleType && !((k = i.saleVariations) != null && k.length)))
    return null;
  if (e.hideIfActivityExpires) {
    if (i.simpleType) {
      if (i.startTime && i.endTime && !Ft(i.startTime, i.endTime))
        return null;
    } else if (i.subversion.versionProductIds)
      for (const l of i.subversion.versionProductIds) {
        const _ = t == null ? void 0 : t.getProductById(l);
        if (_ != null && _.startTime && (_ != null && _.endTime) && !Ft(_.startTime, _.endTime))
          return null;
      }
  }
  return /* @__PURE__ */ S(
    "div",
    {
      className: `product-details ${i.isCombination ? "is-combination" : ""} ${e.className ?? ""} ${e.isSSR ? "is-ssr" : ""} ${e.layout ? e.layout + "-layout" : ""}`,
      "data-key": i.key,
      children: [
        e.combineImageAndTips ? /* @__PURE__ */ S("div", { className: "image-and-tips", children: [
          P,
          y
        ] }) : P,
        /* @__PURE__ */ S("div", { className: "text-content", children: [
          b,
          f,
          e.combinePanelAndTips ? y : null
        ] }),
        !e.combinePanelAndTips && !e.combineImageAndTips ? y : null,
        e.hasBundlesEntrance && p ? /* @__PURE__ */ o(
          qt,
          {
            className: "view-bundles",
            type: "unset",
            color: "#0E6AFF",
            icon: "icon-icon_arrow-right",
            iconPosition: "right",
            iconWidth: "14px",
            iconColor: "#0E6AFF",
            toggleGhost: !1,
            onClick: h,
            children: (C = e.langPack) == null ? void 0 : C["reo-product"]["view-bundles"]
          }
        ) : null
      ]
    }
  );
});
function Wt(e) {
  return e.quantity !== void 0;
}
const qn = Ie((e) => {
  var w, P, p;
  const t = ae(e.data), n = ae(
    t.current.map((h) => {
      var b;
      return {
        key: h.variation_id,
        text: (b = e.langPack) == null ? void 0 : b["product-versions"][h.version]
      };
    })
  ), r = F(() => {
    if (t.current[0].variation_id) {
      const h = t.current.map((C) => C.discount_percentage), b = Math.max(...h), k = t.current.findIndex((C) => C.discount_percentage === b);
      return k === -1 ? 0 : k;
    } else
      return 0;
  }, []), [i, a] = M(r), s = F(() => t.current[i], [i, t]), c = F(() => !!(Wt(s) && e.isFixedCondition), [s, e.isFixedCondition]), u = F(() => c ? s.quantity : e.isChosen ? e.defaultQty : 0, [c, s, e]), [m, v] = M(u), y = V(() => {
    v(u);
  }, [u]);
  ne(() => (y(), e.eventRef.on("reset", y), () => {
    e.eventRef.off("reset", y);
  }), [s, u, y, e]);
  const T = V((h) => {
    h && e.onChoose();
    const b = e.isChosen ? h : e.defaultQty;
    v(b), e.eventRef.emit(
      "updateSelectedList",
      {
        qty: b,
        product: s
      }
    );
  }, [s, e]), f = V((h) => {
    const b = t.current.findIndex((k) => k.variation_id === h);
    b !== -1 && (a(b), e.eventRef.emit(
      "updateSelectedList",
      {
        qty: u,
        product: t.current[b]
      }
    ));
  }, [e, u]);
  return /* @__PURE__ */ S(
    "div",
    {
      className: "single-product",
      style: { border: `1px solid ${m ? "#e74300" : "#e0e0e0"}` },
      children: [
        s.combinations.length ? /* @__PURE__ */ S(ke, { children: [
          /* @__PURE__ */ o("div", { className: "combination-profile", children: s.combinations.map((h) => {
            var b, k, C, l;
            return /* @__PURE__ */ o(
              Lt,
              {
                type: "multiLine",
                placement: Dt.TOP_CENTER,
                content: /* @__PURE__ */ S("p", { className: "text-12", children: [
                  /* @__PURE__ */ o("span", { className: "product-name font-medium", children: h.profile.name }),
                  /* @__PURE__ */ o("span", { className: "product-version font-normal", children: (b = e.langPack) == null ? void 0 : b["product-versions"][h.version] }),
                  /* @__PURE__ */ S("span", { className: "product-amount font-medium", children: [
                    "x ",
                    h.quantity
                  ] })
                ] }),
                trigger: "hover",
                contentClassName: "z-1000 image-balloon",
                children: /* @__PURE__ */ S(
                  "a",
                  {
                    className: "product-profile",
                    href: h.product_link,
                    style: { display: "block", color: "#000814" },
                    children: [
                      /* @__PURE__ */ o(
                        "img",
                        {
                          src: h.product_image.pc,
                          alt: ""
                        }
                      ),
                      !Wt(s) && s.regular_price !== s.price && /* @__PURE__ */ o("span", { className: "product-tag tag-discount", children: s.gift_type === "free" ? (k = e.langPack) == null ? void 0 : k["reo-product"].free : (l = (C = e.langPack) == null ? void 0 : C["reo-product"].$1_off) == null ? void 0 : l.replace("$1", s.discount_type === "percent" ? s.discount_percentage + "%" : s.currency.replace("{}", s.discount)) }),
                      /* @__PURE__ */ S("span", { className: "product-qty", children: [
                        "x ",
                        h.quantity
                      ] })
                    ]
                  }
                )
              },
              h.variation_id
            );
          }) }),
          /* @__PURE__ */ S("div", { className: "combination-name", children: [
            /* @__PURE__ */ o("span", { className: "product-name", children: s.profile.name }),
            /* @__PURE__ */ o(
              Lt,
              {
                type: "multiLine",
                placement: Dt.TOP_CENTER,
                content: /* @__PURE__ */ o("ul", { className: "name-list", children: s.combinations.map((h) => {
                  var b;
                  return /* @__PURE__ */ S("li", { children: [
                    /* @__PURE__ */ o("span", { className: "product-name font-medium", children: h.profile.name }),
                    /* @__PURE__ */ o("span", { className: "product-version font-normal", children: (b = e.langPack) == null ? void 0 : b["product-versions"][h.version] }),
                    /* @__PURE__ */ S("span", { className: "product-amount font-medium", children: [
                      "x ",
                      h.quantity
                    ] })
                  ] }, h.variation_id);
                }) }),
                trigger: "hover",
                className: "ml-6 text-0 inline-block",
                contentClassName: "z-1000 name-balloon",
                children: /* @__PURE__ */ o(
                  st,
                  {
                    name: "icon-icon_question",
                    width: "16px",
                    color: "#777"
                  }
                )
              }
            )
          ] })
        ] }) : /* @__PURE__ */ S(ke, { children: [
          !Wt(s) && s.regular_price !== s.price && /* @__PURE__ */ o("span", { className: "product-tag tag-discount", children: s.gift_type === "free" ? (w = e.langPack) == null ? void 0 : w["reo-product"].free : (p = (P = e.langPack) == null ? void 0 : P["reo-product"].$1_off) == null ? void 0 : p.replace("$1", s.discount_type === "percent" ? s.discount_percentage + "%" : s.currency.replace("{}", s.discount)) }),
          /* @__PURE__ */ S(
            "a",
            {
              href: s.product_link,
              style: { display: "block", color: "#000814", width: "130px", margin: "0 auto" },
              children: [
                /* @__PURE__ */ o(
                  "img",
                  {
                    src: s.product_image.pc,
                    alt: ""
                  }
                ),
                /* @__PURE__ */ o("span", { className: "product-name", children: s.product_name })
              ]
            }
          )
        ] }),
        t.current.length && t.current[0].variation_id ? /* @__PURE__ */ o(
          hn,
          {
            fullDropDownWords: !0,
            options: n.current,
            size: "medium",
            className: "product-select",
            width: "100%",
            dropDownClassName: "z-1001",
            value: s.variation_id,
            onChange: f
          }
        ) : null,
        /* @__PURE__ */ S("div", { className: "price-content", children: [
          /* @__PURE__ */ o("span", { className: "sale-price", children: s.currency.replace("{}", Number(s.price).toFixed(s.currencyPrecision)) }),
          s.regular_price !== s.price && /* @__PURE__ */ o("del", { className: "pre-price", children: s.currency.replace("{}", Number(s.regular_price).toFixed(s.currencyPrecision)) })
        ] }),
        /* @__PURE__ */ o(
          ii,
          {
            value: m,
            onChange: (h) => T(h),
            minValue: c ? s.quantity : 0,
            disabled: c,
            float: !1,
            className: "reo-quantity-controller",
            size: "small",
            bordered: !0
          }
        )
      ]
    }
  );
}), Yn = Ie((e) => {
  const [t, n] = M(1), [r, i] = M(0), [a, s] = M(0), c = F(() => t > 1.5 ? {
    autoPlay: !1,
    swipeable: !1,
    centerMode: !0,
    infiniteLoop: !1,
    showIndicators: !1,
    isHoverArrow: !1,
    slideToChange: t,
    centerSlidePercentage: 100 / t,
    centerSlidePadding: 10,
    selectedItem: a,
    onChange: s
  } : {
    autoPlay: !1,
    swipeable: !0,
    leftMode: !0,
    infiniteLoop: !1,
    showIndicators: !1,
    showArrows: !1,
    centerSlidePercentage: 69,
    centerSlidePadding: 10,
    selectedItem: a,
    onChange: s
  }, [t, a]), u = V(() => {
    he() < 1280 && he() >= 900 ? n(3) : he() < 900 && he() >= 560 ? n(2) : he() < 560 ? n(1.5) : n(4);
  }, []), m = V(() => {
    i(0), s(0);
  }, []);
  return ne(() => (u(), window.addEventListener("resize", u), () => {
    window.removeEventListener("resize", u);
  }), [u]), ne(() => (e.eventRef.on("reset", m), () => {
    e.eventRef.off("reset", m);
  }), [m, e]), /* @__PURE__ */ o(ke, { children: e.datas.length > t ? /* @__PURE__ */ o(mt, { ...c, children: e.datas.map((v, y) => /* @__PURE__ */ o(it, { children: /* @__PURE__ */ o(
    qn,
    {
      data: v,
      isFixedCondition: e.isFixedCondition,
      defaultQty: e.defaultQty,
      isChosen: y === r,
      eventRef: e.eventRef,
      langPack: e.langPack,
      onChoose: () => {
        i(y);
      }
    }
  ) }, y)) }) : e.datas.map((v, y) => /* @__PURE__ */ o(
    qn,
    {
      data: v,
      isFixedCondition: e.isFixedCondition,
      defaultQty: e.defaultQty,
      isChosen: y === r,
      eventRef: e.eventRef,
      langPack: e.langPack,
      onChoose: () => {
        i(y);
      }
    },
    y
  )) });
}), Gn = Ie((e) => {
  var r, i, a, s, c, u, m, v, y;
  const { activity: t } = e, n = F(() => {
    const T = t.handled_products, f = e.currentProductData;
    if (f) {
      const w = T.findIndex((P) => P.some((h) => h.product_id === f.id || h.variation_id === f.id));
      if (w !== -1 && w !== 0) {
        const P = T.splice(w, 1)[0];
        T.unshift(P);
      }
    }
    return T;
  }, [t, e]);
  return /* @__PURE__ */ S(
    "div",
    {
      className: "single-activity",
      children: [
        /* @__PURE__ */ S("div", { className: "condition-content", children: [
          /* @__PURE__ */ o("div", { className: "activity-countdown product-tag limited-time", children: /* @__PURE__ */ S(
            Ti,
            {
              startTime: t.start_at,
              endTime: t.end_at,
              langPack: e.langPack,
              children: [
                (r = e.langPack) == null ? void 0 : r.common["ld-countdown"],
                " "
              ]
            }
          ) }),
          /* @__PURE__ */ S("p", { className: "activity-title", children: [
            t.product_condition === Bt.AND ? (a = (i = e.langPack) == null ? void 0 : i["reo-product"].buy_$1) == null ? void 0 : a.replace("$1", t.products.map((T) => {
              var f;
              return T.quantity + "x " + T.profile.name + (T.variation_id ? "(" + ((f = e.langPack) == null ? void 0 : f["product-versions"][T.version]) + ")" : "");
            }).join(", ")) : (c = (s = e.langPack) == null ? void 0 : s["reo-product"].buy_any_$1_of_the_following_items) == null ? void 0 : c.replace("$1", t.product_qty.toString()),
            " ",
            (v = t.gifts_same_discount ? (u = e.langPack) == null ? void 0 : u["reo-product"].get_any_$1_of_the_offers_$2_off : (m = e.langPack) == null ? void 0 : m["reo-product"].get_any_$1_of_the_offers_at_up_to_$2_off) == null ? void 0 : v.replace("$1", t.gift_product_qty.toString()).replace("$2", t.gifts_max_discount + "%")
          ] }),
          /* @__PURE__ */ o("div", { className: `condition-box ${n.length > 1 ? "sm:pl-10" : "condition-box-center"}`, children: /* @__PURE__ */ o(
            Yn,
            {
              datas: n,
              defaultQty: t.product_qty,
              isFixedCondition: t.product_condition === Bt.AND,
              eventRef: e.eventRef,
              langPack: e.langPack
            }
          ) }),
          /* @__PURE__ */ o("div", { className: "triangle-down" })
        ] }),
        /* @__PURE__ */ S("div", { className: "gift-content", children: [
          /* @__PURE__ */ S("p", { className: "gift-title", children: [
            (y = e.langPack) == null ? void 0 : y["reo-product"].offer_to_choose_from,
            ":"
          ] }),
          /* @__PURE__ */ o("div", { className: `gift-box ${t.handled_gift_products.length > 1 ? "sm:pl-10" : "condition-box-center"}`, children: /* @__PURE__ */ o(
            Yn,
            {
              datas: t.handled_gift_products,
              defaultQty: t.gift_product_qty,
              eventRef: e.eventRef,
              langPack: e.langPack
            }
          ) })
        ] })
      ]
    },
    t.id
  );
}), mo = Ie((e) => {
  var P, p;
  const t = ae(jt.currency.symbol), n = ae(jt.currency.precision), r = ae(jt.currency.code), [i, a] = M([]), [s, c] = M(0), [u, m] = M(!0), v = V((h) => {
    const b = h.map((l) => l.discount_percentage), k = Math.max(...b), C = h.findIndex((l) => l.discount_percentage === k);
    return h[C === -1 ? 0 : C];
  }, []), y = V(() => {
    const h = [], b = e.activities[s];
    if (b) {
      if (b.product_condition === Bt.AND)
        for (const C of b.handled_products)
          for (const l of C)
            h.push({
              id: l.variation_id ? l.variation_id : l.product_id,
              name: l.profile.name,
              quantity: l.quantity,
              version: l.version,
              price: l.price,
              regularPrice: l.regular_price,
              type: "condition",
              mainId: l.product_id,
              mainKey: l.product_key,
              category: l.categories[0] ?? ""
            });
      else {
        const C = v(b.handled_products[0]);
        h.push({
          id: C.variation_id ? C.variation_id : C.product_id,
          name: C.profile.name,
          quantity: b.product_qty,
          version: C.version,
          price: C.price,
          regularPrice: C.regular_price,
          type: "condition",
          mainId: C.product_id,
          mainKey: C.product_key,
          category: C.categories[0] ?? ""
        });
      }
      const k = v(b.handled_gift_products[0]);
      h.push({
        id: k.variation_id ? k.variation_id : k.product_id,
        name: k.profile.name,
        quantity: b.gift_product_qty,
        version: k.version,
        price: k.price,
        regularPrice: k.regular_price,
        type: "gift",
        mainId: k.product_id,
        mainKey: k.product_key,
        category: k.categories[0] ?? ""
      });
    }
    a(h);
  }, [s, e.activities, v]), T = F(() => i.map((h) => ({
    ...h,
    id: Math.random() * 1e3
  })), [i]), f = V((h, b) => {
    const k = b.variation_id ? b.variation_id : b.product_id, C = Wt(b) ? "condition" : "gift", l = i.filter((_) => _.type !== C);
    a(h ? [...l, {
      id: k,
      name: b.profile.name,
      quantity: h,
      version: b.version,
      price: b.price,
      regularPrice: b.regular_price,
      type: C,
      mainId: b.product_id,
      mainKey: b.product_key,
      category: b.categories[0] ?? ""
    }] : [...l]);
  }, [i]);
  ne(() => {
    y();
  }, [s, y]), ne(() => (e.eventRef.on("updateActivitiesIndex", (h) => {
    c(h);
  }), e.eventRef.on("updateSelectedList", (h) => {
    f(h.qty, h.product);
  }), () => {
    e.eventRef.off("updateActivitiesIndex"), e.eventRef.off("updateSelectedList");
  }), [f, e]), ne(() => {
    i.length ? m(!1) : m(!0);
  }, [i]);
  async function w() {
    var l, _, d, x, N, I, B, ie, X, se, Q, ve, ye;
    m(!0);
    const h = e.activities[s].id, b = [], k = [], C = {
      currency: r.current,
      value: 0,
      items: []
    };
    for (const ue of i)
      ue.type === "condition" ? b.push({
        id: ue.id,
        number: ue.quantity
      }) : k.push({
        id: ue.id,
        number: ue.quantity
      }), C.items.push({
        item_id: ue.mainId ?? ue.id,
        item_name: ue.mainKey ?? ue.name,
        item_category: ue.category ?? "",
        price: Number(ue.price),
        quantity: ue.quantity
      }), C.value += Number(ue.price) * ue.quantity;
    try {
      await di.addToCartBatch(b, 0, k, h), (_ = (l = ge()) == null ? void 0 : l.gtag) == null || _.call(l, "event", "add_to_cart", C), e.country === "US" && ((x = (d = ge()) == null ? void 0 : d.rdt) == null || x.call(d, "track", "AddToCart")), document.body.dispatchEvent(new Event("afterAddToCart")), wn() && document.dispatchEvent(new Event("wc_update_cart")), et.showPopup("handledResult", {
        type: "addToCartSuccess",
        onClose: y,
        langPack: e.langPack
      }), e.eventRef.emit("reset"), m(!1);
    } catch (ue) {
      const _e = (I = (N = ue == null ? void 0 : ue._rawError) == null ? void 0 : N.detail) == null ? void 0 : I.code;
      let E = (B = e.langPack) == null ? void 0 : B["reo-product"]["UNKNOWN_ERROR".toLowerCase()];
      const $ = (se = (X = (ie = ue == null ? void 0 : ue._rawError) == null ? void 0 : ie.detail) == null ? void 0 : X.fail_products) == null ? void 0 : se[0].product_name;
      _e && ($ ? E = (ve = (Q = e.langPack) == null ? void 0 : Q["reo-product"][_e.toLowerCase()]) == null ? void 0 : ve.replace("$1", $) : E = (ye = e.langPack) == null ? void 0 : ye["reo-product"][_e.toLowerCase()]), et.showPopup("handledResult", {
        type: "addToCartFailed",
        errorDes: E,
        langPack: e.langPack,
        onClose: () => {
          m(!0);
        }
      });
    }
  }
  return /* @__PURE__ */ S("div", { className: "selected-content", children: [
    /* @__PURE__ */ o("p", { className: "selected-title", children: (P = e.langPack) == null ? void 0 : P["reo-product"].you_have_selected }),
    /* @__PURE__ */ o("ul", { className: "selected-box", children: T.map((h) => {
      var b;
      return /* @__PURE__ */ S(
        "li",
        {
          className: "selected-item",
          children: [
            /* @__PURE__ */ o("span", { className: "product-name", children: h.name }),
            /* @__PURE__ */ o("span", { className: "product-version", children: (b = e.langPack) == null ? void 0 : b["product-versions"][h.version] }),
            /* @__PURE__ */ S("span", { className: "product-qty", children: [
              "x ",
              h.quantity
            ] })
          ]
        },
        h.id
      );
    }) }),
    /* @__PURE__ */ S("div", { className: "result-box", children: [
      i.length && /* @__PURE__ */ S("div", { className: "price-content", children: [
        /* @__PURE__ */ o("span", { className: "sale-price", children: t.current.replace(
          "{}",
          i.reduce((h, b) => h + Number(b.price) * b.quantity, 0).toFixed(n.current)
        ) }),
        /* @__PURE__ */ o("del", { className: "pre-price", children: t.current.replace(
          "{}",
          i.reduce((h, b) => h + Number(b.regularPrice) * b.quantity, 0).toFixed(n.current)
        ) })
      ] }),
      /* @__PURE__ */ o(
        Qe,
        {
          size: "medium",
          activeBackgroundColor: "rgba(255, 75, 43, 0.8)",
          activeBorderColor: "rgba(255, 75, 43, 0.8)",
          backgroundColor: "#FF4B2B",
          borderColor: "#FF4B2B",
          onClick: () => {
            w().catch(console.error);
          },
          disabled: !(i.length && !u),
          children: (p = e.langPack) == null ? void 0 : p["reo-product"].add_to_cart
        }
      )
    ] })
  ] });
});
const ho = Ie((e) => {
  const t = ae(new Ct()), [n, r] = M(), [i, a] = M(null), s = F(() => !e.activitiesType, [e.activitiesType]);
  ne(() => {
    (async () => {
      let f = "all";
      e.activitiesType && (f = "flash-sale");
      const w = await jt.getGiftActivities(e.productData, f);
      a(w ?? null);
    })().catch((f) => {
      var p, h, b;
      a(null), (p = e.onClose) == null || p.call(e);
      const w = f == null ? void 0 : f.result;
      let P = (h = e.langPack) == null ? void 0 : h["reo-product"][`${"UNKNOWN_ERROR".toLowerCase()}`];
      (w == null ? void 0 : w.code) === -2 && (P = (b = e.langPack) == null ? void 0 : b["reo-product"].gift_activity_available), et.showPopup("handledResult", {
        type: "addToCartFailed",
        errorTitle: P,
        langPack: e.langPack
      });
    });
  }, [e]);
  const c = F(() => {
    if (!i)
      return [];
    if (e.activitiesType === "single") {
      const f = i.bundle.filter((w) => w.single_condition && w.products[0].combinations.length === 0);
      return [...i.single, ...f];
    } else
      return e.activitiesType === "multiple" ? [...i.bundle.filter((w) => !w.single_condition || w.single_condition && w.products[0].combinations.length > 0), ...i.random, ...i.category] : e.activitiesType === "lightning" ? [] : [...i.single, ...i.bundle, ...i.random, ...i.category];
  }, [e.activitiesType, i]), u = V(() => {
    he() > 1260 ? r("w-1200") : he() > 768 ? r("w-calc-full-60") : r("w-full rounded-none");
  }, []);
  ne(() => (u(), window.addEventListener("resize", u), () => {
    window.removeEventListener("resize", u);
  }), [u]), ne(() => {
    e.activitiesType && c.length && document.body.dispatchEvent(new Event("show-gift-activity"));
  }, [e, c]);
  const m = V((f) => {
    var w;
    return /* @__PURE__ */ o(
      Qe,
      {
        icon: "icon-icon_left-2",
        iconPosition: "left",
        size: "small",
        ghost: !0,
        activeBackgroundColor: "#f74e46",
        activeBorderColor: "#f74e46",
        activeColor: "#fff",
        backgroundColor: "#fff",
        borderColor: "#f74e46",
        color: "#f74e46",
        onClick: f,
        children: (w = e.langPack) == null ? void 0 : w["reo-product"].previous
      }
    );
  }, [e]), v = V((f) => {
    var w;
    return /* @__PURE__ */ o(
      Qe,
      {
        icon: "icon-icon_right-2",
        iconPosition: "right",
        size: "small",
        ghost: !0,
        activeBackgroundColor: "#f74e46",
        activeBorderColor: "#f74e46",
        activeColor: "#fff",
        backgroundColor: "#fff",
        borderColor: "#f74e46",
        color: "#f74e46",
        className: "ml-20",
        onClick: f,
        children: (w = e.langPack) == null ? void 0 : w["reo-product"].next
      }
    );
  }, [e]), y = F(() => c.length ? /* @__PURE__ */ o(
    mt,
    {
      autoPlay: !1,
      swipeable: !1,
      infiniteLoop: !0,
      showIndicators: !1,
      showArrows: !1,
      customRenderArrowNext: v,
      customRenderArrowPrev: m,
      onChange: (f) => {
        t.current.emit("updateActivitiesIndex", f), t.current.emit("resetQty");
      },
      children: c.map((f) => /* @__PURE__ */ o(it, { children: /* @__PURE__ */ o(
        Gn,
        {
          activity: f,
          currentProductData: e.productData,
          eventRef: t.current,
          langPack: e.langPack
        }
      ) }, f.id))
    }
  ) : null, [c, v, m, e]), T = F(() => {
    var f;
    return c.length ? /* @__PURE__ */ S(
      "div",
      {
        className: "reo-buy-and-gift",
        style: { display: "block" },
        children: [
          e.activitiesType ? /* @__PURE__ */ o("h3", { children: (f = e.langPack) == null ? void 0 : f["reo-product"].buy_and_get_promotion }) : null,
          c.length > 1 && /* @__PURE__ */ o("div", { className: "activities-nav" }),
          /* @__PURE__ */ S("div", { className: "activities-content", children: [
            c.length > 1 ? y : /* @__PURE__ */ o(
              Gn,
              {
                activity: c[0],
                currentProductData: e.productData,
                eventRef: t.current,
                langPack: e.langPack
              }
            ),
            /* @__PURE__ */ o(
              mo,
              {
                activities: c,
                eventRef: t.current,
                country: e.country,
                langPack: e.langPack
              }
            )
          ] })
        ]
      }
    ) : null;
  }, [c, y, e]);
  if (c.length)
    s && _n();
  else
    return null;
  return /* @__PURE__ */ o(ke, { children: s ? /* @__PURE__ */ S(
    Nt,
    {
      mask: !0,
      class: n,
      children: [
        T,
        /* @__PURE__ */ o(
          "span",
          {
            className: "absolute top-0 right-0 transform -translate-y-1/2 rounded-full w-32 h-32 bg-black-opacity-70 flex items-center justify-center cursor-pointer",
            onClick: e.onClose,
            children: /* @__PURE__ */ o(
              yn,
              {
                name: "icon-cross2",
                width: "12px",
                color: "#fff"
              }
            )
          }
        )
      ]
    }
  ) : T });
}), go = ho, Qn = Ie((e) => /* @__PURE__ */ o("div", { className: "single-combination horizontal-layout", children: /* @__PURE__ */ o(
  wt,
  {
    productsData: [e.data],
    productKey: e.data.key,
    boxExclude: ["tags"],
    panelExclude: ["quantity"],
    className: "border border-solid border-gray-d rounded-8",
    isDiscountBtn: !0,
    addedJumpToCart: !0,
    showFeatures: !0,
    hideDescription: !0,
    langPack: e.langPack,
    country: e.country
  }
) }));
const yo = (e) => {
  var r;
  const [t, n] = M();
  return ne(() => {
    (async () => {
      const i = new Ze(e.productsData, e.country);
      await i.init(), n(i);
    })().catch(console.error);
  }, [e]), t != null && t.productsData.length ? /* @__PURE__ */ S("div", { className: "combinations-content", children: [
    /* @__PURE__ */ o("p", { className: "title", children: (r = e.langPack) == null ? void 0 : r["reo-product"].buy_bundles_save_more }),
    /* @__PURE__ */ o("div", { className: "combinations-list", children: t.productsData.length > 1 ? /* @__PURE__ */ o(
      mt,
      {
        autoPlay: !1,
        swipeable: !0,
        infiniteLoop: !1,
        showIndicators: !1,
        children: t.productsData.map((i) => /* @__PURE__ */ o(it, { children: /* @__PURE__ */ o(
          Qn,
          {
            data: i,
            langPack: e.langPack,
            country: e.country
          }
        ) }, i.id))
      }
    ) : /* @__PURE__ */ o(
      Qn,
      {
        data: t.productsData[0],
        langPack: e.langPack,
        country: e.country
      }
    ) })
  ] }) : null;
}, Xn = Ie((e) => e.productData ? /* @__PURE__ */ o("div", { className: "single-recommendation reo-product-box", children: /* @__PURE__ */ o(
  wt,
  {
    productsData: [e.productData],
    productKey: e.productData.key,
    hasLink: !0,
    onlySaleable: !0,
    buttonGhost: !0,
    addedJumpToCart: !0,
    langPack: e.langPack,
    country: e.country,
    tipsExclude: ["shipping", "note"]
  }
) }) : null);
const ki = (e) => {
  var m;
  const [t, n] = M(he()), [r, i] = M(3), [a, s] = M(), c = F(() => e.limit ?? 6, [e]);
  ne(() => {
    (async () => {
      const v = new Ze(e.productsData, e.country);
      await v.init(), s(v);
    })().catch(console.error);
  }, [e]), ne(() => {
    const v = () => {
      n(he());
    };
    return window.addEventListener("resize", v), () => {
      window.removeEventListener("resize", v);
    };
  }, []);
  const u = F(() => {
    let v = [];
    if (e.ids.length) {
      for (const y of e.ids) {
        const T = a == null ? void 0 : a.getProductById(y);
        T && v.push(T);
      }
      e.onlySellable && (v = v.filter((y) => {
        var T;
        return y.simpleType && (y.isInSale || y.isPreOrder) || !y.simpleType && ((T = y.saleVariations) == null ? void 0 : T.length);
      }));
    }
    return v.length > c ? v.slice(0, c) : v;
  }, [e, a, c]);
  return ne(() => {
    e.limit || u.length && (t > 1260 ? i(3) : t > 768 ? i(2) : i(1));
  }, [t, u, e]), u != null && u.length ? /* @__PURE__ */ S("div", { className: `reo-recommendations-wrap ${e.className ?? ""}`, children: [
    /* @__PURE__ */ o("p", { className: "recommend-title text-24 font-medium", children: (m = e.langPack) == null ? void 0 : m["reo-product"].may_be_interested }),
    /* @__PURE__ */ o("div", { className: "recommendations-content reo-products-content", children: /* @__PURE__ */ o("div", { className: "recommendations-list", children: u.length > r ? /* @__PURE__ */ o(
      mt,
      {
        autoPlay: !1,
        swipeable: !0,
        centerMode: !0,
        infiniteLoop: !1,
        showIndicators: !1,
        isHoverArrow: !1,
        slideToChange: r,
        centerSlidePercentage: Number((100 / r).toFixed(1)),
        centerSlidePadding: 12,
        children: u == null ? void 0 : u.map((v) => /* @__PURE__ */ o(it, { children: /* @__PURE__ */ o(
          Xn,
          {
            productData: v,
            langPack: e.langPack,
            country: e.country
          }
        ) }, v.id))
      }
    ) : u == null ? void 0 : u.map((v) => /* @__PURE__ */ o(
      Xn,
      {
        productData: v,
        langPack: e.langPack,
        country: e.country
      },
      v.id
    )) }) })
  ] }) : null;
}, vo = (e) => {
  var s, c, u, m;
  const [t, n] = M({
    day: 0,
    hour: 0,
    min: 0,
    sec: 0
  }), [r, i] = M(!1);
  ne(() => {
    let v = requestAnimationFrame(function y() {
      const T = new Date().getTime();
      if (Ft(e.startTime, e.endTime)) {
        const f = e.endTime - T;
        if (e.limitedShowTime && f > e.limitedShowTime) {
          i(!1);
          return;
        }
        const w = parseInt((f / 1e3 / 60 / 60 / 24).toString()), P = parseInt((f / 1e3 / 60 / 60 % 24).toString()), p = parseInt((f / 1e3 / 60 % 60).toString()), h = parseInt((f / 1e3 % 60).toString());
        n({
          day: w,
          hour: P,
          min: p,
          sec: h
        }), r || i(!0), v = requestAnimationFrame(y);
      } else
        e.onCountdownFinish && e.onCountdownFinish(), i(!1);
    });
    return () => {
      cancelAnimationFrame(v);
    };
  }, [e, r]);
  function a(v) {
    return v < 10 ? "0" + v : "" + v;
  }
  return /* @__PURE__ */ o(ke, { children: r ? /* @__PURE__ */ S("div", { className: `reo-countdown ${e.className ?? ""}`, children: [
    e.children,
    /* @__PURE__ */ o("div", { className: `inline-block text-left ${e.timeWidth ?? ""}`, children: t.day && !e.dayPlusHour ? /* @__PURE__ */ S(ke, { children: [
      /* @__PURE__ */ S("span", { className: "day", children: [
        t.day,
        " "
      ] }),
      t.day > 1 ? (c = (s = e.langPack) == null ? void 0 : s.common) == null ? void 0 : c.days : (m = (u = e.langPack) == null ? void 0 : u.common) == null ? void 0 : m.day
    ] }) : /* @__PURE__ */ S(ke, { children: [
      /* @__PURE__ */ o("span", { className: "hour", children: t.day && e.dayPlusHour ? t.day * 24 + t.hour : a(t.hour) }),
      /* @__PURE__ */ o("span", { className: "time-separation", children: ":" }),
      /* @__PURE__ */ o("span", { className: "min", children: a(t.min) }),
      /* @__PURE__ */ o("span", { className: "time-separation", children: ":" }),
      /* @__PURE__ */ o("span", { className: "sec", children: a(t.sec) })
    ] }) })
  ] }) : null });
}, Ti = vo, Jn = {
  large: 48,
  medium: 36,
  small: 30
};
class bo {
  constructor() {
    this._validateEmail = async (t) => !t.trim().length || !mr.check("isEmail", t) ? 0 : await ur(t) !== -1 ? 1 : 0, this.subscribeSubject = async (t, n, r) => {
      var i, a, s;
      try {
        return await this._validateEmail(t) ? (await tr({
          email: t.trim(),
          subject: n,
          country: r
        }), "succeeded") : "validError";
      } catch (c) {
        const u = (s = (a = (i = c == null ? void 0 : c.response) == null ? void 0 : i.data) == null ? void 0 : a.error) == null ? void 0 : s.symbol;
        return u === "subscription_exist" ? "repeatError" : u === "request_throttled" ? "frequentError" : "serverError";
      }
    };
  }
}
const _o = new bo(), Co = "_reoSubscribeWrap_iw618_1", wo = "_input_iw618_14", Po = "_loading_iw618_53", ko = "_loadingCircle_iw618_1", To = "_successWrap_iw618_75", So = "_successMsg_iw618_80", No = "_success_text_iw618_89", qe = {
  reoSubscribeWrap: Co,
  "input-with-btn-text": "_input-with-btn-text_iw618_14",
  input: wo,
  "submit-button": "_submit-button_iw618_21",
  "icon-wrap": "_icon-wrap_iw618_31",
  "icon-email": "_icon-email_iw618_38",
  "not-be-clicked": "_not-be-clicked_iw618_43",
  "icon-loading": "_icon-loading_iw618_44",
  "icon-arrow": "_icon-arrow_iw618_47",
  "icon-disabled": "_icon-disabled_iw618_50",
  loading: Po,
  loadingCircle: ko,
  "cannot-be-clicked": "_cannot-be-clicked_iw618_60",
  "wrap-width": "_wrap-width_iw618_63",
  successWrap: To,
  successMsg: So,
  success_text: No
}, Zn = ["validError", "serverError", "repeatError", "frequentError", "privacyNotAgree"], Ht = "eu-uk-tips", Io = {
  subscribeType: "lightInput",
  inputWidth: "380px",
  canBeSubscribe: !0,
  name: "icon-icon_have",
  color: "#318C31",
  width: 16,
  size: "large"
}, po = (e) => {
  const { msg: t, placeholder: n, subscribeState: r, setCurrentState: i, onSuccess: a, inputWidth: s, canBeSubscribe: c, options: u } = e, [m, v] = M(""), [y, T] = M([]), [f, w] = M(!0), P = ae(e.inputIconName === "icon-icon_email-facet"), p = V(async () => {
    if (u && !y.includes(Ht)) {
      i("privacyNotAgree");
      return;
    }
    i("processing");
    let N = await _o.subscribeSubject(m, e.subject, e.country);
    e.isRepeatAsSuccess && N === "repeatError" && (N = "succeeded"), i(N), N === "succeeded" && (a == null || a(m));
  }, [y, m, a, u, e.country, e.subject, i, e.isRepeatAsSuccess]), h = V((N) => {
    v(N);
  }, []), b = V(() => {
    m.trim().length || i("normal");
  }, [i, m]), k = F(() => ({
    "--icon-height": Ut(Jn[e.size])
  }), [e.size]), C = F(() => ({
    "--input-height": Ut(Jn[e.size])
  }), [e.size]), l = F(() => u ? u.filter((N) => N.required).map((N) => N.value) : [], [u]), _ = V((N) => !!e.privacyNotAgreeError || l.every((I) => N.includes(I)), [e.privacyNotAgreeError, l]);
  ne(() => {
    const N = e.checkedVal;
    T(N), w(_(N));
  }, [_, e.checkedVal]);
  const d = V((N) => {
    w(_(N)), T(N);
  }, [_]), x = F(() => ({
    "--wrap-width": Ut(s)
  }), [s]);
  return /* @__PURE__ */ S(
    "div",
    {
      className: Re(qe.reoSubscribeWrap, e.wrapClassName),
      style: {
        ...x,
        ...C
      },
      children: [
        /* @__PURE__ */ o(
          Bi,
          {
            size: e.size,
            width: s,
            placeholder: n,
            value: m,
            onChange: (N) => {
              h(N);
            },
            tips: Zn.includes(r) ? "error" : void 0,
            infoMsg: Zn.includes(r) ? t[r] : void 0,
            backgroundColor: e.backgroundColor,
            infoMsgColor: e.infoMsgColor,
            onFocus: b,
            className: Re(qe["reo-input"], {
              [qe["input-with-btn-text"]]: !!e.submitBtnText
            }, e.inputClassName),
            inputClassName: qe.input
          }
        ),
        e.submitBtnText ? /* @__PURE__ */ o(
          Qe,
          {
            disabled: !f || !c,
            className: Re(qe["submit-button"], e.submitBtnClassName),
            loading: r === "processing",
            onClick: () => {
              p().catch(console.error);
            },
            icon: e.iconName,
            children: e.submitBtnText
          }
        ) : /* @__PURE__ */ o(
          "div",
          {
            className: Re(
              qe["icon-wrap"],
              e.inputIconWarpClassName,
              {
                [qe["icon-email"]]: P.current,
                [qe["not-be-clicked"]]: !f,
                [qe["icon-loading"]]: r === "processing"
              }
            ),
            onClick: () => {
              p().catch(console.error);
            },
            children: /* @__PURE__ */ o(
              ot,
              {
                name: r === "processing" ? "icon-icon-loading-1" : e.inputIconName ? e.inputIconName : "icon-icon_arrow-right",
                color: f ? e.iconColor ?? "#0E6AFF" : e.disabledIconColor ?? "#ccc",
                className: Re(
                  qe["icon-arrow"],
                  {
                    [qe["icon-disabled"]]: !c,
                    [qe.loading]: r === "processing",
                    [qe["cannot-be-clicked"]]: !f
                  }
                ),
                width: P.current ? 26 : 16,
                style: k
              }
            )
          }
        ),
        u && y ? /* @__PURE__ */ o(
          ri,
          {
            value: y,
            options: u,
            onChange: d,
            wrapClassName: `${qe["wrap-width"]} ${e.checkboxWrapClassName}`,
            className: e.checkboxClassName
          }
        ) : null
      ]
    }
  );
}, xo = (e) => /* @__PURE__ */ S(
  "div",
  {
    className: Re(qe.successWrap, e.successClassName),
    style: { "--wrap-width": Ut(e.inputWidth) },
    children: [
      /* @__PURE__ */ o(
        ot,
        {
          name: e.name,
          color: e.color,
          width: e.width
        }
      ),
      /* @__PURE__ */ o(
        "p",
        {
          className: Re(qe.successMsg),
          style: { "--color": e.color },
          dangerouslySetInnerHTML: { __html: e.successMsg ?? "" }
        }
      )
    ]
  }
), Ro = (e) => {
  const [t, n] = M(!1), [r, i] = M([]), a = F(() => {
    var v;
    if (t)
      return [
        { value: Ht, label: e.enUkTips ?? ((v = e.langPack) == null ? void 0 : v.subscribe.subscribe_eu_uk_tips), required: !0 }
      ];
  }, [e, t]);
  ne(() => {
    if (e.country) {
      const v = gr.isEurap(e.country);
      v ? n(v) : e.showTips ? (n(!0), i([Ht])) : n(!1);
    } else
      e.showTips ? (n(!0), i([Ht])) : n(!1);
  }, [e]);
  const [s, c] = M("normal"), m = { ...F(() => {
    var v, y, T, f, w, P;
    return {
      msg: {
        validError: (v = e.langPack) == null ? void 0 : v.subscribe["valid-error"],
        serverError: (y = e.langPack) == null ? void 0 : y.subscribe["server-error"],
        repeatError: (T = e.langPack) == null ? void 0 : T.subscribe["repeat-error"],
        frequentError: (f = e.langPack) == null ? void 0 : f.subscribe["frequent-error"],
        succeeded: (w = e.langPack) == null ? void 0 : w.subscribe.succeeded,
        privacyNotAgree: e.privacyNotAgreeError
      },
      placeholder: (P = e.langPack) == null ? void 0 : P.subscribe["input-placeholder"]
    };
  }, [e]), ...Io, ...e };
  return s === "succeeded" ? /* @__PURE__ */ o(
    xo,
    {
      ...m,
      subscribeType: m.subscribeType,
      successMsg: m.msg[s],
      successClassName: qe.success_text
    }
  ) : /* @__PURE__ */ o(
    po,
    {
      ...m,
      options: a,
      checkedVal: r,
      subscribeState: s,
      setCurrentState: (v) => {
        c(v);
      },
      checkboxClassName: m.checkboxClassName
    }
  );
};
const Eo = (e) => {
  var i, a, s;
  const t = F(() => {
    var c;
    return ((c = e.recommendations) == null ? void 0 : c.map((u) => u.id)) ?? [];
  }, [e]), n = V(() => {
    var u, m;
    const c = !!(document.getElementsByClassName("cart-empty").length || document.getElementsByClassName("cart-empty-wrapper").length);
    if (wn() && !c) {
      (u = e.onClose) == null || u.call(e);
      const v = ((m = Nr(document.getElementById("cart-container"))) == null ? void 0 : m.top) ?? 0;
      Ir(v);
    } else
      location.href = Gt("/cart/");
  }, [e]), r = V(() => {
    var c;
    (c = e.onClose) == null || c.call(e);
  }, [e]);
  return /* @__PURE__ */ S("div", { className: "reo-add-to-cart-success py-50 sm:py-38 leading-1.2", children: [
    /* @__PURE__ */ o(
      yn,
      {
        name: "icon-icon_have",
        width: "48px",
        color: "#318C31",
        className: "mx-auto"
      }
    ),
    /* @__PURE__ */ o("p", { className: "text-18 mt-12 mb-24 font-medium leading-1.2 text-green-318c31", children: (i = e.langPack) == null ? void 0 : i["reo-product"].added_success_title }),
    /* @__PURE__ */ S("div", { className: "button-wrap", children: [
      /* @__PURE__ */ o(
        Qe,
        {
          size: "medium",
          className: "continue-shopping",
          ghost: !0,
          onClick: r,
          children: (a = e.langPack) == null ? void 0 : a["reo-product"].continue_shopping
        }
      ),
      /* @__PURE__ */ o(
        Qe,
        {
          size: "medium",
          className: "view-cart",
          onClick: n,
          children: (s = e.langPack) == null ? void 0 : s["reo-product"].view_cart
        }
      )
    ] }),
    /* @__PURE__ */ o(
      yo,
      {
        productsData: e.combinations ?? [],
        langPack: e.langPack,
        country: e.country
      }
    ),
    /* @__PURE__ */ o(
      ki,
      {
        className: "popup-recommendations-content",
        ids: t,
        productsData: e.recommendations ?? [],
        langPack: e.langPack,
        country: e.country
      }
    )
  ] });
}, Ao = (e) => {
  var n;
  const t = V(() => {
    var r;
    (r = e.onClose) == null || r.call(e);
  }, [e]);
  return /* @__PURE__ */ S("div", { className: "reo-add-to-cart-failed py-40 sm:py-30", children: [
    /* @__PURE__ */ o("p", { className: "text-18 mb-10", children: e.errorTitle ? e.errorTitle : e.langPack["reo-product"].added_failed_title }),
    e.errorDes ? /* @__PURE__ */ o("p", { className: "text-16 mb-14 px-40 sm:px-20", children: e.errorDes }) : null,
    /* @__PURE__ */ o("div", { className: "button-wrap", children: /* @__PURE__ */ o(
      Qe,
      {
        size: "medium",
        onClick: t,
        children: (n = e.langPack) == null ? void 0 : n["reo-product"].got_it
      }
    ) })
  ] });
};
const Oo = (e) => {
  var m, v, y, T;
  const { widthOfWindow: t } = yr(), [n, r] = M();
  ne(() => {
    (async () => {
      const f = new Ze(e.productsData, e.country);
      await f.init(), r(f);
    })().catch(console.error);
  }, [e]);
  const i = F(() => e.productKey ? n == null ? void 0 : n.getProductByKey(e.productKey) : null, [e, n]), a = F(() => {
    if (!(i != null && i.children))
      return null;
    const f = e.currentVariationKey ? e.currentVariationKey : i.defaultVariationKey;
    for (const w in i.children) {
      const P = i.children[w];
      if (P.key === f)
        return P;
    }
    return null;
  }, [e, i]), s = F(() => {
    var f;
    return ((f = e.recommendations) == null ? void 0 : f.map((w) => w.id)) ?? [];
  }, [e]), c = F(() => {
    var f;
    if (i != null && i.simpleType)
      return i;
    {
      if (!i)
        return null;
      const w = [];
      for (const P in i.children) {
        const p = i.children[P];
        p != null && p.isComingSoon && w.push(p.id);
      }
      return e.isSubscribeMainVersion && w.length === ((f = i.subversion.versionProductIds) == null ? void 0 : f.length) ? i : a;
    }
  }, [i, a, e.isSubscribeMainVersion]), u = F(() => {
    let f = i == null ? void 0 : i.key;
    return (c == null ? void 0 : c.id) !== (i == null ? void 0 : i.id) && (f = (i == null ? void 0 : i.key) + "-" + (c == null ? void 0 : c.version)), f + "-coming-soon";
  }, [c, i]);
  return c ? /* @__PURE__ */ S("div", { className: "reo-product-subscribe py-50 sm:py-38 leading-1.2", children: [
    /* @__PURE__ */ o("p", { className: "text-center leading-1.2 font-medium text-24 sm:text-20 mb-24 sm:mb-20", children: (m = e.langPack) == null ? void 0 : m["reo-product"].subscribe_title }),
    /* @__PURE__ */ o("div", { className: "subscribe-content", children: /* @__PURE__ */ o(
      Ro,
      {
        placeholder: (v = e.langPack) == null ? void 0 : v["reo-product"].subscribe_placeholder,
        subject: u,
        inputWidth: t >= 540 ? 460 : "100%",
        inputIconName: "icon-icon_email-facet",
        iconColor: "#fff",
        disabledIconColor: "#fff",
        checkboxWrapClassName: "reo-subscription-product",
        country: e.country,
        langPack: e.langPack,
        showTips: !0
      }
    ) }),
    c != null && c.name ? /* @__PURE__ */ S("p", { className: "text-center leading-1.2 text-16 mt-20", children: [
      /* @__PURE__ */ o("span", { className: "text-red-bf3521", children: "* " }),
      (T = (y = e.langPack) == null ? void 0 : y["reo-product"].subscribe_tip) == null ? void 0 : T.replace("$1", c.name)
    ] }) : null,
    (c == null ? void 0 : c.stock.reminder) && /* @__PURE__ */ o(
      wt,
      {
        productsData: [c],
        productKey: c.key,
        boxExclude: ["des", "handle", "image", "tags", "time"],
        tipsAlwaysVisible: !0,
        className: "subscribe-tips-content",
        langPack: e.langPack,
        country: e.country
      }
    ),
    /* @__PURE__ */ o(
      ki,
      {
        className: "popup-recommendations-content",
        ids: s,
        productsData: e.recommendations ?? [],
        langPack: e.langPack,
        country: e.country
      }
    )
  ] }) : null;
}, Lo = (e) => {
  var a;
  const [t, n] = M();
  ne(() => {
    (async () => {
      const s = new Ze(e.productsData, e.country);
      await s.init(), n(s);
    })().catch(console.error);
  }, [e]);
  const r = F(() => e.productKey ? t == null ? void 0 : t.getProductByKey(e.productKey) : null, [t, e.productKey]), i = F(() => {
    const s = [];
    if (!r)
      return s;
    for (const c of r.subversion.versionProductIds) {
      const u = t == null ? void 0 : t.getProductById(c);
      if (u)
        if (!!(u.isOutOfStock ?? u.isComingSoon)) {
          const v = u.stock.outOfStockRecommendation;
          if (!v)
            s.push(u);
          else {
            const y = t == null ? void 0 : t.getProductById(v.product);
            y ? s.push(y) : s.push(u);
          }
        } else
          s.push(u);
    }
    return s;
  }, [r, t]);
  return !r || r.simpleType ? null : /* @__PURE__ */ S("div", { className: "product-selector", children: [
    /* @__PURE__ */ o("p", { className: "version-title", children: (a = e.langPack) == null ? void 0 : a["reo-product"].version }),
    /* @__PURE__ */ o("div", { className: "selectors-content", children: i.map((s) => {
      var c;
      return /* @__PURE__ */ S(
        "div",
        {
          className: `single-variation relative ${e.currentVariationKey === s.key ? "selected" : ""} ${s.isOutOfStock ? "out-of-stock" : ""}`,
          onClick: () => e.onChange(s.key),
          children: [
            /* @__PURE__ */ S("div", { className: "tag-content", children: [
              /* @__PURE__ */ o(
                wi,
                {
                  productData: s,
                  langPack: e.langPack,
                  country: e.country
                }
              ),
              /* @__PURE__ */ o(
                fi,
                {
                  productsData: [s],
                  productKey: s.key,
                  include: ["pre-order", "discount"],
                  langPack: e.langPack,
                  country: e.country
                }
              )
            ] }),
            /* @__PURE__ */ o("div", { className: "inner", children: /* @__PURE__ */ o(
              wt,
              {
                productsData: [s],
                productKey: s.key,
                boxExclude: ["tags", "time", "tips"],
                panelExclude: ["buttons", "quantity", "selector"],
                useVersionText: !0,
                onlyCombinationImages: !0,
                combinationNoBalloon: !0,
                useExtraName: !((c = r == null ? void 0 : r.children) != null && c[s.id]),
                langPack: e.langPack,
                country: e.country
              }
            ) })
          ]
        },
        s.id
      );
    }) })
  ] });
}, Do = Ie((e) => {
  var i, a;
  const [t, n] = M();
  ne(() => {
    (async () => {
      const s = new Ze(e.bundles, e.country);
      await s.init(), n(s);
    })().catch(console.error);
  }, [e]);
  const r = F(() => t ? t == null ? void 0 : t.productsData.sort(br([
    {
      key: "top",
      order: "desc"
    },
    {
      key: "sort",
      order: "asc"
    }
  ])) : [], [t]);
  return /* @__PURE__ */ S("div", { className: "deals-bundles", children: [
    /* @__PURE__ */ o("div", { className: "top-content", children: /* @__PURE__ */ o(
      qt,
      {
        type: "unset",
        backgroundColor: "transparent",
        borderColor: "transparent",
        toggleGhost: !1,
        color: he() > 1280 ? "#000814" : "#0E6AFF",
        iconPosition: "left",
        icon: "icon-icon_arrow-left",
        iconWidth: "14px",
        iconColor: he() > 1280 ? "#000814" : "#0E6AFF",
        className: "back-to-version",
        onClick: e.onClose,
        children: (i = e.langPack) == null ? void 0 : i["reo-product"].back_to_version
      }
    ) }),
    /* @__PURE__ */ S("div", { className: "bundles-content", children: [
      /* @__PURE__ */ o("p", { className: "bundles-title", children: (a = e.langPack) == null ? void 0 : a["reo-product"].bundles }),
      /* @__PURE__ */ o("ul", { className: "bundles-list", children: r.map((s) => /* @__PURE__ */ o(
        "li",
        {
          className: "bundle-item horizontal-layout is-combination",
          children: /* @__PURE__ */ o(
            wt,
            {
              productsData: [s],
              productKey: s.key,
              featuresQty: 3,
              showFeatures: !0,
              hideDescription: !0,
              hasLink: !0,
              combinePanelAndTips: !0,
              combineShippingAndNote: !0,
              tipsHideIcon: !0,
              isDiscountBtn: !0,
              boxExclude: e.isDistributor ? ["time"] : [],
              langPack: e.langPack,
              country: e.country
            }
          )
        },
        s.id
      )) })
    ] })
  ] });
}), Mo = (e) => {
  const { priceLimited: t, page: n, textAlign: r, textSize: i } = e, [a, s] = M(), [c, u] = M(0), m = F(() => !(!(a != null && a.payLaterMessage.enabled) || t && c < Number(a.payLaterMessage.minPrice)), [c, a, t]), v = V(async () => {
    var T, f;
    document.getElementById("reo-paypal-later") && ((f = (T = ge()) == null ? void 0 : T.paypal) == null || f.Messages({
      amount: c,
      style: {
        layout: "text",
        logo: {
          type: "inline"
        },
        text: {
          align: r,
          size: i
        }
      },
      buyerCountry: a == null ? void 0 : a.buyerCountry
    }).render("#reo-paypal-later"));
  }, [c, a, r, i]), y = V(async () => {
    try {
      await Dn.getPaypalSdk();
      const T = await Dn.getPaypalConfig({
        lite: "1",
        page: n
      });
      s(T), await v();
    } catch (T) {
      console.error(T);
    }
  }, [n, v]);
  return ne(() => {
    y().catch(console.error);
  }, []), ne(() => {
    u(e.amount), v().catch(console.error);
  }, [e.amount, v]), m ? /* @__PURE__ */ o("div", { id: "reo-paypal-later" }) : null;
};
const Fo = Ie((e) => {
  var L, z, W, q, Y, re, K, pe, oe, Ue, Be;
  const t = ae(0), n = ae(null), r = ae(1), i = ae(!1), a = ae(!1), s = ae(0), c = ae(!1), [u, m] = M(he()), [v, y] = M([]), [T, f] = M(""), [w, P] = M(e.bundlesVisible), [p, h] = M(e.bundlesVisible), [b, k] = M(!1), [C, l] = M();
  ne(() => {
    (async () => {
      const G = new Ze(e.productsData, e.country);
      await G.init(), l(G);
    })().catch(console.error);
  }, [e]);
  const _ = F(() => e.productKey ? C == null ? void 0 : C.getProductByKey(e.productKey) : null, [C, e.productKey]);
  ne(() => {
    if (_ && !a.current) {
      const G = e.currentVariationKey ? e.currentVariationKey : _.defaultVariationKey;
      f(G), a.current = !0;
    }
  }, [e, _, C]);
  const d = F(() => (C == null ? void 0 : C.getProductByKey(T)) ?? null, [C, T]), x = F(() => {
    var G;
    return d ? _ != null && _.simpleType ? d.id !== _.id : (G = _ == null ? void 0 : _.subversion) != null && G.versionProductIds ? !_.subversion.versionProductIds.includes(d.id) : !1 : !1;
  }, [d, _]), N = F(() => {
    var de, fe, xe;
    let G = ((de = d == null ? void 0 : d.activities) == null ? void 0 : de.flashSale) ?? [];
    if (x)
      return [];
    if (p && !(_ != null && _.simpleType)) {
      G = {};
      let ee = !1;
      for (const Te in _ == null ? void 0 : _.children) {
        const be = C == null ? void 0 : C.getProductById(Number(Te));
        be && !(((fe = be.activities) == null ? void 0 : fe.flashSale) instanceof Array) && (ee = !0, Object.assign(G, (xe = be.activities) == null ? void 0 : xe.flashSale));
      }
      ee || (G = []);
    }
    return G instanceof Array ? [] : Object.values(G);
  }, [p, d, x, C, _]), I = V(() => {
    h(!1), P(!0);
  }, []), B = F(() => e.country !== "US" ? !1 : e.hasAmzPrimeBtn ?? !1, [e.country, e.hasAmzPrimeBtn]), ie = F(() => d ? /* @__PURE__ */ o("div", { className: "reo-bwp-button reo-product-btn", children: /* @__PURE__ */ o(
    "div",
    {
      id: "amzn-buy-now",
      "data-site-id": "y2jtbok0jb",
      "data-widget-id": "w-GMPQu2iX3KacjtDqevhAI9",
      "data-sku": d.key
    }
  ) }) : null, [d]);
  ne(() => {
    (async () => {
      B && !c.current && (await Cr("https://code.buywithprime.amazon.com/bwp.v1.js", { fetchpriority: "high" }), c.current = !0);
    })().catch(console.error);
  }, [B]);
  const X = V((G) => {
    var xe;
    if (!d)
      return;
    const de = v.findIndex((ee) => ee.key === d.key), fe = v;
    fe[de].qty = G, y([...fe]), r.current = G, (xe = window.bwp) == null || xe.updateWidget(d.key, G);
  }, [d, v]), se = V((G) => {
    var xe, ee, Te;
    if (!d)
      return;
    let de = v.filter((be) => be.key === d.key);
    d.isInSale || d.isPreOrder || (G.length ? de = [] : de.push({
      id: d.id,
      key: d.key,
      qty: 1,
      price: d.price.regularPrice,
      regularPrice: d.price.regularPrice,
      category: ((xe = d.categories[0]) == null ? void 0 : xe.key) ?? "",
      mainId: ((ee = d.parent) == null ? void 0 : ee.id) ?? d.id,
      mainKey: ((Te = d.parent) == null ? void 0 : Te.key) ?? d.key
    }));
    const fe = G.map((be) => {
      var De, Ee, Oe;
      return {
        id: be.id,
        key: be.key,
        qty: 1,
        price: be.price.currentPrice,
        regularPrice: be.price.regularPrice,
        category: ((De = be.categories[0]) == null ? void 0 : De.key) ?? "",
        mainId: ((Ee = be.parent) == null ? void 0 : Ee.id) ?? be.id,
        mainKey: ((Oe = be.parent) == null ? void 0 : Oe.key) ?? be.key
      };
    });
    y([...de, ...fe]);
  }, [d, v]), Q = F(() => !!v.filter((G) => G.key !== (d == null ? void 0 : d.key)).length, [v, d]), ve = F(() => !!(d != null && d.isInSale || d != null && d.isPreOrder || Q), [d, Q]), ye = V((G) => {
    var de;
    f(G), (de = window.bwp) == null || de.updateWidget(G, 1), t.current++;
  }, []), ue = F(() => v.reduce((G, de) => G + Number(de.regularPrice) * de.qty, 0), [v]), _e = F(() => v.reduce((G, de) => G + Number(de.price) * de.qty, 0), [v]), E = F(() => {
    if (s.current !== _e)
      return s.current = _e, /* @__PURE__ */ o(
        Mo,
        {
          amount: ve ? _e : 0,
          priceLimited: !0,
          textAlign: he() > 768 ? "right" : "left",
          textSize: he() > 768 ? 16 : 14
        }
      );
  }, [ve, _e]), $ = V(() => {
    var be, De, Ee, Oe, Le;
    const G = (be = document.getElementsByClassName("reo-variation-inner")) == null ? void 0 : be[0], de = (De = document.getElementsByClassName("version-details")) == null ? void 0 : De[0], fe = (Ee = document.getElementsByClassName("other-details")) == null ? void 0 : Ee[0], xe = (Oe = document.getElementsByClassName("reo-variation-top")) == null ? void 0 : Oe[0], ee = (Le = document.getElementsByClassName("reo-variation-bottom")) == null ? void 0 : Le[0];
    if (!G || !de || !fe)
      return;
    const Te = ee ? ee.clientHeight + 20 : 0;
    if (G.setAttribute("style", `padding-bottom: ${Te}px`), he() > 1280) {
      const We = G.scrollTop ?? 0, je = G.getBoundingClientRect().left + "px", Ve = getComputedStyle(G).marginRight, tt = de.clientHeight ?? 0, Ye = fe.clientHeight ?? 0, A = (xe == null ? void 0 : xe.clientHeight) ?? 0, te = (G.clientHeight ?? 0) - A - Te;
      if (tt < te && Ye < te) {
        de.setAttribute("style", "position: unset"), fe.setAttribute("style", "position: unset");
        return;
      } else if (tt > te && Ye > te) {
        let we, Me, Fe;
        tt > Ye ? (we = fe, Me = "right", Fe = Ve, de.setAttribute("style", "position: unset")) : (we = de, Me = "left", Fe = je, fe.setAttribute("style", "position: unset")), we && (We > Number(we.clientHeight) - te ? we.setAttribute("style", `position: fixed; top: unset; bottom: ${Te}px; ${Me}: ${Fe}`) : we.setAttribute("style", "position: unset"));
      } else {
        let we, Me, Fe;
        tt > Ye ? (we = fe, Me = "right", Fe = Ve, de.setAttribute("style", "position: unset")) : (we = de, Me = "left", Fe = je, fe.setAttribute("style", "position: unset")), we && we.setAttribute("style", `position: fixed; top: ${A}px; bottom: unset; ${Me}: ${Fe}`);
      }
    } else
      de.setAttribute("style", "position: unset"), fe.setAttribute("style", "position: unset");
  }, []), ce = V(() => {
    P(!1), h(!1);
  }, []);
  ne(() => {
    var de, fe, xe;
    const G = [];
    d && (G.push({
      id: d.id,
      key: d.key,
      qty: 1,
      price: d.isInSale || d.isPreOrder ? d.price.currentPrice : d.price.regularPrice,
      regularPrice: d.price.regularPrice,
      category: ((de = d.categories[0]) == null ? void 0 : de.key) ?? "",
      mainId: ((fe = d.parent) == null ? void 0 : fe.id) ?? d.id,
      mainKey: ((xe = d.parent) == null ? void 0 : xe.key) ?? d.key
    }), d.price.isPriceGuaranteed ? k(!0) : k(!1)), y([...G]), r.current = 1;
  }, [d]), ne(() => {
    $();
  }, [$, T]);
  const Z = V(() => {
    m(he()), $();
  }, [$]);
  ne(() => {
    $();
    const G = n.current;
    return G && !i.current && (i.current = !0, G == null || G.addEventListener("scroll", $)), window.addEventListener("resize", Z), () => {
      G == null || G.removeEventListener("scroll", $), window.removeEventListener("resize", Z);
    };
  }, [$, Z]);
  const R = F(() => {
    const G = v.map((fe) => ({
      id: fe.id,
      number: fe.qty,
      category: fe.category,
      mainId: fe.mainId,
      mainKey: fe.mainKey,
      price: fe.price
    })), de = d != null && d.isInSale || d != null && d.isPreOrder ? d.id : void 0;
    return {
      products: G,
      recommendation: de
    };
  }, [v, d]), O = V(() => {
    St.emit("clearSelected");
  }, []);
  return /* @__PURE__ */ S(ke, { children: [
    /* @__PURE__ */ S("div", { className: "reo-variation-popup", children: [
      /* @__PURE__ */ o(
        "div",
        {
          className: "reo-variation-inner",
          ref: n,
          children: _ && d ? /* @__PURE__ */ S(ke, { children: [
            u <= 1280 && /* @__PURE__ */ o(
              fn,
              {
                productData: _,
                hideDescription: !e.hasDescriptions,
                showFeatures: e.hasDescriptions ?? !1,
                hasExtraLink: e.hasDescriptions ?? !1,
                langPack: e.langPack,
                country: e.country
              }
            ),
            /* @__PURE__ */ S("div", { className: "version-details", children: [
              b && /* @__PURE__ */ o("div", { className: "low-price-img", children: /* @__PURE__ */ o("img", { src: Tt("/wp-content/assets/low-price.png") }) }),
              /* @__PURE__ */ o(
                wt,
                {
                  productsData: (C == null ? void 0 : C.productsData) ?? [],
                  productKey: d.key,
                  panelExclude: ["selector", "quantity", "buttons"],
                  boxExclude: _.simpleType ? [] : ["time", "tags"],
                  hasLink: x,
                  useVariationName: !0,
                  has3DPreview: !0,
                  onlyCombinationImages: !0,
                  useExtraName: x,
                  hasExtraTip: x,
                  country: e.country,
                  isDistributor: e.isDistributor,
                  langPack: e.langPack
                }
              )
            ] }),
            /* @__PURE__ */ S("div", { className: "other-details", children: [
              u > 1280 && /* @__PURE__ */ o(
                fn,
                {
                  productData: _,
                  hideDescription: !e.hasDescriptions,
                  showFeatures: e.hasDescriptions ?? !1,
                  hasExtraLink: e.hasDescriptions ?? !1,
                  langPack: e.langPack,
                  country: e.country
                }
              ),
              /* @__PURE__ */ o(
                Lo,
                {
                  productsData: (C == null ? void 0 : C.productsData) ?? [],
                  productKey: _.key,
                  currentVariationKey: d.key,
                  country: e.country,
                  isDistributor: e.isDistributor,
                  langPack: e.langPack,
                  onChange: ye
                }
              ),
              N.length ? /* @__PURE__ */ o(
                qt,
                {
                  type: "unset",
                  color: "#0E6AFF",
                  icon: "icon-icon_arrow-right",
                  backgroundColor: "transparent",
                  borderColor: "transparent",
                  iconPosition: "right",
                  iconWidth: "14px",
                  iconColor: "#0E6AFF",
                  className: "view-bundles",
                  toggleGhost: !1,
                  onClick: I,
                  children: (L = e.langPack) == null ? void 0 : L["reo-product"]["view-bundles"]
                }
              ) : null,
              (d.isInSale || d.isPreOrder) && /* @__PURE__ */ S("div", { className: "reo-quantity-content", children: [
                /* @__PURE__ */ S(
                  "div",
                  {
                    className: "quantity-title-wrapper",
                    children: [
                      /* @__PURE__ */ o("p", { className: "quantity-title", children: (z = e.langPack) == null ? void 0 : z["reo-product"].quantity }),
                      (W = d.salesLimitation) != null && W.salesLimited ? /* @__PURE__ */ o("p", { className: "reo-sales-limitation", children: (Y = (q = e.langPack) == null ? void 0 : q["reo-product"]["sales-limitation"]) == null ? void 0 : Y.replace(
                        "{}",
                        d.salesLimitation.details.limitQuantity
                      ) }) : null
                    ]
                  }
                ),
                /* @__PURE__ */ S("div", { className: "reo-quantity-controller-wrapper", children: [
                  /* @__PURE__ */ o(
                    Vi,
                    {
                      value: r.current,
                      onChange: (G) => X(G),
                      minValue: 1,
                      float: !1,
                      bordered: !0,
                      className: "reo-quantity-controller"
                    }
                  ),
                  (re = d.salesLimitation) != null && re.salesLimited ? /* @__PURE__ */ o("p", { className: "reo-sales-limitation", children: (pe = (K = e.langPack) == null ? void 0 : K["reo-product"]["sales-limitation"]) == null ? void 0 : pe.replace(
                    "{}",
                    d.salesLimitation.details.limitQuantity
                  ) }) : null
                ] })
              ] }),
              d.isRefurbished && /* @__PURE__ */ o(
                gn,
                {
                  href: It("/refurbished-products/"),
                  target: "_blank",
                  icon: "icon-icon_arrow-right",
                  className: "refurbished-tip",
                  fontSize: "14px",
                  children: (oe = e.langPack) == null ? void 0 : oe["reo-product"]["refurbished-tip"]
                }
              ),
              (Ue = d.companions) != null && Ue.length ? /* @__PURE__ */ o(
                la,
                {
                  list: d.companions,
                  productsData: (C == null ? void 0 : C.productsData) ?? [],
                  langPack: e.langPack,
                  country: e.country,
                  isDistributor: e.isDistributor,
                  onPurchase: se
                },
                t.current
              ) : null,
              he() <= 768 ? E : null
            ] })
          ] }) : null
        }
      ),
      he() > 1280 && /* @__PURE__ */ o("div", { className: "reo-variation-top", children: /* @__PURE__ */ o("div", { className: "top-inner", children: /* @__PURE__ */ o(
        qt,
        {
          type: "unset",
          size: "medium",
          color: "#000814",
          backgroundColor: "transparent",
          borderColor: "transparent",
          iconPosition: "left",
          icon: "icon-icon_arrow-left",
          iconWidth: "14px",
          iconColor: "#000814",
          className: "back-to-overview",
          toggleGhost: !1,
          onClick: () => {
            et.hidePopup("hideVariationContent");
          },
          children: (Be = e.langPack) == null ? void 0 : Be["reo-product"].back_to_overview
        }
      ) }) }),
      /* @__PURE__ */ o("div", { className: "reo-variation-bottom", children: /* @__PURE__ */ o("div", { className: "bottom-inner", children: d ? /* @__PURE__ */ S(ke, { children: [
        he() >= 768 ? E : null,
        /* @__PURE__ */ S("div", { className: `reo-and-amz ${B ? "has-bwp-btn" : ""}`, children: [
          /* @__PURE__ */ S("div", { className: "price-and-buttons", children: [
            /* @__PURE__ */ S("div", { className: "price-content", children: [
              _e ? /* @__PURE__ */ o("span", { className: "sale-price", children: d.currency.symbol.replace(
                "{}",
                _e.toFixed(d.currency.precision)
              ) }) : null,
              _e < ue ? /* @__PURE__ */ o("del", { className: "pre-price", children: d.currency.symbol.replace(
                "{}",
                ue.toFixed(d.currency.precision)
              ) }) : null
            ] }),
            /* @__PURE__ */ o("div", { className: "button-content", children: /* @__PURE__ */ o(
              Pi,
              {
                productsData: [d],
                productKey: d.key,
                exclude: ["price", "quantity", "selector"],
                buttonSize: u < 1280 ? "medium" : "large",
                externalProsToPurchase: R,
                afterAddToCart: O,
                alwaysCanPurchase: Q,
                hasBuyNowBtn: !0,
                country: e.country,
                isDistributor: e.isDistributor,
                langPack: e.langPack
              }
            ) })
          ] }),
          ie
        ] })
      ] }) : null }) }),
      w && /* @__PURE__ */ o(
        Do,
        {
          bundles: N,
          isDistributor: e.isDistributor,
          langPack: e.langPack,
          country: e.country,
          onClose: ce
        }
      )
    ] }),
    !(he() > 1280) && /* @__PURE__ */ o(
      "span",
      {
        className: "absolute top-0 right-0 transform -translate-y-1/2 rounded-full w-32 h-32 bg-black-opacity-70 flex items-center justify-center cursor-pointer z-1",
        onClick: () => {
          et.hidePopup("hideVariationContent");
        },
        children: /* @__PURE__ */ o(
          ot,
          {
            name: "icon-cross2",
            width: "12px",
            color: "#fff"
          }
        )
      }
    )
  ] });
});
class Bo {
  constructor() {
    this._productEvent = new Ct(), this._productPopup = () => {
      const [t, n] = M(""), [r, i] = M(""), [a, s] = M(""), [c, u] = M(!1), [m, v] = M([]), [y, T] = M([]), [f, w] = M(""), [P, p] = M(!1), [h, b] = M(!1), [k, C] = M(!1), [l, _] = M(!1), [d, x] = M(), [N, I] = M(null), [B, ie] = M(""), [X, se] = M(""), [Q, ve] = M(null), [ye, ue] = M(""), [_e, E] = M(""), [$, ce] = M(""), [Z, R] = M(""), [O, L] = M(!1), [z, W] = M(null), q = V(() => {
        z && z(), n(""), w("");
      }, [z]);
      ne(() => {
        this._productEvent.on("showPopup", (oe) => {
          s(oe.errorTitle ?? ""), i(oe.errorDes ?? ""), v(oe.combinations ?? []), T(oe.recommendations ?? []), p(oe.isSubscribeMainVersion ?? !1), W(oe.onClose ?? null), ve(oe.productsData ?? null), ue(oe.productKey ?? ""), E(oe.currentVariationKey ?? ""), x(oe.langPack), ce(oe.className ?? ""), R(oe.country ?? "US"), L(oe.isDistributor ?? !1), W(oe.onClose ?? null), oe.type && n(oe.type);
        }), this._productEvent.on("hideHandledResult", () => {
          q();
        }), this._productEvent.on("showVariationContent", (oe) => {
          var de, fe;
          const Be = (oe.productsData ? oe.productsData instanceof Array ? oe.productsData : Object.values(oe.productsData) : []).find((xe) => xe.key === oe.productKey), G = (fe = (de = Be == null ? void 0 : Be.uiData) == null ? void 0 : de.referrals) == null ? void 0 : fe[0];
          if (G) {
            window.location.href = G.link;
            return;
          }
          u(!0), I(oe.productsData ?? null), ie(oe.productKey ?? ""), se(oe.currentVariationKey ?? ""), x(oe.langPack), b(oe.showBundles ?? !1), C(oe.hasDescriptions ?? !1), R(oe.country ?? "US"), L(oe.isDistributor ?? !1), _(oe.hasAmzPrimeBtn ?? !1);
        }), this._productEvent.on("hideVariationContent", () => {
          u(!1), window.bwpCartScriptLoadedOn = "";
        }), this._productEvent.on("updateProductData", (oe) => {
          I(oe ?? null);
        });
      }, [q]);
      const Y = F(() => t === "addToCartSuccess" ? /* @__PURE__ */ o(
        Eo,
        {
          combinations: m,
          recommendations: y,
          langPack: d ?? {},
          country: Z,
          onClose: q
        }
      ) : t === "addToCartFailed" ? /* @__PURE__ */ o(
        Ao,
        {
          errorTitle: a,
          errorDes: r,
          onClose: q,
          langPack: d ?? {}
        }
      ) : t === "subscribeContent" ? /* @__PURE__ */ o(
        Oo,
        {
          productsData: Q ?? [],
          productKey: ye,
          currentVariationKey: _e,
          recommendations: y,
          isSubscribeMainVersion: P,
          langPack: d ?? {},
          country: Z
        }
      ) : null, [q, m, Z, r, a, P, d, t, y, _e, ye, Q]), re = F(() => Y ? /* @__PURE__ */ S(
        Nt,
        {
          mask: !0,
          onClose: q,
          center: t === "addToCartFailed" || !(m.length || y.length),
          class: "text-center min-w-540 sm:min-w-auto max-w-1200 text-0 px-40 sm:px-20 " + f + " " + $,
          children: [
            Y,
            /* @__PURE__ */ o(
              "span",
              {
                className: "absolute top-0 right-0 transform -translate-y-1/2 rounded-full w-32 h-32 bg-black-opacity-70 flex items-center justify-center cursor-pointer",
                onClick: q,
                children: /* @__PURE__ */ o(
                  ot,
                  {
                    name: "icon-cross2",
                    width: "12px",
                    color: "#fff"
                  }
                )
              }
            )
          ]
        }
      ) : null, [q, m, t, Y, f, $, y]), K = F(() => c ? /* @__PURE__ */ o(
        Nt,
        {
          mask: !0,
          pcAnimation: he() > 1280,
          mobileAnimation: he() <= 1280,
          onClose: () => {
            this._productEvent.emit("hideVariationContent");
          },
          children: /* @__PURE__ */ o(
            Fo,
            {
              productsData: N ?? [],
              productKey: B,
              currentVariationKey: X,
              bundlesVisible: h,
              hasDescriptions: k,
              hasAmzPrimeBtn: l,
              country: Z,
              isDistributor: O,
              langPack: d ?? {}
            }
          )
        }
      ) : null, [h, Z, X, l, k, O, d, B, N, c]), pe = V(() => {
        m.length ? he() > 725 ? w("w-665") : he() > 580 ? w("w-calc-full-60") : w("w-calc-full-40") : y.length ? he() > 1280 ? w("w-1200") : he() > 768 ? w("w-calc-full-60") : w("w-calc-full-40") : he() > 580 ? w("w-540") : w("w-calc-full-40");
      }, [m, y]);
      return ne(() => (pe(), window.addEventListener("resize", pe), () => {
        window.removeEventListener("resize", pe);
      }), [pe]), ne(() => {
        t !== "" || c ? _n() : t === "" && !c && Cn();
      }, [t, c]), /* @__PURE__ */ S(ke, { children: [
        re,
        K
      ] });
    }, this.inited = !1;
  }
  init() {
    var r;
    if (this.inited)
      return;
    const t = (r = ge()) == null ? void 0 : r.document;
    if (!t)
      return;
    let n = t.getElementById("__reo-product-popup__");
    n || (n = t.createElement("div"), n.id = "__reo-product-popup__", t.body.appendChild(n)), this._reoProductPopup || (this._reoProductPopup = zi.createRoot(n)), this._reoProductPopup.render(/* @__PURE__ */ o(this._productPopup, {})), this.inited = !0;
  }
  showPopup(t, n) {
    let r;
    t === "variationContent" ? r = "showVariationContent" : r = "showPopup", this._productEvent.emit(r, n);
  }
  hidePopup(t) {
    this._productEvent.emit(t);
  }
  updatePopupProductData(t) {
    this._productEvent.emit("updateProductData", t);
  }
}
const Vo = new Bo(), et = Vo, $o = {
  axis: "horizontal",
  autoPlay: !1,
  infiniteLoop: !0,
  showArrows: !0,
  swipeable: !1
}, ei = (e) => {
  var k, C, l, _;
  const t = V((d) => {
    const x = {};
    if (!(d != null && d.profile))
      return [];
    for (const N of d.profile.products) {
      const I = N.category, B = x[I.id] ?? {
        category: I.title,
        sort: I.sort,
        products: []
      };
      N.href !== "" ? B.products.push(/* @__PURE__ */ o(
        "a",
        {
          href: N.href,
          target: "_blank",
          className: "mb-8 inline-block design-for-product",
          rel: "noreferrer",
          children: N.name
        },
        `link-${Math.random().toString(36).slice(-6)}`
      )) : B.products.push(/* @__PURE__ */ o(
        "span",
        {
          className: "mb-8 inline-block text-gray-3",
          children: N.name
        },
        `link-${Math.random().toString(36).slice(-6)}`
      )), x[I.id] = B;
    }
    return Object.values(x).sort((N, I) => N.sort - I.sort);
  }, []), n = ae(e.productData), [r, i] = M(""), [a, s] = M(null), c = ae(t(n.current)), u = bn(), m = ae(null), v = ae(null), [y, T] = M(!1), [f, w] = M(!1), [P, p] = M(), h = V((d, x) => {
    var ie;
    const N = () => d.profile ? d.profile.images.map((se, Q) => /* @__PURE__ */ o(
      "img",
      {
        src: se,
        className: `w-full h-full ${Q > 0 ? "ml-4" : ""}`
      },
      `img-${Q}`
    )) : [], I = (ie = d.profile) == null ? void 0 : ie.images.map((X, se) => /* @__PURE__ */ o(it, { children: /* @__PURE__ */ o("img", { src: X }) }, `carousel-item-${se}`));
    return {
      carouselProps: {
        ...$o,
        thumbWidth: 54,
        showThumbs: x === "pc",
        thumbClassName: {
          thumbClassName: "overflow-hidden",
          thumbItemClassName: "myItem"
        },
        renderThumbs: N,
        showIndicators: x !== "pc",
        swipeable: x !== "pc",
        showArrows: x === "pc",
        isHoverArrow: !1
      },
      carouselPics: I
    };
  }, []);
  ne(() => {
    var x, N;
    const d = (N = (x = n.current) == null ? void 0 : x.profile) == null ? void 0 : N.images;
    if (d)
      if (d.length > 1) {
        const { carouselProps: I, carouselPics: B } = h(n.current, u);
        p(I), s(B);
      } else
        i(d[0]);
  }, [u, h]);
  const b = V(() => {
    T(!y);
  }, [y]);
  return ne(() => {
    if (m.current) {
      const d = m.current.offsetHeight;
      if (d && d >= 100) {
        w(!0);
        return;
      }
    }
    w(!1);
  }, []), n.current ? /* @__PURE__ */ S(
    "div",
    {
      className: "product-popup-inner",
      children: [
        a ? /* @__PURE__ */ o(mt, { ...P, children: a }) : "",
        r ? /* @__PURE__ */ o(
          "img",
          {
            className: "w-full acc-item",
            src: r
          }
        ) : "",
        /* @__PURE__ */ S("div", { children: [
          /* @__PURE__ */ o("p", { className: "product-name", children: n.current.name }),
          (k = n.current.profile) != null && k.longDesc ? /* @__PURE__ */ o(
            "p",
            {
              className: "long-des",
              dangerouslySetInnerHTML: { __html: n.current.profile.longDesc }
            }
          ) : "",
          c.current.length > 0 ? /* @__PURE__ */ S("div", { className: "mb-32 overflow-hidden relative", children: [
            /* @__PURE__ */ o("p", { className: "design-for-title", children: (C = e.langPack) == null ? void 0 : C["reo-product"].designfor }),
            /* @__PURE__ */ o(
              "div",
              {
                ref: m,
                className: "design-for-container bg-gray-f7f8f9 overflow-hidden",
                style: { maxHeight: y ? "unset" : "100px" },
                children: c.current.map((d, x) => /* @__PURE__ */ S(
                  "div",
                  {
                    className: "category-content",
                    children: [
                      /* @__PURE__ */ o("span", { className: "category-title", children: d.category }),
                      /* @__PURE__ */ o("div", { className: "products-list", children: d.products })
                    ]
                  },
                  x
                ))
              }
            ),
            f ? /* @__PURE__ */ S(
              "div",
              {
                ref: v,
                className: "design-for-cover",
                onClick: b,
                children: [
                  /* @__PURE__ */ o("span", { children: (l = e.langPack) == null ? void 0 : l["reo-product"][y ? "show-less" : "show-more"] }),
                  /* @__PURE__ */ o(
                    ot,
                    {
                      name: y ? "icon-icon_arrow-up" : "icon-icon_arrow-down",
                      width: "12"
                    }
                  )
                ]
              }
            ) : null
          ] }) : "",
          (_ = n.current.profile) != null && _.note ? /* @__PURE__ */ o(
            "div",
            {
              className: "pb-12 mb-24 border-b-1 border-t-0 border-l-0 border-r-0 border-solid border-gray-d text-14 leading-1.4",
              dangerouslySetInnerHTML: { __html: n.current.profile.note }
            }
          ) : ""
        ] }),
        /* @__PURE__ */ o("div", { className: "reo-accessory-container mb-12 sm:mb-8", children: /* @__PURE__ */ o(
          wt,
          {
            productsData: [n.current],
            productKey: n.current.key,
            useAccessoryVariation: !0,
            boxExclude: ["des", "image", "tags", "time"],
            langPack: e.langPack,
            country: e.country
          }
        ) })
      ]
    },
    n.current.key
  ) : null;
}, Si = j.createContext({
  setValue: () => {
  },
  setIsVerified: () => {
  },
  formEventBus: new Ct()
});
var Jt = /* @__PURE__ */ ((e) => (e.FORM_SUBMIT = "FORM_SUBMIT", e))(Jt || {});
const ti = (e) => Array.isArray(e) && e.length <= 0 ? !0 : e === void 0 || e === "" || e === null;
function Ko() {
  return document.cookie.includes("cs_2s");
}
const gt = (e) => {
  const { setValue: t, setIsVerified: n, formEventBus: r } = j.useContext(Si), i = j.useContext(Pn), a = e.validFC, [s, c] = j.useState(""), [u, m] = j.useState(!1), [v, y] = j.useState(), [T, f] = j.useState(!1), w = j.useRef(), P = j.useCallback((k) => {
    var C;
    return ((C = i["contact-sales-form"]) == null ? void 0 : C[k]) ?? "";
  }, [i]), p = j.useCallback((k, C) => {
    m(!k), n(e.name, k), c(k ? "" : C ?? P("common-error"));
  }, [P, e.name, n]), h = j.useCallback((k, C) => {
    if (e.required && ti(k)) {
      p(!1, P("value-required"));
      return;
    }
    if (a) {
      const l = a(k, C);
      typeof l == "string" ? p(!1, l) : p(!!l);
    } else
      p(!0);
  }, [P, e.required, p, a]), b = j.useCallback((k) => {
    y(k), w.current = k, t(e.name, k), h(k, "change");
  }, [e.name, t, h]);
  return j.useEffect(() => {
    e.required && ti(w.current) && n(e.name, !1);
  }, [e.name, e.required, n]), j.useEffect(() => {
    const k = () => {
      h(w.current, "submit");
    };
    return r.on(Jt.FORM_SUBMIT, k), () => {
      r.off(Jt.FORM_SUBMIT, k);
    };
  }, [r, P, e.required, p, h]), /* @__PURE__ */ S(
    "div",
    {
      "data-name": e.name,
      className: `contact-sales-form-item ${e.className}  ${u ? "contact-sales-form-item-error" : ""}`,
      children: [
        e.label ? /* @__PURE__ */ o("label", { className: `contact-sales-form-item-label ${T ? "contact-sales-form-item-label-focus" : ""} ${v ? "contact-sales-form-item-label-fill" : ""}`, children: e.label }) : null,
        j.Children.map(e.children, (k) => j.cloneElement(k, {
          value: v,
          onChange: b,
          className: "contact-sales-form-item-input",
          onFocus: () => {
            f(!0);
          },
          onBlur: () => {
            f(!1);
          }
        })),
        e.required ? /* @__PURE__ */ o("span", { className: "required-dot", children: "*" }) : null,
        s ? /* @__PURE__ */ o("p", { className: "error-tips", children: s }) : null
      ]
    }
  );
};
const Uo = (e) => /* @__PURE__ */ o(
  "textarea",
  {
    className: `contact-sales-textarea ${e.className ?? ""}`,
    onFocus: e.onFocus,
    onBlur: e.onBlur,
    value: e.value,
    onChange: (t) => {
      var n;
      (n = e.onChange) == null || n.call(e, t.target.value);
    }
  }
);
function zo(e, t) {
  const n = e.name.split(".").reverse()[0];
  return t != null && t.length ? t.map(function(r) {
    return r.toLowerCase();
  }).includes(n.toLowerCase()) : !0;
}
const jo = async (e) => await ct.get("storage/uploading/tokens/?no-mobile-redirection=1", e), Wo = async (e) => await ct.post("distributor/support?no-mobile-redirection=1", e);
class Ho {
  constructor(t) {
    this._file = t.file, this._scenes = t.scenes, this._xhr = new XMLHttpRequest(), this._timeout = t.timeout ?? 3e4;
  }
  async startUpload(t) {
    var c, u;
    let n = "";
    this._file.name ? n = this._file.name.split(".").reverse()[0] : n = this._file.type.split("/")[1];
    let r = null;
    try {
      r = await jo({
        type: n,
        vs: Date.now(),
        viaReoAPI: !0,
        scenes: this._scenes
      });
    } catch (m) {
      return console.error(m), Promise.reject({
        status: ((c = m == null ? void 0 : m.result) == null ? void 0 : c.code) ?? -1,
        errorMsg: ((u = m == null ? void 0 : m.result) == null ? void 0 : u.msg) ?? "upload-file-fail"
      });
    }
    const i = new FormData();
    for (const m in r.data.inputs)
      i.append(m, r.data.inputs[m]);
    i.append("file", this._file);
    const a = this._xhr, s = this._timeout;
    return new Promise(function(m, v) {
      a.open("post", r.data.url, !0), a.timeout = s, a.onload = function() {
        var y;
        if (a.status >= 200 && a.status < 300) {
          const T = /(?:Location>)(.+)(?:<\/Location)/.exec(a.response);
          T ? ((y = t.onProcess) == null || y.call(t, 100), m(T[1])) : v({
            status: a.status,
            errorMsg: "upload-file-fail"
          });
        } else
          v({
            status: a.status,
            errorMsg: a.statusText
          });
      }, a.onabort = function() {
        v({
          status: a.status,
          errorMsg: "request_abort"
          /* E_XHR_ERR_ABORT */
        });
      }, a.onerror = function() {
        v({
          status: a.status,
          errorMsg: a.statusText
        });
      }, a.ontimeout = function() {
        v({
          status: a.status,
          errorMsg: "request_timeout"
          /* E_XHR_ERR_TIMEOUT */
        });
      }, t.onProcess && (a.upload.onprogress = function(y) {
        var T;
        if (y.lengthComputable) {
          const f = Number((y.loaded / y.total * 100).toFixed(2));
          (T = t.onProcess) == null || T.call(t, f === 100 ? 99.99 : f);
        }
      }), a.send(i);
    });
  }
}
const qo = j.memo((e) => {
  const [t, n] = j.useState(0), [r, i] = j.useState(!1), a = e.onUploadFinish, s = e.onError, c = j.useRef(!1), u = j.useCallback(async () => {
    if (c.current || e.status === "fail" || e.status === "success")
      return;
    const v = new Ho({
      file: e.file,
      scenes: e.scenes
    });
    try {
      const y = await v.startUpload({
        onProcess(T) {
          n(T);
        }
      });
      a({
        name: e.file.name,
        url: y,
        status: "success"
      }), c.current = !0, i(!0);
    } catch (y) {
      console.error(y), s == null || s({
        name: e.file.name,
        type: (y == null ? void 0 : y.errorMsg) ?? "upload-file-fail"
      });
    }
  }, [s, a, e.file, e.scenes, e.status]), m = () => {
    e.onDelete(e.file.name, r);
  };
  return j.useEffect(() => {
    e.disableAutoUpload || u().catch(console.error);
  }, [e.disableAutoUpload, u]), /* @__PURE__ */ S(
    "li",
    {
      className: `uploaded ${e.errMsg ? "uploaded-error" : ""}`,
      children: [
        /* @__PURE__ */ S("div", { className: "file-list-item-inner", children: [
          e.disableAutoUpload ? null : /* @__PURE__ */ S("span", { className: "reo_file-number-progress", children: [
            t,
            "%"
          ] }),
          /* @__PURE__ */ o("span", { className: "name", children: e.file.name }),
          /* @__PURE__ */ o(
            "span",
            {
              className: "icon-close reo_close-file-item",
              onClick: m
            }
          ),
          /* @__PURE__ */ o("span", { className: "reo_file-progress", children: /* @__PURE__ */ o(
            "span",
            {
              className: `reo_file-progress-cover ${t === 100 ? "reo_file-progress-cover-finish" : ""}`,
              style: { width: `${t}%` }
            }
          ) })
        ] }),
        e.errMsg ? /* @__PURE__ */ o("p", { className: "upload-file-error-tip", children: e.errMsg }) : null
      ]
    }
  );
}), Yo = j.memo((e) => {
  var x;
  const t = e.langPack, n = e.onChange, r = e.maxCount ?? 10, i = e.maxSize ?? 10 * 1024 * 1024, [a, s] = j.useState(e.showAttachButton !== !1), [c, u] = j.useState([]), m = j.useRef([]), v = j.useRef(null), y = j.useRef(0), T = j.useRef(null), f = j.useCallback((N) => (t == null ? void 0 : t[N]) ?? N, [t]), w = j.useCallback((N) => {
    u(N), m.current = N, n == null || n(N);
  }, [n]), P = j.useCallback((N, I, B) => I.get(N.name) ? "file-name-repeated" : B > r ? "file-max-count-error" : zo(N, e.accept) ? e.maxSize && N.size > i ? "file-format-size-error" : "" : "file-format-type-error", [r, i, e.accept, e.maxSize]), p = j.useCallback((N) => {
    const I = new Map(m.current.map((se) => [se.name, !0])), B = [];
    let ie = m.current.length;
    for (const se of N) {
      ie++;
      const Q = P(se, I, ie);
      B.push({
        data: se,
        name: se.name,
        status: Q ? "fail" : "process",
        errMsg: Q ? f(Q) : void 0
      });
    }
    const X = [...m.current, ...B];
    w(X), v.current.value = "";
  }, [P, f, w]), h = j.useCallback((N) => {
    const I = N.target.files;
    I != null && I.length && p(I);
  }, [p]), b = j.useCallback((N) => {
    const I = [...m.current];
    for (const B of I)
      B.name === N.name && (B.status = "success", B.url = N.url);
    w(I);
  }, [w]), k = j.useCallback((N) => {
    const I = [...m.current];
    I.splice(N, 1), w(I);
  }, [w]), C = () => {
    var N;
    (N = v.current) == null || N.click();
  }, l = j.useCallback((N) => {
    const I = [...m.current];
    for (const B of I)
      B.name === N.name && (B.status = "fail", B.errMsg = f(N.type));
    w(I);
  }, [f, w]), _ = (N) => {
    var B;
    y.current = 0, T.current.classList.remove("hover");
    const I = (B = N.dataTransfer) == null ? void 0 : B.files;
    if (!(I != null && I.length))
      return !1;
    p(I), N.preventDefault(), N.stopPropagation();
  }, d = j.useCallback(() => {
    const N = T.current;
    if (!N)
      return;
    const I = () => {
      N.classList.add("focused");
    }, B = () => {
      N.classList.remove("focused");
    }, ie = (Q) => (y.current--, y.current === 0 && N.classList.remove("hover"), Q.stopPropagation(), Q.preventDefault(), !1), X = (Q) => (Q.stopPropagation(), Q.preventDefault(), !1), se = (Q) => (y.current++, Q.stopPropagation(), Q.preventDefault(), N.classList.add("hover"), !1);
    return N.addEventListener("mousedown", I), N.addEventListener("mouseup", B), N.addEventListener("dragleave", ie), N.addEventListener("dragover", X), N.addEventListener("dragenter", se), () => {
      N.removeEventListener("mousedown", I), N.removeEventListener("mouseup", B), N.removeEventListener("dragleave", ie), N.removeEventListener("dragover", X), N.removeEventListener("dragenter", se);
    };
  }, []);
  return j.useEffect(() => {
    const N = a ? void 0 : d();
    return () => {
      N == null || N();
    };
  }, [d, a]), j.useEffect(() => {
    s(e.showAttachButton !== !1);
  }, [e.showAttachButton]), j.useEffect(() => {
    e.value && e.value !== c && u(e.value);
  }, [c, e.value]), /* @__PURE__ */ o("div", { className: "reo-file-select-content", children: a ? /* @__PURE__ */ o(
    "button",
    {
      className: "attach-file-button",
      type: "button",
      onClick: () => {
        s(!1);
      },
      children: f("attach-files-button")
    }
  ) : /* @__PURE__ */ S("div", { className: "reo-file-select", children: [
    /* @__PURE__ */ S(
      "div",
      {
        className: "reo_file-inner",
        onClick: C,
        ref: T,
        onDrop: _,
        children: [
          /* @__PURE__ */ S("p", { children: [
            /* @__PURE__ */ o(st, { name: "icon-attach-file" }),
            /* @__PURE__ */ o("span", { className: "note-text", children: f("select-files-tips") })
          ] }),
          /* @__PURE__ */ o(
            "input",
            {
              ref: v,
              className: "reo_file-input",
              type: "file",
              multiple: !0,
              onChange: h,
              accept: (x = e.accept) == null ? void 0 : x.map((N) => "." + N).join(",")
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ o(
      "p",
      {
        className: "format-text",
        dangerouslySetInnerHTML: {
          __html: f("select-files-rule")
        }
      }
    ),
    /* @__PURE__ */ o("ul", { className: "file-list-content", children: c.map((N, I) => /* @__PURE__ */ o(
      qo,
      {
        file: N.data,
        errMsg: N.errMsg,
        status: N.status,
        lang: e.lang,
        onError: l,
        onUploadFinish: b,
        disableAutoUpload: e.disableAutoUpload,
        scenes: e.scenes ?? "support",
        onDelete: () => {
          k(I);
        }
      },
      N.name
    )) })
  ] }) });
});
const Go = (e) => {
  const [t, n] = j.useState(!1), [r, i] = j.useState([]), a = j.useCallback(async () => {
    var s;
    n(!0);
    try {
      const c = await ar({ lang: e.lang, viaReoAPI: !0 });
      (s = c.data) != null && s.length && i(
        c.data.map((u) => ({
          key: u.code.toLocaleUpperCase(),
          text: u.name
        })).sort((u, m) => u.text.localeCompare(m.text))
      );
    } catch (c) {
      console.error(c);
    } finally {
      n(!1);
    }
  }, [e.lang]);
  return j.useEffect(() => {
    a().catch(console.error);
  }, [a]), /* @__PURE__ */ o("div", { className: e.className, children: /* @__PURE__ */ o(
    hn,
    {
      value: e.value,
      onChange: e.onChange,
      options: r,
      isLoading: t,
      isSearchable: !0,
      width: "100%"
    }
  ) });
};
const Qo = ["txt", "xls", "xlsx", "doc", "docx", "png", "jpg", "svg", "jpeg", "gif", "webp", "bmp", "zip", "rar", "7z", "gz", "tar", "tgz", "bz", "tbz", "mp4", "mkv", "wmv", "mov", "avi"], Xo = j.forwardRef((e, t) => {
  const n = j.useContext(Pn), r = e.onFinish, i = e.onError, [a, s] = j.useState(!1), [c, u] = j.useState([]), m = j.useRef(new Ct()), v = j.useRef(null), y = j.useCallback((l) => {
    var _;
    return ((_ = n["contact-sales-form"]) == null ? void 0 : _[l]) ?? l;
  }, [n]), [T, f] = j.useReducer((l) => l + 1, 0), w = j.useRef({}), P = j.useRef({}), p = j.useCallback(async () => {
    var l, _, d;
    s(!0);
    try {
      const x = w.current;
      await Wo({
        ...x,
        isFromAd: Ko(),
        ...(l = e.partnerData) == null ? void 0 : l.data,
        isFromPartner: !!e.partnerData,
        attachment: ((_ = x.attachment) == null ? void 0 : _.map((N) => ({
          name: N.name,
          url: N.url
        }))) ?? []
      }), r();
    } catch (x) {
      console.error(x), i(y(((d = x == null ? void 0 : x.result) == null ? void 0 : d.msg) ?? "submit-fail-message"));
    } finally {
      s(!1);
    }
  }, [y, i, r, e.partnerData]), h = j.useCallback((l) => {
    var _;
    l.preventDefault(), m.current.emit(Jt.FORM_SUBMIT);
    for (const d in P.current)
      if (!P.current[d]) {
        const x = (_ = v.current) == null ? void 0 : _.querySelector(`[data-name="${d}"]`);
        x == null || x.scrollIntoView({ behavior: "smooth", block: "center" });
        return;
      }
    p().catch(console.error), l.preventDefault();
  }, [p]), b = j.useMemo(() => ({
    setValue: (l, _) => {
      w.current[l] = _;
    },
    setIsVerified: (l, _) => {
      P.current[l] = _;
    },
    formEventBus: m.current
  }), []), k = j.useCallback((l) => ft.Network.isEMailAddress(l ?? "") ? !0 : y("email-error-msg"), [y]), C = j.useCallback((l, _) => {
    if (!(l != null && l.length))
      return !0;
    for (const d of l)
      if (d.status === "fail" || _ === "submit" && d.status === "process")
        return y("file-upload-not-finish");
    return !0;
  }, [y]);
  return j.useImperativeHandle(t, () => ({
    resetFields() {
      w.current = {}, P.current = {}, f();
    }
  }), []), /* @__PURE__ */ o(
    "form",
    {
      className: "contact-sales-form",
      onSubmit: h,
      ref: v,
      children: /* @__PURE__ */ o(
        $i,
        {
          spining: a,
          children: /* @__PURE__ */ S(Si.Provider, { value: b, children: [
            e.partnerData ? null : /* @__PURE__ */ S(ke, { children: [
              /* @__PURE__ */ o(
                gt,
                {
                  label: y("email-label"),
                  name: "email",
                  required: !0,
                  validFC: k,
                  children: /* @__PURE__ */ o(pt, {})
                }
              ),
              /* @__PURE__ */ S("div", { className: "contact-sales-form-item-group", children: [
                /* @__PURE__ */ o(
                  gt,
                  {
                    label: y("country-label"),
                    name: "country",
                    required: !0,
                    children: /* @__PURE__ */ o(Go, { lang: e.lang })
                  }
                ),
                /* @__PURE__ */ o(
                  gt,
                  {
                    label: y("company-label"),
                    name: "company",
                    children: /* @__PURE__ */ o(pt, {})
                  }
                )
              ] })
            ] }),
            /* @__PURE__ */ S("div", { className: "contact-sales-form-item-group", children: [
              /* @__PURE__ */ o(
                gt,
                {
                  label: y("first-name-label"),
                  name: "firstName",
                  required: !0,
                  children: /* @__PURE__ */ o(pt, {})
                }
              ),
              /* @__PURE__ */ o(
                gt,
                {
                  label: y("last-name-label"),
                  name: "lastName",
                  required: !0,
                  children: /* @__PURE__ */ o(pt, {})
                }
              )
            ] }),
            /* @__PURE__ */ o(
              gt,
              {
                label: y("subject-label"),
                name: "subject",
                required: !0,
                children: /* @__PURE__ */ o(pt, {})
              }
            ),
            /* @__PURE__ */ o(
              "p",
              {
                className: "contact-sales-form-tips",
                dangerouslySetInnerHTML: {
                  __html: e.partnerData ? e.partnerData.formTips : y("form-tips")
                }
              }
            ),
            /* @__PURE__ */ o(
              gt,
              {
                label: y("description-label"),
                name: "description",
                required: !0,
                className: "contact-sales-form-item-suggestions",
                children: /* @__PURE__ */ o(Uo, {})
              }
            ),
            /* @__PURE__ */ o(
              gt,
              {
                name: "attachment",
                validFC: C,
                children: /* @__PURE__ */ o(
                  Yo,
                  {
                    maxCount: 10,
                    maxSize: 1024 * 1024 * 10,
                    accept: Qo,
                    langPack: n["contact-sales-form"],
                    lang: e.lang
                  }
                )
              }
            ),
            /* @__PURE__ */ S("div", { className: "contact-sales-policy-notice", children: [
              /* @__PURE__ */ o(
                ri,
                {
                  value: c,
                  options: [{
                    value: "policy-notice"
                  }],
                  onChange: u
                }
              ),
              /* @__PURE__ */ o("span", { className: "required-dot", children: "*" }),
              /* @__PURE__ */ o(
                "p",
                {
                  className: "contact-sales-policy-notice-text",
                  dangerouslySetInnerHTML: {
                    __html: y("policy-notice")
                  }
                }
              )
            ] }),
            /* @__PURE__ */ o(
              Qe,
              {
                disabled: !c.includes("policy-notice"),
                className: Re(
                  "contact-sales-form-submit-button",
                  {
                    "contact-sales-form-submit-button-disabled": !c.includes("policy-notice")
                  }
                ),
                htmlType: "submit",
                children: y("submit-button")
              }
            )
          ] })
        }
      )
    },
    T
  );
});
const Pn = j.createContext({}), Jo = j.memo((e) => {
  const [t, n] = j.useState(!1), [r, i] = j.useState(!1), [a, s] = j.useState(""), c = j.useRef(null), u = j.useCallback((f) => {
    var w;
    return ((w = e.langPack["contact-sales-form"]) == null ? void 0 : w[f]) ?? f;
  }, [e.langPack]), m = j.useCallback(() => {
    var f;
    n(!0), (f = e.onSubmitSuccess) == null || f.call(e);
  }, [e]), v = j.useCallback((f) => {
    s(f), i(!0);
  }, []), y = j.useCallback(() => {
    i(!1);
  }, []), T = j.useCallback(() => {
    var f;
    t && e.onFinish ? e.onFinish() : (f = e.onCancel) == null || f.call(e);
  }, [t, e]);
  return j.useEffect(() => {
    var f;
    e.open && (n(!1), (f = c.current) == null || f.resetFields());
  }, [e.open]), /* @__PURE__ */ S(ke, { children: [
    /* @__PURE__ */ o(
      Rn,
      {
        open: e.open,
        title: u("modal-title"),
        onClose: T,
        titleClassName: "contact-sales-popup-title",
        maskClosable: !1,
        children: /* @__PURE__ */ o(Pn.Provider, { value: e.langPack, children: t ? /* @__PURE__ */ S("div", { className: "contact-sales-popup-submit-success", children: [
          /* @__PURE__ */ o("p", { className: "contact-sales-popup-submit-success-title", children: u("submit-success-title") }),
          /* @__PURE__ */ o(
            xn,
            {
              onClick: T,
              className: "contact-sales-popup-submit-success-button",
              children: u("submit-success-button")
            }
          )
        ] }) : /* @__PURE__ */ o(
          Xo,
          {
            ref: c,
            onFinish: m,
            onError: v,
            lang: e.lang,
            partnerData: e.partnerData
          }
        ) })
      }
    ),
    /* @__PURE__ */ S(
      Rn,
      {
        open: r,
        onClose: y,
        className: "contact-sales-popup-submit-fail",
        children: [
          /* @__PURE__ */ o("p", { className: "contact-sales-popup-submit-fail-title", children: a }),
          /* @__PURE__ */ o(
            xn,
            {
              onClick: y,
              className: "contact-sales-popup-submit-fail-button",
              children: u("submit-fail-button")
            }
          )
        ]
      }
    )
  ] });
}), Zo = Jo, ea = "_willRote_wnhx3_1", yt = {
  "reo-loading-box": "_reo-loading-box_wnhx3_9",
  willRote: ea,
  "reo-loading-box-item": "_reo-loading-box-item_wnhx3_17",
  "reo-loading-notice": "_reo-loading-notice_wnhx3_43"
}, ta = (e) => /* @__PURE__ */ S(ke, { children: [
  /* @__PURE__ */ S("div", { className: yt["reo-loading-box"], children: [
    /* @__PURE__ */ o("div", { className: yt["reo-loading-box-item"] }),
    /* @__PURE__ */ o("div", { className: yt["reo-loading-box-item"] }),
    /* @__PURE__ */ o("div", { className: yt["reo-loading-box-item"] }),
    /* @__PURE__ */ o("div", { className: yt["reo-loading-box-item"] }),
    /* @__PURE__ */ o("div", { className: yt["reo-loading-box-item"] }),
    /* @__PURE__ */ o("div", { className: yt["reo-loading-box-item"] })
  ] }),
  /* @__PURE__ */ o("div", { className: yt["reo-loading-notice"], children: e == null ? void 0 : e.notice })
] });
let cn;
const na = (e) => {
  var Be, G, de, fe, xe;
  const t = ae((Be = e.productData) == null ? void 0 : Be.threeDModel), [n] = M(t.current !== null), r = ae({
    jsLoaded: !1,
    loadingShown: !1,
    renderComplete: !1,
    errFound: !1
  }), i = ae(new Date().getTime() + ""), a = ae(null), s = ae(
    "start"
    /* START */
  ), c = ae(0), u = ae(0), m = ae(0), [v, y] = M(0), [T, f] = M(0), [w, P] = M(""), p = ae(""), h = ae(""), b = ae(""), k = ae(!0), [C, l] = M(!1), [_, d] = M(!1), [x, N] = M(!1), I = ae(!1), B = ae(si()), ie = ae(null), X = ae(!0), se = V(() => document.getElementById(`${i.current}`).getBoundingClientRect().top, []), Q = bn() === "mobile", ve = V(() => {
    const ee = a.current;
    c.current = setInterval(() => {
      s.current === "middle-to-left" && ee.content.rotation.y <= -0.25 ? s.current = "left-to-right" : s.current === "start" ? s.current = "middle-to-left" : s.current === "left-to-right" && ee.content.rotation.y >= 0.25 ? s.current = "right-to-middle" : s.current === "right-to-middle" && ee.content.rotation.y <= 0 && (s.current = "end"), s.current === "left-to-right" ? (ee.content.rotation.y += 0.05, m.current += Q ? 3 : 5, y(m.current), P("all 0.05s linear")) : s.current === "middle-to-left" ? (ee.content.rotation.y -= 0.05, m.current -= Q ? 3 : 5, y(m.current), f(1), P("all 0.05s linear")) : s.current === "right-to-middle" ? (ee.content.rotation.y -= 0.05, m.current -= Q ? 3 : 5, y(m.current), P("all 0.05s linear")) : (clearInterval(c.current), f(0), P("all 0.2s linear"), u.current = setTimeout(() => {
        s.current = "start", m.current = 0, y(m.current), ve();
      }, 5e3));
    }, 150);
  }, [Q]), ye = V((ee) => {
    switch (l(!1), d(!1), N(!1), ee) {
      case "loading":
        l(!0);
        break;
      case "guide":
        d(!0), ve();
        break;
      case "error":
        N(!0);
        break;
      case "none":
        break;
      default:
        console.error("wrong notice name!");
    }
  }, [ve]), ue = V(() => {
    let ee;
    vr(Event) ? ee = new Event("resize") : (ee = document.createEvent("Event"), ee.initEvent("resize", !0, !0)), window.dispatchEvent(ee);
  }, []), { size: _e } = e, E = V((ee) => {
    const Te = a.current;
    Te.camera.position.x = Te.boxSize * ee, Te.camera.position.y = 0, Te.camera.position.z = Te.boxSize * ee;
  }, []), $ = V(() => {
    var ee;
    ye("none"), E(Q ? _e === "small" ? 2 : 2.6 : _e === "small" ? 2.4 : 2.5), requestAnimationFrame(() => {
      a.current.animate();
    }), (ee = document.getElementById(`${i.current + "-reo-threed-core-part"}`)) == null || ee.setAttribute("style", "height: 100%; cursor: pointer"), ue();
  }, [Q, E, ye, ue, _e]), ce = V(() => {
    var Te, be;
    const ee = (be = (Te = document.getElementById(`${i.current}`)) == null ? void 0 : Te.getElementsByTagName("canvas")[0]) == null ? void 0 : be.height;
    if (n && ee === 0 && r.current.renderComplete)
      ue();
    else
      return;
  }, [ue, n]), Z = V(() => (k.current || document.removeEventListener("scroll", Y.current), r.current.errFound ? !1 : (ye("loading"), !0)), [ye]), R = V(() => {
    r.current.loadingShown && Z();
  }, [Z]), O = V(() => {
    r.current.loadingShown && setTimeout(() => {
      I.current || ye("guide");
    }, 1e3);
  }, [ye]), L = V(() => (r.current.renderComplete = !0, r.current.loadingShown ? r.current.errFound ? !1 : ($(), !0) : !0), [$]), z = V((ee = "") => {
    clearInterval(re.current), r.current.errFound = !0, ye("error"), console.error("Error occured during model rendering!"), ee && console.error(ee);
  }, [ye]), W = V(async () => {
    var be, De;
    cn || (cn = (await import("./core-e9a98d65.mjs")).Init3D);
    const Te = {
      el: document.getElementById(`${i.current + "-reo-threed-core-part"}`),
      loadUrl: (be = t.current) == null ? void 0 : be.modelFile,
      hdrEnv: (De = t.current) == null ? void 0 : De.background,
      animateControl: !0,
      isMobile: Q,
      configComplete: R,
      loadComplete: L,
      errorOccured: z,
      animateComplete: O
    };
    try {
      a.current = new cn(Te), a.current.loadModel();
    } catch (Ee) {
      r.current.errFound = !0, z("Load model failed!"), console.error(Ee);
    }
  }, [O, R, z, Q, L]), q = V(async () => {
    const ee = se();
    ee >= 0 && ee <= 2e3 && ee <= 300 && (r.current.loadingShown = !0, Z(), r.current.jsLoaded || W().then(() => {
      r.current.jsLoaded = !0;
    }, console.error));
  }, [W, se, Z]), Y = ae(ft.Optimization.throttle(() => {
    q().catch(console.error);
  }, 500)), re = ae(0), K = ft.Optimization.throttle(ce, 500), pe = V(() => {
    Y.current(), re.current = setInterval(() => {
      K();
    }, 500);
  }, [K]), oe = V(() => {
    if (r.current.errFound)
      return;
    function ee() {
      var be;
      I.current = !0, r.current.renderComplete && (clearInterval(c.current), clearTimeout(u.current), ye("none"), (be = document.getElementById(`${i.current}`)) == null || be.removeEventListener("pointerdown", oe));
    }
    const Te = ie.current;
    Te.addEventListener("pointerup", function() {
      Te.removeEventListener("pointermove", ee);
    }), Te.addEventListener("pointermove", ee);
  }, [ye]);
  _e === "small" ? Q ? (p.current = 'url("' + Tt("/wp-content/assets/2022/09/purchased-3d-background-768-" + B.current + ".jpg") + '")', h.current = "100%", b.current = "260px") : (p.current = 'url("' + Tt("/wp-content/assets/2022/09/purchased-3d-background-1920-" + B.current + ".jpg") + '")', h.current = "540px", b.current = "400px") : _e === "large" && (Q ? (p.current = 'url("' + Tt("/wp-content/assets/2021/09/3d-background-768-" + B.current + ".jpg") + '")', h.current = "100%", b.current = "440px") : (p.current = 'url("' + Tt("/wp-content/assets/2021/09/3d-background-1920-" + B.current + ".jpg") + '")', h.current = "100%", b.current = "640px"));
  const Ue = {
    "--background-image": p.current,
    "--height": b.current,
    "--width": h.current
  };
  return ne(() => {
    ie.current = document.getElementById(`${i.current}`);
  }, []), ne(() => {
    X.current && k.current && n && (_e === "small" && (e != null && e.active) ? (pe(), k.current = !1) : _e === "large" && (document.addEventListener("scroll", Y.current), document.addEventListener("scroll", K), k.current = !1));
  }, [k, e == null ? void 0 : e.active, n, pe, K, _e]), !((G = ge()) != null && G.PointerEvent) && (X.current = !1, _e === "small") ? /* @__PURE__ */ o("div", { children: /* @__PURE__ */ o(
    "section",
    {
      style: Ue,
      className: Re("reo-threed-overview-wrap reo-overview-tab", e.className),
      children: /* @__PURE__ */ o(
        "div",
        {
          id: i.current,
          className: "reo-threed-display-wrap",
          style: { display: "block" },
          children: /* @__PURE__ */ o("div", { className: "reo-render-wrap", children: /* @__PURE__ */ o("div", { className: "reo-three-notice-wrap", children: /* @__PURE__ */ o(
            "div",
            {
              className: "reo-three-error-notice",
              style: { display: "inline-block" },
              children: /* @__PURE__ */ o("span", { className: "reo-three-warning-notice", children: (de = e.langPack) == null ? void 0 : de.threed["threed-warning-notice"] })
            }
          ) }) })
        }
      )
    }
  ) }) : /* @__PURE__ */ o("div", { className: _e === "large" && n ? "reo-threed-spec" : "", children: /* @__PURE__ */ o(
    "section",
    {
      style: Ue,
      className: Re("reo-threed-overview-wrap reo-overview-tab", e.className),
      children: /* @__PURE__ */ S(
        "div",
        {
          id: i.current,
          className: "reo-threed-display-wrap",
          style: { display: n ? "block" : "none" },
          onPointerDown: oe,
          children: [
            /* @__PURE__ */ o(
              "div",
              {
                className: "reo-close-pop",
                style: { display: "none" },
                children: /* @__PURE__ */ o(
                  st,
                  {
                    name: "icon-close",
                    width: "24px"
                  }
                )
              }
            ),
            /* @__PURE__ */ S("div", { className: "reo-render-wrap", children: [
              /* @__PURE__ */ o(
                "div",
                {
                  id: i.current + "-reo-threed-core-part",
                  className: "reo-threed-core-part"
                }
              ),
              /* @__PURE__ */ S("div", { className: "reo-three-notice-wrap", children: [
                /* @__PURE__ */ o(
                  "div",
                  {
                    className: "reo-loading-wrap",
                    style: { display: C ? "inline-block" : "none" },
                    children: /* @__PURE__ */ o(ta, { notice: (fe = e.langPack) == null ? void 0 : fe.threed["threed-loading-notice"] })
                  }
                ),
                /* @__PURE__ */ o(
                  "div",
                  {
                    className: "reo-action-guide",
                    style: { display: _ ? "inline-block" : "none" },
                    children: /* @__PURE__ */ o(
                      "img",
                      {
                        className: "reo-three-arrows",
                        src: "/wp-content/assets/2021/09/image-finger.png",
                        alt: "",
                        style: { transition: w, opacity: T, left: v }
                      }
                    )
                  }
                ),
                /* @__PURE__ */ o(
                  "div",
                  {
                    className: "reo-three-error-notice",
                    style: { display: x ? "inline-block" : "none" },
                    children: /* @__PURE__ */ o("span", { className: "reo-three-warning-notice", children: (xe = e.langPack) == null ? void 0 : xe.threed["threed-warning-notice"] })
                  }
                )
              ] })
            ] })
          ]
        }
      )
    }
  ) });
}, ia = na;
class Sa extends j.Component {
  constructor(t) {
    super(t), this._ref = j.createRef();
  }
  componentDidMount() {
    this._ref.current && ("loading" in HTMLImageElement.prototype ? this._ref.current.setAttribute("src", this._ref.current.getAttribute("data-src")) : Fi(this._ref.current, this._ref.current.getAttribute("data-src")));
  }
  render() {
    return /* @__PURE__ */ o(
      "img",
      {
        loading: "lazy",
        ref: this._ref,
        alt: this.props.alt,
        "data-src": this.props.src,
        width: this.props.width,
        height: this.props.height,
        className: this.props.className
      }
    );
  }
}
const ra = {
  axis: "horizontal",
  autoPlay: !1,
  infiniteLoop: !0,
  showIndicators: !1,
  showArrows: !1,
  swipeable: !1,
  containerClass: "companion-container"
}, oa = (e) => {
  var P, p;
  const t = bn(), n = ft.Env.getGlobalProperty("innerHeight", 0) - 160, [r, i] = M(null);
  ne(() => {
    (async () => {
      const h = new Ze(e.productsData, e.country);
      await h.init(), i(h);
    })().catch(console.error);
  }, [e]);
  const a = F(() => {
    const h = [];
    for (const b of e.ids) {
      const k = r == null ? void 0 : r.getProductById(b);
      k && h.push(k);
    }
    return h;
  }, [r, e]), s = ae(null), [c, u] = M(null), [m, v] = M(!1), y = ae(), T = V(() => {
    const h = document.getElementsByClassName("companion-container")[0];
    h && (h.scrollTop = 0);
  }, []), f = V(() => {
    const h = (k, C, l) => {
      var _;
      return /* @__PURE__ */ o("div", { "aria-label": l, children: /* @__PURE__ */ o(
        Qe,
        {
          size: "large",
          ghost: !0,
          icon: "icon-arrow-right-1",
          iconPosition: "right",
          disabled: C,
          onClick: k,
          children: (_ = e.langPack) == null ? void 0 : _["reo-product"].next
        }
      ) });
    }, b = (k, C, l) => {
      var _;
      return /* @__PURE__ */ o("div", { "aria-label": l, children: /* @__PURE__ */ o(
        Qe,
        {
          size: "large",
          ghost: !0,
          icon: "icon-arrow-left-1",
          iconPosition: "left",
          disabled: C,
          onClick: k,
          children: (_ = e.langPack) == null ? void 0 : _["reo-product"].last
        }
      ) });
    };
    return {
      ...ra,
      selectedItem: e.index,
      customRenderArrowPrev: b,
      customRenderArrowNext: h,
      onChange: T
    };
  }, [e, T]), w = V((h, b) => {
    const k = [];
    for (const C of h)
      k.push(
        /* @__PURE__ */ o(
          "div",
          {
            className: "inner-carousel",
            children: /* @__PURE__ */ o(it, { children: /* @__PURE__ */ o(
              ei,
              {
                productData: C,
                langPack: b,
                country: e.country
              },
              `accessories-item-${C.id}`
            ) }, `carousel-item-${C.id}`)
          },
          `item-${C.id}`
        )
      );
    return k;
  }, [e]);
  return ne(() => {
    if (a.length > 1) {
      const h = w(a, e.langPack);
      u(h), y.current = f();
    } else
      s.current = a[0], s.current && v(!0);
  }, [a, w, f, e]), /* @__PURE__ */ o(
    Nt,
    {
      mask: !0,
      mobileAnimation: !(he() > 768),
      class: "sm:w-full",
      onClose: e.onClose,
      children: /* @__PURE__ */ S(
        "div",
        {
          className: "reo-acc-wrap relative bg-white rounded-12",
          style: { height: t === "pc" ? n + "px" : "100%" },
          children: [
            /* @__PURE__ */ o(
              "div",
              {
                className: "w-32 h-32 rounded-full absolute -top-16 right-0 flex justify-center items-center bg-black-0 bg-opacity-70",
                onClick: e.onClose,
                children: /* @__PURE__ */ o(
                  yn,
                  {
                    name: "icon-cross2",
                    width: 10,
                    color: "#fff"
                  }
                )
              }
            ),
            c ? /* @__PURE__ */ o("div", { className: "reo-acc-popup rounded-12 overflow-hidden", children: /* @__PURE__ */ o(mt, { ...y.current, children: c }) }) : "",
            m ? /* @__PURE__ */ o("div", { className: "reo-acc-popup rounded-12 overflow-hidden", children: /* @__PURE__ */ S("div", { className: "inner-carousel", children: [
              /* @__PURE__ */ S("div", { className: "h-70 flex justify-center items-center", children: [
                /* @__PURE__ */ o(
                  Qe,
                  {
                    size: "large",
                    ghost: !0,
                    icon: "icon-arrow-left-1",
                    iconPosition: "left",
                    disabled: !0,
                    children: (P = e.langPack) == null ? void 0 : P["reo-product"].last
                  }
                ),
                /* @__PURE__ */ o(
                  Qe,
                  {
                    size: "large",
                    ghost: !0,
                    icon: "icon-arrow-right-1",
                    iconPosition: "right",
                    disabled: !0,
                    children: (p = e.langPack) == null ? void 0 : p["reo-product"].next
                  }
                )
              ] }),
              /* @__PURE__ */ o(
                "div",
                {
                  className: "single-acc-item px-40 py-30 overflow-y-auto box-border sm:px-20 sm:py-24",
                  style: { height: t === "pc" ? n - 70 + "px" : "100%" },
                  children: /* @__PURE__ */ o(
                    ei,
                    {
                      productData: s.current,
                      langPack: e.langPack,
                      country: e.country
                    },
                    `accessories-item-${s.current.key}`
                  )
                }
              )
            ] }) }) : ""
          ]
        }
      )
    }
  );
}, aa = (e) => {
  e.showPopup();
}, ni = (e) => {
  let t = [], n = null;
  return e && !e.simpleType ? e.saleVariations && (t = e.saleVariations.map((r) => e.children[r]), n = e.children[e.defaultVariationId] ?? null) : e && (n = e), {
    versions: t,
    defaultProduct: n,
    accessoryProduct: e
  };
}, sa = (e) => {
  var p;
  const t = F(() => e.productData, [e]), n = ae(-1), [r, i] = M(null), [a, s] = M(null), [c, u] = M(!1), [m, v] = M(!1), [y, T] = M([]), f = V((h) => {
    var b;
    (b = t == null ? void 0 : t.saleVariations) != null && b.length ? (i({
      ...t,
      isChecked: h
    }), n.current = a.id, u(h), v(h), e.onSelected(n.current, h), h || (n.current = -1)) : (i({
      ...r,
      isChecked: h
    }), h ? n.current = a.id : n.current = -1, e.onSelected(a.id, h), v(h));
  }, [r, a, e, t]), w = V((h, b) => {
    if (n.current !== b.id) {
      i({
        ...r,
        isChecked: !0
      });
      const { defaultProduct: k } = ni(b);
      if (k) {
        const C = k.price;
        s({
          ...k,
          accPrice: k.currency.symbol.replace("{}", C.currentPrice),
          accRegularPrice: parseFloat(C.regularPrice) > parseFloat(C.currentPrice) ? k.currency.symbol.replace("{}", C.regularPrice) : ""
        });
      }
      n.current !== -1 && e.onSelected(n.current, !1), e.onSelected(b.id, !0), v(!0), n.current = b.id;
    } else
      i({
        ...r,
        isChecked: !1
      }), e.onSelected(n.current, !1), v(!1), u(!1), n.current = -1;
    h.stopPropagation();
  }, [r, e]), P = V(() => {
    if (!t)
      return;
    n.current = -1;
    const {
      versions: h,
      defaultProduct: b,
      accessoryProduct: k
    } = ni(t);
    if (b) {
      const C = b.price;
      s({
        ...b,
        accPrice: b.currency.symbol.replace("{}", C.currentPrice),
        accRegularPrice: parseFloat(C.regularPrice) > parseFloat(C.currentPrice) ? b.currency.symbol.replace("{}", C.regularPrice) : ""
      });
    } else
      s(null);
    i(k ? {
      ...k,
      isChecked: !1
    } : null), T(h), v(!1), u(!1);
  }, [t]);
  return ne(() => (St.on("clearSelectedPurchaseItems", P), () => {
    St.off("clearSelectedPurchaseItems", P);
  }), [P]), ne(() => {
    P();
  }, [P]), /* @__PURE__ */ o(ke, { children: a ? /* @__PURE__ */ S("div", { className: `companion-item py-16 px-20 mb-12 rounded-8 flex sm:px-16 ${n.current !== -1 ? "checked" : ""}`, children: [
    /* @__PURE__ */ o("div", { className: "mt-16 mr-4", children: /* @__PURE__ */ o(
      Ui,
      {
        checked: m,
        onChange: (h) => {
          f(h);
        }
      }
    ) }),
    /* @__PURE__ */ o(
      "img",
      {
        className: "w-48 h-48 mr-12",
        src: a.image.pc
      }
    ),
    /* @__PURE__ */ S(
      "div",
      {
        className: "flex-1",
        onClick: () => {
          f(!(r != null && r.isChecked));
        },
        children: [
          /* @__PURE__ */ o("div", { className: "flex flex-wrap", children: /* @__PURE__ */ S("div", { className: "text-gray-3 text-0", children: [
            /* @__PURE__ */ o("p", { className: "text-16 font-medium leading-1.2", children: r.name }),
            /* @__PURE__ */ S("p", { className: "my-8 leading-1.2 sm:my-6", children: [
              /* @__PURE__ */ o("span", { className: "text-14 mr-12 text-gray-3 font-medium", children: a.accPrice }),
              a.accRegularPrice !== "" ? /* @__PURE__ */ o("del", { className: "text-14 mr-12 text-gray-7", children: a.accRegularPrice }) : ""
            ] }),
            /* @__PURE__ */ o(
              gn,
              {
                transition: !0,
                onClick: () => {
                  aa(e);
                },
                color: "#0E6AFF",
                iconColor: "#0E6AFF",
                fontSize: "14px",
                iconWidth: "9",
                children: (p = e.langPack) == null ? void 0 : p["reo-product"].detail
              }
            )
          ] }) }),
          c ? /* @__PURE__ */ o("div", { className: "acc-version flex flex-wrap border-0 border-t-1 border-solid border-gray-d mt-12", children: y.length ? y.map((h) => {
            var b;
            return /* @__PURE__ */ S(
              "div",
              {
                className: `companion-version px-10 py-6 mr-12 mt-12 bg-opacity-10 rounded-24 cursor-pointer text-12 flex justify-center items-center box-border ${h.id === n.current ? "chosen" : ""}`,
                onClick: (k) => {
                  w(k, h);
                },
                children: [
                  h.color ? /* @__PURE__ */ o(
                    "div",
                    {
                      className: "w-12 h-12 rounded-full mr-6",
                      style: { background: h.color }
                    }
                  ) : "",
                  /* @__PURE__ */ o("p", { className: "leading-none font-medium", children: (b = e.langPack) == null ? void 0 : b["product-versions"][h.version] })
                ]
              },
              `sale-variations-${h.key}`
            );
          }) : "" }) : ""
        ]
      }
    )
  ] }) : "" });
}, ca = (e) => {
  var f;
  const t = ae([]), n = ae([]), [r, i] = M(0), [a, s] = M(!1), [c, u] = M();
  ne(() => {
    (async () => {
      const w = new Ze(e.productsData, e.country);
      await w.init(), u(w);
    })().catch(console.error);
  }, [e]);
  const m = F(() => {
    const w = [];
    for (const P of e.list) {
      const p = c == null ? void 0 : c.getProductById(P);
      p && w.push(p);
    }
    return w;
  }, [c, e]), v = V((w) => {
    w !== void 0 && i(w), s(!a);
  }, [a]), y = V((w, P) => {
    if (P && !t.current.includes("" + w)) {
      const p = c == null ? void 0 : c.getProductById(w);
      p && (t.current.push("" + w), n.current.push(p));
    } else if (!P && t.current.includes("" + w)) {
      const p = t.current.indexOf("" + w);
      t.current.splice(p, 1), n.current.splice(p, 1);
    }
    e.onPurchase(n.current);
  }, [e, c]), T = V(() => {
    t.current = [], n.current = [], St.emit("clearSelectedPurchaseItems"), e.onPurchase(n.current);
  }, [e]);
  return ne(() => (St.on("clearSelected", T), () => {
    St.off("clearSelected", T);
  }), [T]), ne(() => {
    t.current = [], n.current = [];
  }, []), /* @__PURE__ */ o(ke, { children: e.list.length ? /* @__PURE__ */ S("div", { className: "w-full mt-32", children: [
    /* @__PURE__ */ o("p", { className: "mb-20 text-16 text-gray-3 font-bold", children: (f = e.langPack) == null ? void 0 : f["reo-product"].purchasetitle }),
    e.list.map((w, P) => c != null && c.getProductById(w) ? /* @__PURE__ */ o(
      sa,
      {
        productData: c.getProductById(w),
        showPopup: () => {
          v(P);
        },
        onSelected: y,
        langPack: e.langPack,
        country: e.country
      },
      `purchase-accessories-item-${w}`
    ) : null),
    a ? /* @__PURE__ */ o(
      oa,
      {
        onClose: () => {
          v();
        },
        productsData: m,
        ids: e.list,
        index: r,
        langPack: e.langPack,
        country: e.country
      }
    ) : ""
  ] }) : "" });
}, la = ca;
const ua = (e, t, n, r) => {
  const i = ji(e, t);
  return i.on("ready", (a) => {
    var s;
    (s = n.events) != null && s.ready ? n.events.ready(a) : fa(i, n);
  }), i.on("stateChange", (a) => {
    var s;
    (s = n.events) != null && s.stateChange ? n.events.stateChange(a) : da(a, r);
  }), i;
}, da = (e, t) => {
  switch (e.data) {
    case YT.PlayerState.ENDED:
      t.onEnd && t.onEnd(e);
      break;
    case YT.PlayerState.PLAYING:
      t.onPlay && t.onPlay(e);
      break;
    case YT.PlayerState.PAUSED:
      t.onPause && t.onPause(e);
      break;
    case YT.PlayerState.CUED:
      t.onCued && t.onCued();
      break;
  }
}, fa = (e, t) => {
  t.videoId ? e.loadVideoById(t.videoId).catch(console.error) : t.videoIds && e.loadPlaylist(t.videoIds).catch(console.error);
}, ma = (e) => {
  const t = ae(e.options), n = ae({
    videoId: "",
    playerVars: {}
  }), r = ae(null), i = ae(null), a = V(() => {
    n.current.playerVars = {
      rel: 0,
      loop: 1,
      autoplay: 0,
      start: 0,
      end: 0,
      ...t.current.playerVars
    }, t.current.videoId ? n.current.videoId = t.current.videoId : t.current.videoIds && (n.current.playerVars = {
      ...n.current.playerVars,
      playlist: t.current.videoIds.join(",")
    });
  }, []), s = V(() => {
    i.current && t.current.index !== void 0 && i.current.playVideoAt(t.current.index).catch(console.error);
  }, []);
  return ne(() => {
    (t.current.videoId || t.current.videoIds) && r.current && n.current && !i.current && (a(), window.youtubeClass = "reo-youtube", i.current = ua(r.current, n.current, t.current, e)), e.options.index !== void 0 && e.options.index !== t.current.index && (t.current.index = e.options.index, s());
  }, [s, e, a]), /* @__PURE__ */ o(
    "div",
    {
      id: "video-iframe",
      className: "video-iframe",
      ref: r
    }
  );
}, ha = (e) => {
  var i;
  const t = ((i = ge()) == null ? void 0 : i.innerWidth) ?? 0, n = ae(e.options), r = V(() => {
    e.onClose();
  }, [e]);
  return /* @__PURE__ */ S(
    Nt,
    {
      class: "relative flex justify-center items-center " + e.className,
      mask: !0,
      onClose: r,
      children: [
        /* @__PURE__ */ o("div", { className: "absolute z-1 w-60 h-60 loadingWrap " + e.loadingClassName, children: /* @__PURE__ */ o(
          ot,
          {
            name: "icon-icon-loading-2",
            width: "60",
            color: "#fff"
          }
        ) }),
        /* @__PURE__ */ o(
          "div",
          {
            className: "relative z-1 inline-block youtube-video-container " + e.videoClassName,
            id: "youtube-video-container",
            children: /* @__PURE__ */ o(
              "div",
              {
                id: "youtube-video-box",
                className: "youtube-video-box",
                children: /* @__PURE__ */ o(ma, { options: n.current })
              }
            )
          }
        ),
        /* @__PURE__ */ o(
          "div",
          {
            className: "close-icon absolute w-50 h-50 rounded-full bg-black-0 inline-flex justify-center cursor-pointer top-30 right-30  xl:top-40 xl:right-40 sm:w-32 sm:h-32 sm:top-20 sm:right-20 " + e.closeClassName,
            onClick: r,
            children: /* @__PURE__ */ o(
              ot,
              {
                name: "icon-icon-error-4",
                width: t >= 768 ? "20" : "10",
                color: "#fff"
              }
            )
          }
        )
      ]
    }
  );
};
export {
  ei as AccessoriesItem,
  oa as AccessoriesPopup,
  go as BuyAndGift,
  Mo as PaypalLater,
  wt as ProductBox,
  Ze as ProductHub,
  et as ProductPopup,
  fi as ProductTag,
  ki as Recommendations,
  Zo as ReoContactSalesPopup,
  Yo as ReoFileSelectUploader,
  Ro as ReoSubscribe,
  ia as ThreeD,
  di as cartHandler,
  gr as gdpr,
  Er as locale
};
//# sourceMappingURL=index.mjs.map
